// import React, { useState, useEffect, useRef } from "react";
//  import { FaSearch, FaUsers, FaBell,FaUserEdit,FaClipboardCheck, FaProjectDiagram, FaFileAlt, FaEye, FaEdit, FaUser, FaChevronDown, FaPlus, FaUpload, FaTimes, FaStore, FaUserTie, FaTrash, FaFileInvoiceDollar, FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaClipboardList, FaEnvelope, FaSms } from "react-icons/fa";
//   import "./Navbar.css";
//   import CreateReport from "./CreateReport";
//   import Get from "./Get";
//   import AddEmployees from "./AddEmployees";
//   import ManageLeaves from "./ManageLeaves";
//   import AddProject from "./AddProject";
//   import ProjectNavbar from "./ProjectNavbar"; 
//   import ExpenseList from "./Expenses";
//   import ProjectUpdate from "./ProjectUpdate"; 
//   import AddVendor from "./AddVendor";
//   import Client from "./Client";
//   import EditVendor from "./EditVendor";
//   import EditClient from "./EditClient"; 
//   import TaxInvoice from "./TaxInvoice";
//   import UpdateTaxinvoice from "./UpdateTaxinvoice";
//   import Performa from "./Performa";
//   import Invoice from "./Invoice";
//   import { API_URL } from "./API";
//   import PerformaUpdate from "./PerformaUpdate";
//   import ViewTaxInvoice from "./ViewTaxinvoice";
//   import AddEmployeeProject from "./AddEmployeeProject";
//   import ReportSubmission from "./ReportSubmission";

//   const VendorsDisplay = ({ 
//     vendors, 
//     searchQuery, 
//     onSearchChange, 
//     onAddVendor, 
//     onViewVendor,
//     onEditVendor, 
//     onDeleteVendor,
//     selectedVendorStatus,
//     onStatusChange
//   }) => {
//     const filteredVendors = vendors.filter((vendor) => {
//       const vendorName = vendor.vendor_name || '';
//       const gst_no = vendor.gst_no || '';
//       const contact_number = vendor.contact_number || '';
      
//       const matchesSearch = vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             gst_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             contact_number.toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesStatus = selectedVendorStatus ? vendor.status === selectedVendorStatus : true;
      
//       return matchesSearch && matchesStatus;
//     });

//    function hasImage(logo) {
//       if (!logo || typeof logo !== "string") return false;
//       return (
//         logo.startsWith("data:image/") ||
//         logo.startsWith("http://") ||
//         logo.startsWith("https://")
//       );
//     }

//     return (
//       <div>
//         <div className="search-add-section">
//           <div className="search-container">
//             <div className="icon-wrapper"><FaSearch /></div>
//             <div className="Search-bar">
//               <input
//                 type="text"
//                 placeholder=" Search Vendor Details"
//                 value={searchQuery}
//                 onChange={(e) => onSearchChange(e.target.value)}
//               />
//             </div>
//           </div>
//           <div className="status-filter-container">
//             <select 
//     value={selectedVendorStatus} 
//     onChange={(e) => onStatusChange(e.target.value)}
//     className="status-filter-dropdown"
//   >
//     <option value="Active">Active</option>
//     <option value="Inactive">Inactive</option>
//   </select>
//           </div>
//           <div className="add-button-container">
//             <button className="add-button" onClick={onAddVendor}>
//               <FaPlus className="add-icon" />
//               Add Vendor
//             </button>
//           </div>
//         </div>
//         <section className="data-container">
//           <div className="header-row1">
//             <div className="column1"><span>Vendor Name</span></div>
//             <div className="column1"><span>GST NO</span></div>
//             <div className="column1"><span>Contact Number</span></div>
//             <div className="column1"><span>Vendor Logo</span></div>
//             <div className="column1"><span>Status</span></div>
//             <div className="column1"><span>Actions</span></div>
//           </div>
//           <hr className="divider" />
//           {filteredVendors.length === 0
//             ? <div className="no-data-message">{searchQuery ? `No vendors match "${searchQuery}"` : "No vendors found"}</div>
//             : <>
//               <div className="data-count-info">Showing {filteredVendors.length} of {vendors.length} vendors</div>
//               {filteredVendors.map((vendor) => (
//                 <div key={vendor.id} className="data-row">
//                   <div className="column"><span>{vendor.vendor_name}</span></div>
//                   <div className="column"><span>{vendor.gst_no || 'N/A'}</span></div>
//                   <div className="column"><span>{vendor.contact_number || 'N/A'}</span></div>
//                   <div className="column">
//                     {hasImage(vendor.vendor_logo) ? (
//                       <img
//                         src={vendor.vendor_logo}
//                         alt="Vendor Logo"
//                         className="entity-logo"
//                         onError={(e)=>{e.target.onerror=null;e.target.style.display="none"}}
//                       />
//                     ) : (
//                       <div className="entity-logo-placeholder">
//                         <FaStore />
//                       </div>
//                     )}
//                   </div>
//                   <div className="column">
//                     <span className={`status-${(vendor.status || 'Active').toLowerCase()}`}>
//                       {vendor.status || 'Active'}
//                     </span>
//                   </div>
//                   <div className="column actions">
//                     <FaEye
//                       className="action-icon view-icon"
//                       title="View"
//                       onClick={() => onViewVendor(vendor)}
//                     />
//                     <FaEdit
//                       className="action-icon edit-icon"
//                       title="Edit"
//                       onClick={() => onEditVendor(vendor)}
//                     />
//                     <FaTrash
//                       className="action-icon delete-icon"
//                       title="Delete"
//                       onClick={() => onDeleteVendor(vendor.id)}
//                     />
//                   </div>
//                 </div>
//               ))}
//             </>
//           }
//         </section>
//       </div>
//     );
//   };

//   const ClientsDisplay = ({ 
//     clients, 
//     searchQuery, 
//     onSearchChange, 
//     onAddClient, 
//     onViewClient,
//     onEditClient, 
//     onDeleteClient,
//     selectedClientStatus,
//     onStatusChange
//   }) => {
//     const filteredClients = clients.filter((client) => {
//       const clientName = client.client_name || '';
//       const gst_no = client.gst_no || '';
//       const contact_number = client.contact_number || '';
      
//       const matchesSearch = clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             gst_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
//             contact_number.toLowerCase().includes(searchQuery.toLowerCase());
      
//       const matchesStatus = !selectedClientStatus || client.status === selectedClientStatus;
      
//       return matchesSearch && matchesStatus;
//     });

//     function hasImage(logo) {
//       if (!logo || typeof logo !== "string") return false;
//       return (
//         logo.startsWith("data:image/") ||
//         logo.startsWith("http://") ||
//         logo.startsWith("https://")
//       );
//     }

//     return (
//       <div>
//         <div className="search-add-section">
//           <div className="search-container">
//             <div className="icon-wrapper"><FaSearch /></div>
//             <div className="Search-bar">
//               <input
//                 type="text"
//                 placeholder="        Search Client Details"
//                 value={searchQuery}
//                 onChange={(e) => onSearchChange(e.target.value)}
//               />
//             </div>
//           </div>
//           <div className="status-filter-container">
//             <select 
//               value={selectedClientStatus} 
//               onChange={(e) => onStatusChange(e.target.value)}
//               className="status-filter-dropdown"
//             >
            
//               <option value="Active">Active</option>
//               <option value="Inactive">Inactive</option>
//             </select>
//           </div>
//           <div className="add-button-container">
//             <button className="add-button" onClick={onAddClient}>
//               <FaPlus className="add-icon" />
//               Add Client
//             </button>
//           </div>
//         </div>
//         <section className="data-container">
//           <div className="header-row1">
//             <div className="column1"><span>Client Name</span></div>
//             <div className="column1"><span>GST NO</span></div>
//             <div className="column1"><span>Contact Number</span></div>
//             <div className="column1"><span>Client Logo</span></div>
//             <div className="column1"><span>Status</span></div>
//             <div className="column1"><span>Actions</span></div>
//           </div>
//           <hr className="divider" />
//           {filteredClients.length === 0
//             ? <div className="no-data-message">{searchQuery ? `No clients match "${searchQuery}"` : "No clients found"}</div>
//             : <>
//               <div className="data-count-info">Showing {filteredClients.length} of {clients.length} clients</div>
//               {filteredClients.map((client) => (
//                 <div key={client.id} className="data-row">
//                   <div className="column"><span>{client.client_name}</span></div>
//                   <div className="column"><span>{client.gst_no || 'N/A'}</span></div>
//                   <div className="column"><span>{client.contact_number || 'N/A'}</span></div>
//                   <div className="column">
//                     {hasImage(client.client_logo) ? (
//                       <img
//                         src={client.client_logo}
//                         alt="Client Logo"
//                         className="entity-logo"
//                         onError={(e)=>{e.target.onerror=null;e.target.style.display="none"}}
//                       />
//                     ) : (
//                       <div className="entity-logo-placeholder">
//                         <FaUserTie />
//                       </div>
//                     )}
//                   </div>
//                   <div className="column">
//                     <span className={`status-${(client.status || 'Active').toLowerCase().replace(/\s+/g, "-")}`}>
//                       {client.status || 'Active'}
//                     </span>
//                   </div>
//                   <div className="column actions">
//                     <FaEye
//                       className="action-icon view-icon"
//                       title="View"
//                       onClick={() => onViewClient(client)}
//                     />
//                     <FaEdit
//                       className="action-icon edit-icon"
//                       title="Edit"
//                       onClick={() => onEditClient(client)}
//                     />
//                     <FaTrash
//                       className="action-icon delete-icon"
//                       title="Delete"
//                       onClick={() => onDeleteClient(client.id)}
//                     />
//                   </div>
//                 </div>
//               ))}
//             </>
//           }
//         </section>
//       </div>
//     );
//   };




// const FilterSection = ({ onSearch, financialYear, setFinancialYear, quarter, setQuarter, period, setPeriod, status, setStatus }) => {
//   const quarterMonths = {
//     "Quarter 1 (Apr - Jun)": ["April", "May", "June"],
//     "Quarter 2 (Jul - Sep)": ["July", "August", "September"],
//     "Quarter 3 (Oct - Dec)": ["October", "November", "December"],
//     "Quarter 4 (Jan - Mar)": ["January", "February", "March"],
//   };

//   const filteredPeriods = quarterMonths[quarter] || [];

//  React.useEffect(() => {
//   if (filteredPeriods.length > 0 && !filteredPeriods.includes(period)) {
//     setPeriod(filteredPeriods[0]);
//   }
// }, [quarter]);

// React.useEffect(() => {
//   onSearch({ financialYear, quarter, period, status });
// }, [financialYear, quarter, period, status, onSearch]);

//   const handleSearch = () => {
//     onSearch({ financialYear, quarter, period, status });
//   };

//   return (
//     <div className="IVV-00">
//       <div className="IVV-01">
       
//         <div className="IVV-02">
//           <label className="IVV-03">Financial Year</label>
//           <select
//             className="IVV-05"
//             value={financialYear}
//             onChange={(e) => setFinancialYear(e.target.value)}
//           >
//             <option value="2025-26">2025-26</option>
//             <option value="2024-25">2024-25</option>
//             <option value="2023-24">2023-24</option>
//             <option value="2022-23">2022-23</option>
//             <option value="2021-22">2021-22</option>
//           </select>
//         </div>

      
//         <div className="IVV-02">
//           <label className="IVV-03">Quarter</label>
//           <select
//             className="IVV-05"
//             value={quarter}
//             onChange={(e) => setQuarter(e.target.value)}
//           >
//             <option value="Quarter 1 (Apr - Jun)">Quarter 1 (Apr - Jun)</option>
//             <option value="Quarter 2 (Jul - Sep)">Quarter 2 (Jul - Sep)</option>
//             <option value="Quarter 3 (Oct - Dec)">Quarter 3 (Oct - Dec)</option>
//             <option value="Quarter 4 (Jan - Mar)">Quarter 4 (Jan - Mar)</option>
//           </select>
//         </div>

       
//         <div className="IVV-02">
//           <label className="IVV-03">Period</label>
//           <select
//             className="IVV-05"
//             value={period}
//             onChange={(e) => setPeriod(e.target.value)}
//           >
//             {filteredPeriods.map((m, i) => (
//               <option key={i} value={m}>{m}</option>
//             ))}
//           </select>
//         </div>

        
//         <div className="IVV-02">
//           <label className="IVV-03">Status</label>
//           <select
//             className="IVV-05"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             <option value="ACTIVE">ACTIVE</option>
//             <option value="CANCEL">CANCEL</option>
//             <option value="ALL INVOICES">ALL INVOICES</option>
//           </select>
//         </div>

//         <button className="IVV-06" onClick={handleSearch}>
//           SEARCH
//         </button>
//       </div>
//     </div>
//   );
// };


// const getStatusClassName = (status) => {
//   const normalizedStatus = (status || 'Active').toLowerCase();
//   if (normalizedStatus === 'active') {
//     return 'status-active';
//   } else if (normalizedStatus === 'cancel') {
//     return 'status-cancel';
//   }
//   return 'status-active'; 
// };


// const getCurrentFinancialYear = () => {
//   const today = new Date();
//   const currentYear = today.getFullYear();
//   const currentMonth = today.getMonth() + 1;
  
//   if (currentMonth >= 4) {
//     return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
//   } else {
//     return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
//   }
// };


// const InvoicesDisplay = ({ 
//   invoices, 
//   searchQuery, 
//   onSearchChange, 
//   onTaxInvoiceClick, 
//   onProformaInvoiceClick, 
//   onEditInvoice,
//   onViewInvoice  
// }) => {
//  const [financialYear, setFinancialYear] = React.useState(getCurrentFinancialYear());
// const [quarter, setQuarter] = React.useState("Quarter 3 (Oct - Dec)");
// const [period, setPeriod] = React.useState("October");
// const [status, setStatus] = React.useState("ALL INVOICES");
// const [appliedFilters, setAppliedFilters] = React.useState(null);

//   const handleFilterSearch = (filters) => {
    
//     setAppliedFilters(filters);
//   };

// const filteredInvoices = invoices.filter((invoice) => {
//   const invoiceNumber = invoice.invoice_number || '';
//   const clientName = invoice.client_name || '';
//   const vendorName = invoice.vendor_name || '';
//   const amount = invoice.amount ? invoice.amount.toString() : '';
  
//   const matchesSearch = invoiceNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         amount.includes(searchQuery);

//   if (!appliedFilters) {
//     return matchesSearch;
//   }

 
//   const invoiceDate = new Date(invoice.invoice_date || invoice.date || invoice.created_on);
  

//   if (isNaN(invoiceDate.getTime())) {
   
//     return false;
//   }
  
//   const invoiceMonthName = invoiceDate.toLocaleString('en-US', { month: 'long' });
//   const invoiceYear = invoiceDate.getFullYear();
//   const invoiceMonthNum = invoiceDate.getMonth() + 1; 
//   const [startYearStr, endYearStr] = appliedFilters.financialYear.split('-');
//   const startYear = parseInt(startYearStr);
//   const endYear = parseInt('20' + endYearStr); 

//   let correctYearForMonth;
//   if (invoiceMonthNum >= 4 && invoiceMonthNum <= 12) {

//     correctYearForMonth = startYear;
//   } else if (invoiceMonthNum >= 1 && invoiceMonthNum <= 3) {
 
//     correctYearForMonth = endYear;
//   }

//   const isInFinancialYear = 
//     (invoiceYear === startYear && invoiceMonthNum >= 4) || 
//     (invoiceYear === endYear && invoiceMonthNum <= 3);     
//   const matchesExactMonth = invoiceMonthName === appliedFilters.period;
 
//   const matchesExactYear = invoiceYear === correctYearForMonth;

//   const matchesStatus = appliedFilters.status === "ALL INVOICES" || 
//                         (invoice.status && invoice.status.toUpperCase() === appliedFilters.status);

//   if (matchesSearch && matchesStatus) {
 
//   }

//   return matchesSearch && matchesExactMonth && matchesExactYear && matchesStatus && isInFinancialYear;
// });

//   const handleSendEmail = (invoice) => {
   
//   };

//   const handleSendSMS = (invoice) => {
   
//   };
//   return (
//     <div>
//       <div className="search-add-section">
//         <div className="search-container">
//           <div className="icon-wrapper"><FaSearch /></div>
//           <div className="Search-bar">
//             <input
//               type="text"
//               placeholder="        Search Tax Invoice Details"
//               value={searchQuery}
//               onChange={(e) => onSearchChange(e.target.value)}
//             />
//           </div>
//         </div>
//         <div className="IV-04">
//           <button className="IV-05" onClick={onTaxInvoiceClick}>
//             + Tax Invoice
//           </button>
//         </div>
//       </div>

//       <FilterSection 
//         onSearch={handleFilterSearch}
//         financialYear={financialYear}
//         setFinancialYear={setFinancialYear}
//         quarter={quarter}
//         setQuarter={setQuarter}
//         period={period}
//         setPeriod={setPeriod}
//         status={status}
//         setStatus={setStatus}
//       />
      
//       <section className="data-container">
//         <div className="header-row1">
//           <div className="column1"><span>Invoice Number</span></div>
//           <div className="column1"><span>Status</span></div>
//           <div className="column1"><span>Billed To</span></div>
//           <div className="column1"><span>Date</span></div>
//           <div className="column1"><span>Grand Total</span></div>
//           <div className="column1"><span>Actions</span></div>
//         </div>
//         <hr className="divider" />
//         {filteredInvoices.length === 0
//           ? <div className="no-data-message">{searchQuery ? `No invoices match "${searchQuery}"` : "No invoices found"}</div>
//           : <>
//             <div className="data-count-info">Showing {filteredInvoices.length} of {invoices.length} invoices</div>
//             {filteredInvoices.map((invoice) => (
//               <div key={invoice.id} className="data-row">
//                 <div className="column1"><span>{invoice.invoice_number}</span></div>
//                 <div className="column1">
//                   <span className={getStatusClassName(invoice.status)}>
//                     {invoice.status || 'Active'}
//                   </span>
//                 </div>
//                 <div className="column1"><span>{invoice.client_name}</span></div>
//                 <div className="column1">
//                   <span>{new Date(invoice.invoice_date || invoice.date || invoice.created_on).toLocaleDateString()}</span>
//                 </div>
//                 <div className="column1"><span>₹{invoice.amount?.toLocaleString()}</span></div>
//                 <div className="column1 actions">
//                   <FaEye
//                     className="action-icon view-icon"
//                     title="View"
//                     onClick={() => onViewInvoice(invoice)}  
//                   />
//                   <FaEdit
//                     className="action-icon edit-icon"
//                     title="Edit"
//                     onClick={() => onEditInvoice(invoice)}
//                   />
//                   <FaEnvelope
//                     className="action-icon mail-icon"
//                     title="Send Email"
//                     onClick={() => handleSendEmail(invoice)}
//                   />
//                   <FaSms
//                     className="action-icon sms-icon"
//                     title="Send SMS"
//                     onClick={() => handleSendSMS(invoice)}
//                   />
//                 </div>
//               </div>
//             ))}
//           </>
//         }
//       </section>
//     </div>
//   );
// };








  
//   const Navbar = ({ onLogout, project, initialSection, notificationMessages }) => {

//  const handleReportSubmissionPageClick = async () => {
 
  
//   setShowProjectsDropdown(false);
//   setShowEmployeesDropdown(false);
//   setShowClientsDropdown(false);
//   setShowInvoicesDropdown(false);
  
//   setShowManageLeaves(false);
//   setShowLeaves(false);
//   setShowProjects(false);
//   setShowReports(false);
//   setShowAddProject(false);
//   setShowExpenses(false);
//   setShowProjectUpdate(false);
//   setShowUserProfile(false);
//   setShowVendors(false);
//   setShowClients(false);
//   setShowAddVendor(false);
//   setShowAddClient(false);
//   setShowEditVendor(false);
//   setShowViewVendor(false);
//   setShowEditClient(false);
//   setShowViewClient(false);
//   setShowTaxInvoice(false);
//   setShowProformaInvoice(false);
//   setShowUpdateTaxInvoice(false);
//   setShowViewInvoice(false);
//   setShowInvoices(false);
//   setShowPerformaInvoices(false);
//   setShowPerformaInvoiceForm(false);
//   setShowUpdatePerformaInvoice(false);
//   setShowEmployeeProject(false);
  
//   setShowReportSubmission(true);

//   await fetchProjects();
// };
//     const [showViewInvoice, setShowViewInvoice] = useState(false);
//     const [viewInvoiceData, setViewInvoiceData] = useState(null);
 
//   const [selectedVendorStatus, setSelectedVendorStatus] = useState(
//     localStorage.getItem('selectedVendorStatus') || "Active"
//   );
   
//     const [selectedClientStatus, setSelectedClientStatus] = useState(
//     localStorage.getItem('selectedClientStatus') || "Active"
//   );

//   const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState(
//   localStorage.getItem('selectedEmployeeStatus') || "Active"
// );
//     const [showPopup, setShowPopup] = useState(false);
//     const [showProjectModal, setShowProjectModal] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const [showInvoices, setShowInvoices] = useState(false);
//     const [selectedProjectData, setSelectedProjectData] = useState(null);
//     const [invoices, setInvoices] = useState([]);
//     const [employeeLeaves, setEmployeeLeaves] = useState([]);
//     const [errorMessage, setErrorMessage] = useState("");
//     const [showProfileMenu, setShowProfileMenu] = useState(false);
//     const [showUserProfile, setShowUserProfile] = useState(false);
//     const [showManageLeaves, setShowManageLeaves] = useState(true);
//     const [showLeaves, setShowLeaves] = useState(false);


//     const [showReportSubmission, setShowReportSubmission] = useState(false);
// const [reportSubmissionSearchQuery, setReportSubmissionSearchQuery] = useState("");

// const [showReportSubmissionView, setShowReportSubmissionView] = useState(false);
// const [selectedReportForSubmission, setSelectedReportForSubmission] = useState(null);


//     const [showEmployeesDropdown, setShowEmployeesDropdown] = useState(false);
//     const [showProjects, setShowProjects] = useState(false);
//     const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);
//     const [showAddProject, setShowAddProject] = useState(false);
//     const [selectedProjectStatus, setSelectedProjectStatus] = useState("");
//     const [showExpenses, setShowExpenses] = useState(false);
//     const [selectedProject, setSelectedProject] = useState(null);
//     const [showProjectUpdate, setShowProjectUpdate] = useState(false); 
//     const [projectToUpdate, setProjectToUpdate] = useState(null); 
//     const [employees, setEmployees] = useState([]); 
//     const [showReports, setShowReports] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
//     const [showVendors, setShowVendors] = useState(false);
//     const [showClients, setShowClients] = useState(false);
//     const [showClientsDropdown, setShowClientsDropdown] = useState(false);
//     const [showAddVendor, setShowAddVendor] = useState(false);
//     const [showAddClient, setShowAddClient] = useState(false);
//     const [showEditVendor, setShowEditVendor] = useState(false);
//     const [showViewVendor, setShowViewVendor] = useState(false);
//     const [selectedVendor, setSelectedVendor] = useState(null);
//     const [showTaxInvoice, setShowTaxInvoice] = useState(false);
//     const [refreshInvoiceNumber, setRefreshInvoiceNumber] = useState(null);

//     const [showEditClient, setShowEditClient] = useState(false);
//     const [showViewClient, setShowViewClient] = useState(false);
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [isUploading, setIsUploading] = useState(false);
//     const [uploadSuccess, setUploadSuccess] = useState(false);
//     const fileInputRef = useRef(null);
//     const [profileImage, setProfileImage] = useState(null);
//     const [userName, setUserName] = useState("User Name");
//     const [reports, setReports] = useState([]);
//     const [projects, setProjects] = useState([]);
//     const [vendors, setVendors] = useState([]);
//     const [clients, setClients] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [expenses, setExpenses] = useState([]);
//     const [error, setError] = useState('');
//     const [projectExpenses, setProjectExpenses] = useState([]);
//     const [showUpdateTaxInvoice, setShowUpdateTaxInvoice] = useState(false);
//     const [selectedInvoice, setSelectedInvoice] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [vendorSearchQuery, setVendorSearchQuery] = useState("");
//     const [clientSearchQuery, setClientSearchQuery] = useState("");
//     const [invoiceSearchQuery, setInvoiceSearchQuery] = useState("");
//     const [showInvoicesDropdown, setShowInvoicesDropdown] = useState(false);
//     const [showProformaInvoice, setShowProformaInvoice] = useState(false);
//     const [showReportsList, setShowReportsList] = useState(false);
//     const [selectedProjectForReports, setSelectedProjectForReports] = useState(null);
//     const [projectReports, setProjectReports] = useState([]);
    
//     const [viewMode, setViewMode] = useState(false); 
//     const [showGetReports, setShowGetReports] = useState(false);

//     const [assignedProjectIds, setAssignedProjectIds] = useState([]);

//     const [showEmployeeProject, setShowEmployeeProject] = useState(false);
//   const [selectedProjectForEmployees, setSelectedProjectForEmployees] = useState(null);
    


//   const [showNotifications, setShowNotifications] = useState(false);
// const [notifications, setNotifications] = useState([]);
// const [unreadCount, setUnreadCount] = useState(0);

//     const [performaInvoices, setPerformaInvoices] = useState([]);
//   const [showPerformaInvoices, setShowPerformaInvoices] = useState(false);
//   const [showPerformaInvoiceForm, setShowPerformaInvoiceForm] = useState(false);
//   const [showUpdatePerformaInvoice, setShowUpdatePerformaInvoice] = useState(false);
//   const [selectedPerformaInvoice, setSelectedPerformaInvoice] = useState(null);
//   const [performaInvoiceSearchQuery, setPerformaInvoiceSearchQuery] = useState("");


// const [filterType, setFilterType] = useState('all');







//   useEffect(() => {
//   if (initialSection) {
//     resetAllViews();
    
//     switch(initialSection) {
//       case 'employees':
//         setShowManageLeaves(true);
//         fetchEmployees();
//         break;
//       case 'projects':
//         setShowProjects(true);
//         fetchProjects();
//         break;
//       case 'reports':
//         setShowReports(true);
//         fetchReports();
//         break;
//       case 'vendors':
//         setShowVendors(true);
//         fetchVendors();
//         break;
//       case 'clients':
//         setShowClients(true);
//         fetchClients();
//         break;
//       case 'taxInvoices':
//         setShowInvoices(true);
//         fetchInvoices();
//         break;
//       case 'performaInvoices':
//         setShowPerformaInvoices(true);
//         fetchPerformaInvoices();
//         break;
//           case 'reportSubmission':
//         setShowReportSubmission(true);
//         break;
//       default:
//         break;
//     }
//   }
// }, [initialSection]);

//   const isCEOUser = () => {
//     const accessLevel = localStorage.getItem('accessLevel');
//     const userRole = currentUser?.role || localStorage.getItem('currentUserRole') || '';
//     return accessLevel === 'full' || 
//           userRole.toUpperCase().includes('CEO') ||
//           userRole.toUpperCase().includes('ADMIN');
//   };

//   const getUserRole = () => {
//     const userRole = currentUser?.role || localStorage.getItem('currentUserRole') || '';
//     const accessLevel = localStorage.getItem('accessLevel');
    
//     if (accessLevel === 'full' || 
//         userRole.toUpperCase() === 'CEO' || 
//         userRole.toUpperCase().includes('CEO') ||
//         userRole.toUpperCase() === 'ADMIN' ||
//         userRole.toUpperCase().includes('ADMIN')) {
//       return 'CEO';
//     } else if (localStorage.getItem('userType') === 'client') {
//       return 'CLIENT';
//     } else {
//       return 'EMPLOYEE';
//     }
//   };

// const isMenuItemVisible = (menuItem) => {
//   const role = getUserRole();
  
//   switch (role) {
//     case 'CEO':
//       return true;
      
//     case 'CLIENT':
//       return menuItem === 'PROJECTS';
      
//     case 'EMPLOYEE':
//       return ['EMPLOYEES', 'PROJECTS', 'REPORTS'].includes(menuItem);
      
//     default:
//       return false;
//   }
// };
// const fetchEmployeeAssignedProjects = async () => {
//   try {
//     const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
    
//     if (!currentUserId) {
     
//       return [];
//     }
//     const response = await fetch(`${API_URL}/projects/get_employee_to_projects`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       mode: 'cors',
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     const result = await response.json();
//     if (result.status === 'success' && result.data) {
//       const employeeProjects = result.data.filter(
//         emp => emp.employee_id === parseInt(currentUserId)
//       );
      
//       const projectIds = [...new Set(employeeProjects.map(emp => emp.project_id))];
     
      
//       setAssignedProjectIds(projectIds);
//       return projectIds;
//     } else {
      
//       setAssignedProjectIds([]);
//       return [];
//     }
//   } catch (error) {
   
//     setAssignedProjectIds([]);
//     return [];
//   }
// };

// const loadNotifications = () => {
//   const currentUserId = localStorage.getItem('currentUserId');
//   if (!currentUserId) return;
  
//   const storedNotifications = localStorage.getItem(`notifications_${currentUserId}`) || '[]';
  
//   try {
//     const parsedNotifications = JSON.parse(storedNotifications);
//     const sortedNotifications = parsedNotifications.sort((a, b) => 
//       new Date(b.timestamp) - new Date(a.timestamp)
//     );
//     setNotifications(sortedNotifications);
    
//     const unread = sortedNotifications.filter(n => !n.read).length;
//     setUnreadCount(unread);
//   } catch (error) {
   
//     setNotifications([]);
//   }
// };

// useEffect(() => {
//   loadNotifications();

//   const handleNotificationUpdate = () => {
//     loadNotifications();
//   };

//   const handleStorageChange = (e) => {
//     if (e.key && (e.key.startsWith('notifications_') || e.key === 'notifications_update')) {
//       loadNotifications();
//     }
//   };

//   window.addEventListener('storage', handleStorageChange);
//   window.addEventListener('notificationUpdate', handleNotificationUpdate);

//   const notificationCheckInterval = setInterval(loadNotifications, 5000);

//   return () => {
//     window.removeEventListener('storage', handleStorageChange);
//     window.removeEventListener('notificationUpdate', handleNotificationUpdate);
//     clearInterval(notificationCheckInterval);
//   };
// }, []);


// const addNotification = (type, message, details = {}) => {
//   const currentUserId = localStorage.getItem('currentUserId');
//   const notification = {
//     id: Date.now(),
//     type,
//     message,
//     details,
//     timestamp: new Date().toISOString(),
//     read: false
//   };

//   const existingNotifications = JSON.parse(localStorage.getItem(`notifications_${currentUserId}`) || '[]');
//   existingNotifications.unshift(notification);
  
//   localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(existingNotifications));
//   loadNotifications();
// };


// useEffect(() => {
//   loadNotifications();

//   const handleStorageChange = (e) => {
//     if (e.key && e.key.startsWith('notifications_')) {
//       loadNotifications();
//     }
//   };

//   window.addEventListener('storage', handleStorageChange);
//   window.addEventListener('notificationUpdate', loadNotifications);

//   return () => {
//     window.removeEventListener('storage', handleStorageChange);
//     window.removeEventListener('notificationUpdate', loadNotifications);
//   };
// }, []);



// const getFilteredLeaves = () => {
//   const role = getUserRole();
//   const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
  
//   if (role === 'CEO') {
//     return employeeLeaves;
//   } else if (role === 'EMPLOYEE') {
//     return employeeLeaves.filter(leave => 
//       String(leave.employee_id) === String(currentUserId)
//     );
//   }
//   return [];
// };



// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (showProfileMenu && !event.target.closest('.profile-section')) {
//       setShowProfileMenu(false);
//     }
//     if (showNotifications && !event.target.closest('.notification-section') && !event.target.closest('.HM-notification-panel')) {
//       setShowNotifications(false);
//     }
//   };

//   document.addEventListener('mousedown', handleClickOutside);
//   return () => document.removeEventListener('mousedown', handleClickOutside);
// }, [showProfileMenu, showNotifications]);


//   const getFilteredEmployees = () => {
//     const role = getUserRole();
//     const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
    
//     if (role === 'CEO') {
//       return employees;
//     } else if (role === 'EMPLOYEE') {
//       return employees.filter(emp => 
//         emp.id === parseInt(currentUserId) || 
//         emp.employee_id === parseInt(currentUserId)
//       );
//     }
//     return [];
//   };
//   const handleManageEmployees = (project) => {
   
//     setSelectedProjectForEmployees(project);
//     setShowEmployeeProject(true);
//     setShowProjects(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowReports(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowInvoices(false);
//   };

//   const handleBackFromEmployeeProject = () => {
//     setShowEmployeeProject(false);
//     setSelectedProjectForEmployees(null);
//     setShowProjects(true);
//   };
 
//   const getFilteredProjects = () => {
//   const role = getUserRole();
//   const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
//   const clientId = currentUser?.client_id || localStorage.getItem('currentClientId');
  
//   if (role === 'CEO') {
//     return projects;
//   } else if (role === 'CLIENT') {
//     return projects.filter(project => 
//       project.client_id === parseInt(clientId) || 
//       project.client === parseInt(clientId)
//     );
//   } else if (role === 'EMPLOYEE') {
//     if (assignedProjectIds.length === 0) {
//       return [];
//     }
//     return projects.filter(project => 
//       assignedProjectIds.includes(project.project_id || project.id)
//     );
//   }
//   return [];
// };
  
//   const AddClient = ({ onBack, onSubmit }) => {
//       const [clientData, setClientData] = useState({
//         client_name: '',
//         gst_no: '',
//         contact_number: '',
//         client_logo: null
//       });
//       const [isSubmitting, setIsSubmitting] = useState(false);
//       const [submitError, setSubmitError] = useState('');
//       const logoInputRef = useRef(null);

//       const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setClientData(prev => ({
//           ...prev,
//           [name]: value
//         }));
//       };

//       const handleLogoUpload = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//           if (file.size > 2 * 1024 * 1024) {
//             alert('Logo file size should be less than 2MB');
//             return;
//           }
          
//           const reader = new FileReader();
//           reader.onload = (e) => {
//             setClientData(prev => ({
//               ...prev,
//               client_logo: e.target.result
//             }));
//           };
//           reader.readAsDataURL(file);
//         }
//       };

//       const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         if (!clientData.client_name.trim()) {
//           alert('Please enter client name');
//           return;
//         }

//         setIsSubmitting(true);
//         setSubmitError('');

//         try {
//           const response = await fetch(`${API_URL}/clients/add_client`, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             mode: 'cors',
//             body: JSON.stringify(clientData)
//           });

//           if (!response.ok) {
//             const errorData = await response.json().catch(() => ({}));
//             throw new Error(`Failed to add client: ${errorData.message || response.statusText}`);
//           }

//           const result = await response.json();
          

//           const newClient = {
//             id: result.client_id || Date.now(),
//             client_id: result.client_id || Date.now(),
//             client_name: clientData.client_name,
//             gst_no: clientData.gst_no,
//             contact_number: clientData.contact_number,
//             client_logo: clientData.client_logo,
//             created_on: new Date().toISOString(),
//             updated_on: new Date().toISOString(),
//             originalData: result
//           };

//           if (onSubmit) {
//             onSubmit(newClient);
//           }

//           alert('Client added successfully!');
//           onBack();

//         } catch (error) {
         
//           setSubmitError(error.message);
          
//           const newClient = {
//             id: Date.now(),
//             client_id: Date.now(),
//             client_name: clientData.client_name,
//             gst_no: clientData.gst_no,
//             contact_number: clientData.contact_number,
//             client_logo: clientData.client_logo,
//             created_on: new Date().toISOString(),
//             updated_on: new Date().toISOString()
//           };

//           if (onSubmit) {
//             onSubmit(newClient);
//           }
          
//           alert('Client added to local list (check server connection)');
//           onBack();
//         } finally {
//           setIsSubmitting(false);
//         }
//       };

//       useEffect(() => {
//         fetchEmployees();
//       }, []);

//       return (
//         <div className="add-client-container">
//           <div className="add-client-form-wrapper">
//             <div className="add-client-header">
//               <button 
//                 onClick={onBack}
//                 className="back-button"
//               >
//                 ←
//               </button>
//               <h2 className="add-client-title">Add New Client</h2>
//             </div>

//             {submitError && (
//               <div className="error-alert">
//                 {submitError}
//               </div>
//             )}

//             <form onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label className="form-label">
//                   Client Name *
//                 </label>
//                 <input
//                   type="text"
//                   name="client_name"
//                   value={clientData.client_name}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">
//                   GST NO
//                 </label>
//                 <input
//                   type="text"
//                   name="gst_no"
//                   value={clientData.gst_no}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="Enter GST NO (optional)"
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">
//                   Contact Number
//                 </label>
//                 <input
//                   type="text"
//                   name="contact_number"
//                   value={clientData.contact_number}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="Enter Contact Number (optional)"
//                 />
//               </div>

//               <div className="form-group">
//                 <label className="form-label">
//                   Client Logo
//                 </label>
//                 <input
//                   type="file"
//                   ref={logoInputRef}
//                   onChange={handleLogoUpload}
//                   accept="image/*"
//                   className="hidden-file-input"
//                 />
//                 <div className="logo-upload-section">
//                   <button
//                     type="button"
//                     onClick={() => logoInputRef.current?.click()}
//                     className="choose-logo-button"
//                   >
//                     Choose Logo
//                   </button>
//                   {clientData.client_logo && (
//                     <img 
//                       src={clientData.client_logo} 
//                       alt="Client Logo Preview" 
//                       className="logo-preview"
//                     />
//                   )}
//                 </div>
//               </div>

//               <div className="form-actions">
//                 <button
//                   type="button"
//                   onClick={onBack}
//                   className="cancel-button"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className={`submit-button ${isSubmitting ? 'disabled' : ''}`}
//                 >
//                   {isSubmitting ? 'Adding...' : 'Add Client'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       );
//     };

//     useEffect(() => {
//       const storedUser = localStorage.getItem('currentUser');
//       const storedProfileImage = localStorage.getItem('currentUserProfileImage');
//       const storedUserName = localStorage.getItem('currentUserName');
      
//       if (storedUser) {
//         try {
//           const userData = JSON.parse(storedUser);
//           setCurrentUser(userData);
        
//           const userRole = userData.role || localStorage.getItem('currentUserRole') || 'Employee';
//           setUserName(userData.name || storedUserName || "User Name");
          
//           if (userData.id || userData.employee_id) {
//             const employeeId = userData.id || userData.employee_id;
//             const employeeImage = localStorage.getItem(`employee_${employeeId}_profileImage`);
//             if (employeeImage) {
//               setProfileImage(employeeImage);
//             }
//           }
//         } catch (error) {
        
//           setUserName(storedUserName || "User Name");
//         }
//       }
      
//       if (storedProfileImage) {
//         setProfileImage(storedProfileImage);
//       }
      
//       if (storedUserName) {
//         setUserName(storedUserName);
//       }

//       const openReports = localStorage.getItem('openReportsOnLoad');
//       if (openReports === 'true') {
//         localStorage.removeItem('openReportsOnLoad');
//         handleReportsClick();
//       }

//       fetchProjects();
//     }, []);
    
// useEffect(() => {
//   if (showManageLeaves) {
//     fetchEmployees();
//   }
// }, [selectedEmployeeStatus]);   
//     const getProjectId = () => {
//       if (!project) return null;
//       return project.project_id || project.id;
//     };


// useEffect(() => {
//   const fetchNotifications = async () => {
//     const role = getUserRole();
    
//     if (role === 'CEO') {
//       try {
//         const currentUserId = localStorage.getItem('currentUserId');
//         loadNotifications(); 

//         const response = await fetch(`${API_URL}/payslips/get_employee_leaves`, {
//           method: 'GET',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           mode: 'cors',
//         });

//         if (!response.ok) {
//           throw new Error('Failed to fetch leave notifications');
//         }

//         const result = await response.json();
        
      
//         const storedNotifications = JSON.parse(localStorage.getItem(`notifications_${currentUserId}`) || '[]');
        
       
//         const uniqueNotifications = storedNotifications.filter((notif, index, self) =>
//           index === self.findIndex((n) => n.id === notif.id)
//         );
        
       
//         const sortedNotifications = uniqueNotifications.sort((a, b) => 
//           new Date(b.timestamp) - new Date(a.timestamp)
//         );

//         const expenseResponse = await fetch(`${API_URL}/projects/get_project_expense`, {
//           method: 'GET',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           mode: 'cors',
//         });

//         if (expenseResponse.ok) {
//           const expenseResult = await expenseResponse.json();
//           let expensesData = [];
          
//           if (expenseResult.project_expenses && Array.isArray(expenseResult.project_expenses)) {
//             expensesData = expenseResult.project_expenses;
//           }

//           const pendingExpenses = expensesData.filter(
//             expense => expense.status && expense.status.toLowerCase() === 'pending'
//           );

//           const expenseNotifications = pendingExpenses.map(expense => {
//             const employeeName = expense.employee_name || `Employee ${expense.employee_id}`;
//             const amount = expense.expense_amount || expense.amount || 0;
//             const reason = expense.expense_reason || 'No reason provided';
            
           
//           });

//           const allNotifications = [...sortedNotifications, ...expenseNotifications];
          
         
//           const finalNotifications = allNotifications.filter((notif, index, self) =>
//             index === self.findIndex((n) => n.id === notif.id)
//           ).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
          
//           setNotifications(finalNotifications);
//           const unread = finalNotifications.filter(n => !n.read).length;
//           setUnreadCount(unread);
//         }

//       } catch (error) {
        
//         loadNotifications();
//       }
//     } else if (role === 'EMPLOYEE') {
//       loadNotifications();
//     } else {
//       setNotifications([]);
//       setUnreadCount(0);
//     }
//   };

//   fetchNotifications();
//   const intervalId = setInterval(fetchNotifications, 60000); 

//   return () => clearInterval(intervalId);
// }, [currentUser]);


//     const fetchProjectExpenses = async () => {
//       const projectId = getProjectId();
      
//       setLoading(true);
//       setError('');
      
//       try {
//         const employeeLookup = await fetchEmployees();
        
//         let apiUrl;
//         if (projectId) {
//           apiUrl = `${API_URL}/projects/get_project_expense?project_id=${projectId}`;
//         }

      

//         const response = await fetch(apiUrl, {
//           method: 'GET',  
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           mode: 'cors',
//         });

//         if (!response.ok) {
//           throw new Error(`API Error: ${response.status}`);
//         }

//         const result = await response.json();
        
//         let expensesData = [];
//         if (result.status === "success" && result.project_expenses) {
//           expensesData = result.project_expenses;
//         } else if (result.project_expenses) {
//           expensesData = result.project_expenses;
//         }

       
        
//         const formattedExpenses = expensesData.map((expense, index) => {
//           const employeeId = expense.employee_id || '';
//           const amount = parseFloat(expense.expense_amount || expense.amount || 0);
          
//           const formatted = {
//             id: expense.expense_id || expense.id || index + 1,
//             expense_id: expense.expense_id || expense.id,
//             employeeName: employeeId,
//             employee_name: employeeId,
//             date: expense.date_of_expense ? 
//                   expense.date_of_expense.split('T')[0] : 
//                   new Date().toISOString().split('T')[0],
//             reason: expense.expense_reason || 'No reason provided',
//             description: expense.expense_reason || 'No reason provided',
//             amount: amount,
//             status: expense.status || 'Pending',
//             project_id: expense.project_id,
//             employee_id: expense.employee_id,
//             originalData: expense
//           };
          
         
//           return formatted;
//         });
        
//         setExpenses(formattedExpenses);

//       } catch (error) {
       
//         setError(`Failed to load expenses: ${error.message}`);
//         setExpenses([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//   const isCEO = () => {
//     const accessLevel = localStorage.getItem('accessLevel');
//     const userRole = currentUser?.role || localStorage.getItem('currentUserRole') || 'Employee';
    
//     return accessLevel === 'full' || 
//           userRole.toLowerCase().includes('ceo') ||
//           userRole.toLowerCase().includes('assistant admin');  
//   };
//     const canEditEmployee = (employeeId) => {
//       if (isCEO()) return true;
//       const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
//       return parseInt(currentUserId) === parseInt(employeeId);
//     };
//   const handleEmployeesClick = () => {
//     setShowEmployeesDropdown(!showEmployeesDropdown);
//     setShowProjectsDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);
    
//     if (!showEmployeesDropdown) {
//       setShowInvoices(false);
//       setShowProjects(false);
//       setShowReports(false);
//       setShowVendors(false);
//       setShowClients(false);
//       setShowAddProject(false);
//       setShowExpenses(false);
//       setShowProjectUpdate(false);
//       setShowUserProfile(false);
//       setShowAddVendor(false);
//       setShowAddClient(false);
//       setShowEditVendor(false);
//       setShowViewVendor(false);
//       setShowEditClient(false);
//       setShowViewClient(false);
//       setShowTaxInvoice(false);
//       setShowProformaInvoice(false);
//       setShowUpdateTaxInvoice(false);
//       setShowViewInvoice(false);
//       setShowLeaves(false);
//       setShowPerformaInvoices(false);        
//       setShowPerformaInvoiceForm(false);     
//       setShowUpdatePerformaInvoice(false);   
      
//       setShowManageLeaves(true);
//     }
//   };
//   const handleVendorStatusChange = (status) => {
//     setSelectedVendorStatus(status);
//     localStorage.setItem('selectedVendorStatus', status);
//   };

//   const handleClientStatusChange = (status) => {
//     setSelectedClientStatus(status);
//     localStorage.setItem('selectedClientStatus', status);
//   };
//   const handleEmployeeStatusChange = (status) => {
//     setSelectedEmployeeStatus(status);
//     localStorage.setItem('selectedEmployeeStatus', status);
//   };
//   const handleClientsClick = async () => {
    
//      setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);
//     setShowReportSubmission(false);
// setShowReportSubmissionView(false);
    
//     setShowInvoices(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//     setShowPerformaInvoices(false);       
//     setShowPerformaInvoiceForm(false);     
//     setShowUpdatePerformaInvoice(false);   
    
//     setShowClients(true);

//     await fetchClients();
//   };

// const fetchPerformaInvoices = async () => {
//   setIsLoading(true);
//   setErrorMessage("");
  
//   try {
//     const response = await fetch(`${API_URL}/performainvoices/get_performainvoice`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       mode: 'cors',
//     });
    
//     const result = await response.json();
    
    
//     let invoicesData = [];
    
//     if (result.status === "success" && result.data) {
//       invoicesData = Array.isArray(result.data) ? result.data : [result.data];
//     } else if (Array.isArray(result)) {
//       invoicesData = result;
//     }
    
//     invoicesData.forEach((inv, index) => {
     
//     });
    
//     const transformedInvoices = invoicesData.map(invoice => {
//       const transformed = transformInvoiceData(invoice);
      
//       return transformed;
//     });
    
   
    
//     setPerformaInvoices(transformedInvoices);
    
//   } catch (error) {
    
//     setPerformaInvoices([]);
//   } finally {
//     setIsLoading(false);
//   }
// };

// const PerformaFilterSection = ({ 
//   onSearch, 
//   financialYear, 
//   setFinancialYear, 
//   quarter, 
//   setQuarter, 
//   period, 
//   setPeriod, 
//   status, 
//   setStatus 
// }) => {
  
//   const quarterMonths = {
//     "Quarter 1 (Apr - Jun)": ["April", "May", "June"],
//     "Quarter 2 (Jul - Sep)": ["July", "August", "September"],
//     "Quarter 3 (Oct - Dec)": ["October", "November", "December"],
//     "Quarter 4 (Jan - Mar)": ["January", "February", "March"],
//   };

//   const filteredPeriods = quarterMonths[quarter] || [];

//   React.useEffect(() => {
//     if (filteredPeriods.length > 0 && !filteredPeriods.includes(period)) {
//       setPeriod(filteredPeriods[0]);
//     }
//   }, [quarter, filteredPeriods, period, setPeriod]);

//   React.useEffect(() => {
//     onSearch({ financialYear, quarter, period, status });
//   }, [financialYear, quarter, period, status, onSearch]);

//   const handleSearch = () => {
//     onSearch({ financialYear, quarter, period, status });
//   };

//   return (
//     <div className="IVV-00">
//       <div className="IVV-01">
      
//         <div className="IVV-02">
//           <label className="IVV-03">Financial Year</label>
//           <select
//             className="IVV-05"
//             value={financialYear}
//             onChange={(e) => setFinancialYear(e.target.value)}
//           >
//             <option value="2025-26">2025-26</option>
//             <option value="2024-25">2024-25</option>
//             <option value="2023-24">2023-24</option>
//             <option value="2022-23">2022-23</option>
//             <option value="2021-22">2021-22</option>
//           </select>
//         </div>

//         <div className="IVV-02">
//           <label className="IVV-03">Quarter</label>
//           <select
//             className="IVV-05"
//             value={quarter}
//             onChange={(e) => setQuarter(e.target.value)}
//           >
//             <option value="Quarter 1 (Apr - Jun)">Quarter 1 (Apr - Jun)</option>
//             <option value="Quarter 2 (Jul - Sep)">Quarter 2 (Jul - Sep)</option>
//             <option value="Quarter 3 (Oct - Dec)">Quarter 3 (Oct - Dec)</option>
//             <option value="Quarter 4 (Jan - Mar)">Quarter 4 (Jan - Mar)</option>
//           </select>
//         </div>

//         <div className="IVV-02">
//           <label className="IVV-03">Period</label>
//           <select
//             className="IVV-05"
//             value={period}
//             onChange={(e) => setPeriod(e.target.value)}
//           >
//             {filteredPeriods.map((m, i) => (
//               <option key={i} value={m}>{m}</option>
//             ))}
//           </select>
//         </div>

//         <div className="IVV-02">
//           <label className="IVV-03">Status</label>
//           <select
//             className="IVV-05"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             <option value="ACTIVE">ACTIVE</option>
//             <option value="CANCEL">CANCEL</option>
//             <option value="ALL INVOICES">ALL INVOICES</option>
//           </select>
//         </div>

//         <button className="IVV-06" onClick={handleSearch}>
//           SEARCH
//         </button>
//       </div>
//     </div>
//   );
// };

// const PerformaInvoicesDisplay = ({ 
//   invoices, 
//   searchQuery, 
//   onSearchChange, 
//   onAddPerformaInvoice, 
//   onEditInvoice,
//   onViewInvoice  
// }) => {
  
//   const [financialYear, setFinancialYear] = React.useState("2025-26");
//   const [quarter, setQuarter] = React.useState("Quarter 1 (Apr - Jun)");
//   const [period, setPeriod] = React.useState("April");
//   const [status, setStatus] = React.useState("ALL INVOICES");
//   const [appliedFilters, setAppliedFilters] = React.useState(null);

 
//   const handleFilterSearch = (filters) => {
 
//     setAppliedFilters(filters);
//   };

  
// const filteredPerformaInvoices = performaInvoices.filter((invoice) => {
//   const invoiceNumber = invoice.invoice_number || '';
//   const clientName = invoice.client_name || '';
//   const vendorName = invoice.vendor_name || '';
//   const amount = invoice.amount ? invoice.amount.toString() : '';
  
//   const matchesSearch = invoiceNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         amount.includes(searchQuery);

//   if (!appliedFilters) {
//     return matchesSearch;
//   }

//   const invoiceDate = new Date(invoice.date || invoice.created_on || invoice.invoice_date);
//   const invoiceMonth = invoiceDate.toLocaleString('en-US', { month: 'long' });
//   const invoiceYear = invoiceDate.getFullYear();

//   const [startYear] = appliedFilters.financialYear.split('-').map(y => parseInt(y));
//   const endYear = startYear + 1;

//   let matchesFinancialYear = false;
//   const invoiceMonthNum = invoiceDate.getMonth() + 1;
  
//   if (invoiceMonthNum >= 4 && invoiceMonthNum <= 12) {
//     matchesFinancialYear = invoiceYear === startYear;
//   } else if (invoiceMonthNum >= 1 && invoiceMonthNum <= 3) {
//     matchesFinancialYear = invoiceYear === endYear;
//   }

//   const quarterMonths = {
//     "Quarter 1 (Apr - Jun)": ["April", "May", "June"],
//     "Quarter 2 (Jul - Sep)": ["July", "August", "September"],
//     "Quarter 3 (Oct - Dec)": ["October", "November", "December"],
//     "Quarter 4 (Jan - Mar)": ["January", "February", "March"],
//   };

//   const matchesQuarter = quarterMonths[appliedFilters.quarter]?.includes(invoiceMonth) || false;
//   const matchesPeriod = invoiceMonth === appliedFilters.period;
//   const matchesStatus = appliedFilters.status === "ALL INVOICES" || 
//                         (invoice.status && invoice.status.toUpperCase() === appliedFilters.status);

//   return matchesSearch && matchesFinancialYear && matchesQuarter && matchesPeriod && matchesStatus;
// });


//   const handleSendEmail = (invoice) => {
  
 
// };

// const handleSendSMS = (invoice) => {
  
  
// };

//   return (
//     <div>
//       <div className="search-add-section">
//         <div className="search-container">
//           <div className="icon-wrapper"><FaSearch /></div>
//           <div className="Search-bar">
//             <input
//               type="text"
//               placeholder="        Search Performa Invoice Details"
//               value={searchQuery}
//               onChange={(e) => onSearchChange(e.target.value)}
//             />
//           </div>
//         </div>
//         <div className="add-button-container">
//           <button className="add-button" onClick={onAddPerformaInvoice}>
//             <FaPlus className="add-icon" />
//             Performa Invoice
//           </button>
//         </div>
//       </div>

//       <PerformaFilterSection 
//         onSearch={handleFilterSearch}
//         financialYear={financialYear}
//         setFinancialYear={setFinancialYear}
//         quarter={quarter}
//         setQuarter={setQuarter}
//         period={period}
//         setPeriod={setPeriod}
//         status={status}
//         setStatus={setStatus}
//       />
      
//      <section className="data-container">
//   <div className="header-row1">
//     <div className="column1"><span>Invoice Number</span></div>
//     <div className="column1"><span>Status</span></div>
//     <div className="column1"><span>Billed To</span></div>
//     <div className="column1"><span>Date</span></div>
//     <div className="column1"><span>Grand Total</span></div>
//     <div className="column1"><span>Actions</span></div>
//   </div>
//   <hr className="divider" />
//   {filteredPerformaInvoices.length === 0
//     ? <div className="no-data-message">{searchQuery ? `No invoices match "${searchQuery}"` : "No performa invoices found"}</div>
//     : <>
//       <div className="data-count-info">Showing {filteredPerformaInvoices.length} of {performaInvoices.length} performa invoices</div>
//       {filteredPerformaInvoices.map((invoice) => (
//         <div key={invoice.id} className="data-row">
//           <div className="column1"><span>{invoice.invoice_number}</span></div>
//           <div className="column1">
//             <span className={getStatusClassName(invoice.status)}>
//               {invoice.status || 'Active'}
//             </span>
//           </div>
//           <div className="column1"><span>{invoice.client_name}</span></div>
//           <div className="column1"><span>{new Date(invoice.date || invoice.created_on).toLocaleDateString()}</span></div>
//           <div className="column1"><span>₹{invoice.amount?.toLocaleString()}</span></div>
//           <div className="column1 actions">
//             <FaEye
//               className="action-icon view-icon"
//               title="View"
//               onClick={() => onViewInvoice(invoice)}  
//             />
//             <FaEdit
//               className="action-icon edit-icon"
//               title="Edit"
//               onClick={() => onEditInvoice(invoice)}
//             />
//             <FaEnvelope
//               className="action-icon mail-icon"
//               title="Send Email"
//               onClick={() => handleSendEmail(invoice)}
//             />
//             <FaSms
//               className="action-icon sms-icon"
//               title="Send SMS"
//               onClick={() => handleSendSMS(invoice)}
//             />
//           </div>
//         </div>
//       ))}
//     </>
//   }
// </section>
//     </div>
//   );
// };

// const handleMarkAllRead = (e) => {
//   e.stopPropagation();
//   const currentUserId = localStorage.getItem('currentUserId');
//   const updatedNotifications = notifications.map(notif => ({ ...notif, read: true }));
  
//   localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
//   setNotifications(updatedNotifications);
//   setUnreadCount(0);
// };

// const handleNotificationClick = (id) => {
//   const currentUserId = localStorage.getItem('currentUserId');
//   const updatedNotifications = notifications.map(notif => 
//     notif.id === id ? { ...notif, read: true } : notif
//   );
  
//   localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
//   setNotifications(updatedNotifications);
//   setUnreadCount(prev => Math.max(0, prev - 1));
// };



// const handleDeleteNotification = (id, e) => {
//   e.stopPropagation();
//   const currentUserId = localStorage.getItem('currentUserId');
//   const updatedNotifications = notifications.filter(notif => notif.id !== id);
  
//   localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
//   setNotifications(updatedNotifications);
  
//   const unread = updatedNotifications.filter(n => !n.read).length;
//   setUnreadCount(unread);
// };

// const handleClearAll = (e) => {
//   e.stopPropagation();
//   const currentUserId = localStorage.getItem('currentUserId');
//   localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify([]));
//   setNotifications([]);
//   setUnreadCount(0);
// };



// const getNotificationIcon = (type) => {
//   switch (type) {
//     case 'leave_approval':
//     case 'leave_approved':
//       return <FaCheckCircle className="notif-icon success" />;
//     case 'leave_rejected':
//       return <FaExclamationCircle className="notif-icon danger" />;
//     case 'project_assignment':
//       return <FaClipboardList className="notif-icon info" />;
//     case 'expense_approval':
//     case 'expense_approved':
//       return <FaCheckCircle className="notif-icon success" />;
//     case 'expense_rejected':
//       return <FaExclamationCircle className="notif-icon danger" />;
//     case 'employee_update':
//     case 'profile_updated_by_admin':
//       return <FaUserEdit className="notif-icon info" />;
//     default:
//       return <FaInfoCircle className="notif-icon info" />;
//   }
// };


// const getTimeAgo = (timestamp) => {
//   const now = new Date();
//   const notifTime = new Date(timestamp);
//   const diffMs = now - notifTime;
//   const diffMins = Math.floor(diffMs / 60000);
//   const diffHours = Math.floor(diffMs / 3600000);
//   const diffDays = Math.floor(diffMs / 86400000);

//   if (diffMins < 1) return 'Just now';
//   if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
//   if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
//   if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
//   return notifTime.toLocaleDateString();
// };

// const filteredNotifications = filterType === 'all' 
//   ? notifications 
//   : notifications.filter(n => n.type && n.type.toLowerCase().includes(filterType));


// const handleMarkNotificationAsRead = async (notificationId, type) => {
//   const role = getUserRole();
  
//   if (role !== 'EMPLOYEE') {
//     return;
//   }

//   try {
//     const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
    
//     await fetch(`${API_URL}/employees/mark_notification_read`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       mode: 'cors',
//       body: JSON.stringify({
//         notification_id: notificationId,
//         employee_id: currentUserId
//       })
//     });

//     setNotifications(prev => 
//       prev.map(n => n.id === notificationId ? {...n, read: true} : n)
//     );
//     setUnreadCount(prev => Math.max(0, prev - 1));

//   } catch (error) {
   
//   }
// };

//   const handleAddPerformaInvoice = () => {
//     setShowPerformaInvoiceForm(true);
//     setShowPerformaInvoices(false);
//   };

//   const handleBackFromPerformaInvoiceForm = async (shouldRefresh = false) => {
//     setShowPerformaInvoiceForm(false);
//     setShowPerformaInvoices(true);
    
//     if (shouldRefresh) {
//       await fetchPerformaInvoices();
//     }
//   };

// const handleEditPerformaInvoice = async (invoice) => {

  
//   const invoiceForEdit = {
//     ...invoice,
//     id: invoice.invoice_id || invoice.id,
//     invoice_id: invoice.invoice_id || invoice.id,
//     invoice_type: 'Performa Invoice',
//     performa_invoice_no: invoice.performa_invoice_no || invoice.invoice_no || invoice.invoice_number,
//     billed_name: invoice.billed_name || invoice.client_name,
//     billed_address: invoice.billed_address,
//     billed_gst_no: invoice.billed_gst_no,
//     billed_pan_no: invoice.billed_pan_no,
//     billed_state: invoice.billed_state,
//     status: invoice.status || 'Active',  
//     vendor_name: invoice.vendor_name,
//     po_no: invoice.po_no,
//     po_date: invoice.po_date,
//     ola_no: invoice.ola_no,
//     invoice_date: invoice.invoice_date,
//     line_items: invoice.line_items,
//     originalData: invoice
//   };
  

  
//   setSelectedPerformaInvoice(invoiceForEdit);
//   setShowUpdatePerformaInvoice(true);
//   setShowPerformaInvoices(false);
//   setShowUpdateTaxInvoice(false);
// };

//   const handleEditInvoice = async (invoice) => {
  
    
//     try {
//       const response = await fetch(`${API_URL}/taxinvoices/get_taxinvoice/${invoice.invoice_id || invoice.id}`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         mode: 'cors',
//       });

//       let invoiceData;
//       if (response.ok) {
//         const result = await response.json();
//         invoiceData = result.data || result;
//       } else {
      
//         invoiceData = invoice;
//       }

//       const invoiceForEdit = {
//         ...invoiceData,
//         id: invoiceData.invoice_id || invoiceData.id || invoice.id,
//         invoice_id: invoiceData.invoice_id || invoice.invoice_id || invoice.id,
//         invoice_type: 'Tax Invoice', 
//         invoice_no: invoiceData.invoice_no || invoiceData.invoice_number || invoice.invoice_no || invoice.invoice_number || '',
//         billed_name: invoiceData.billed_name || invoiceData.client_name || invoice.billed_name || invoice.client_name || '',
//         vendor_name: invoiceData.vendor_name || invoice.vendor_name || '',
//         description: invoiceData.description || invoice.description || '',
//         rate: parseFloat(invoiceData.rate || invoice.rate || 0),
//         quantity: parseFloat(invoiceData.quantity || invoice.quantity || 1),
//         gross_amount: parseFloat(invoiceData.gross_amount || invoice.gross_amount || 0),
//         igst_amount: parseFloat(invoiceData.igst_amount || invoice.igst_amount || 0),
//         cgst_amount: parseFloat(invoiceData.cgst_amount || invoice.cgst_amount || 0),
//         sgst_amount: parseFloat(invoiceData.sgst_amount || invoice.sgst_amount || 0),
//         grand_total: parseFloat(invoiceData.grand_total || invoiceData.amount || invoice.grand_total || invoice.amount || 0),
//         created_on: invoiceData.created_on || invoice.created_on || new Date().toISOString(),
//         updated_on: invoiceData.updated_on || invoice.updated_on || new Date().toISOString(),
//         status: invoiceData.status || invoice.status || 'Active',
//         originalData: invoiceData || invoice
//       };
      
     
      
//       setSelectedInvoice(invoiceForEdit);
//       setShowUpdateTaxInvoice(true);
//       setShowInvoices(false);
//       setShowUpdatePerformaInvoice(false); 
//       setShowReports(false);
//       setShowManageLeaves(false);
//       setShowLeaves(false);
//       setShowProjects(false);
//       setShowProjectsDropdown(false);
//       setShowEmployeesDropdown(false);
//       setShowClientsDropdown(false);
//       setShowInvoicesDropdown(false);
//       setShowProformaInvoice(false);
//       setShowTaxInvoice(false);
      
//     } catch (error) {
      
      
//       const invoiceForEdit = {
//         ...invoice,
//         id: invoice.invoice_id || invoice.id,
//         invoice_id: invoice.invoice_id || invoice.id,
//         invoice_type: 'Tax Invoice',
//         invoice_no: invoice.invoice_no || invoice.invoice_number || '',
//         billed_name: invoice.billed_name || invoice.client_name || '',
//         vendor_name: invoice.vendor_name || '',
//         description: invoice.description || '',
//         rate: parseFloat(invoice.rate || 0),
//         quantity: parseFloat(invoice.quantity || 1),
//         gross_amount: parseFloat(invoice.gross_amount || 0),
//         igst_amount: parseFloat(invoice.igst_amount || 0),
//         cgst_amount: parseFloat(invoice.cgst_amount || 0),
//         sgst_amount: parseFloat(invoice.sgst_amount || 0),
//         grand_total: parseFloat(invoice.grand_total || invoice.amount || 0),
//         originalData: invoice
//       };
      
//       setSelectedInvoice(invoiceForEdit);
//       setShowUpdateTaxInvoice(true);
//       setShowInvoices(false);
//       setShowUpdatePerformaInvoice(false);
//     }
//   };
// const handleBackFromUpdatePerformaInvoice = async () => {
//   setShowUpdatePerformaInvoice(false);
//   setSelectedPerformaInvoice(null);
//   setShowPerformaInvoices(true);
  
 
//   await fetchPerformaInvoices();
// };
//   const handleDeleteEmployee = async (employeeId) => {
//     const confirmDelete = window.confirm('Are you sure you want to mark this employee as Inactive?');
//     if (!confirmDelete) return;

//     try {
//       setIsLoading(true);
//       setErrorMessage("");

//       const response = await fetch(`${API_URL}/employees/delete_employees`, {
//         method: 'DELETE',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           employee_id: employeeId.toString()
//         }),
//       });

//       const result = await response.json();

//       if (response.ok && result.bool) {
//         alert(result.message || 'Employee marked as Inactive successfully!');
//         await fetchEmployees();
//       } else {
//         throw new Error(result.message || 'Failed to update employee status');
//       }
//     } catch (error) {
     
//       alert(`Failed to mark employee as Inactive: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const fetchInvoices = async () => {
//     setIsLoading(true);
//     setErrorMessage("");
    
//     try {
//       const response = await fetch(`${API_URL}/taxinvoices/get_taxinvoice`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         mode: 'cors',
//       });
    

      
//       if (!response.ok) {
//         const errorText = await response.text();
       
//         throw new Error(`HTTP ${response.status}: ${errorText}`);
//       }
      
//       const result = await response.json();
  
      
//       let invoicesData = [];
      
//       if (result.status === "success" && result.data) {
//         invoicesData = Array.isArray(result.data) ? result.data : [result.data];
//       } else if (Array.isArray(result)) {
//         invoicesData = result;
//       } else {
       
//         invoicesData = [];
//       }
      
    
      
//       const transformedInvoices = invoicesData.map(transformInvoiceData);
     
      
//       setInvoices(transformedInvoices);
      
//     } catch (error) {
      
      
//       if (error.name === 'TypeError' && error.message.includes('fetch')) {
//         setErrorMessage("Cannot connect to server. Please check if the backend is running and accessible.");
//       } else if (error.message.includes('CORS')) {
//         setErrorMessage("CORS error: Backend is not allowing requests from this origin.");
//       } else if (error.message.includes('404')) {
//         setErrorMessage("API endpoint not found. Check if the route '/v1/taxinvoices/get_taxinvoice' exists.");
//       }
      
//       setInvoices([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

// const transformInvoiceData = (apiInvoice) => {
 
  
//   const invoiceNumber = 
//     apiInvoice.invoice_no || 
//     apiInvoice.invoice_number || 
//     apiInvoice.performa_invoice_no ||  
//     apiInvoice.performainvoice_no ||
//     'N/A';
  
  
//   const invoiceStatus = apiInvoice.status;
 
  
//   const transformed = {
//     id: apiInvoice.invoice_id || apiInvoice.id,
//     invoice_id: apiInvoice.invoice_id,
//     invoice_number: invoiceNumber,
//     invoice_no: invoiceNumber,
//     client_name: apiInvoice.billed_name || apiInvoice.client_name,
//     billed_name: apiInvoice.billed_name || apiInvoice.client_name,
//     billed_address: apiInvoice.billed_address || apiInvoice.vendor_address || apiInvoice.client_address,
//     date: apiInvoice.created_on ? apiInvoice.created_on.split(' ')[0] : '',
//     amount: parseFloat(apiInvoice.grand_total || apiInvoice.amount || 0),
//     status: invoiceStatus, 
//     created_on: apiInvoice.created_on,
//     updated_on: apiInvoice.updated_on,
//     vendor_name: apiInvoice.vendor_name,
//     description: apiInvoice.description,
//     rate: apiInvoice.rate,
//     quantity: apiInvoice.quantity,
//     gross_amount: apiInvoice.gross_amount,
//     igst_amount: apiInvoice.igst_amount,
//     cgst_amount: apiInvoice.cgst_amount,
//     sgst_amount: apiInvoice.sgst_amount,
//     grand_total: apiInvoice.grand_total,
//     performa_invoice_no: apiInvoice.performa_invoice_no,
//     po_no: apiInvoice.po_no,
//     po_date: apiInvoice.po_date,
//     ola_no: apiInvoice.ola_no,
//     invoice_date: apiInvoice.invoice_date,
//     line_items: apiInvoice.line_items,
//     billed_gst_no: apiInvoice.billed_gst_no,
//     billed_pan_no: apiInvoice.billed_pan_no,
//     billed_state: apiInvoice.billed_state,
//     vendor_address: apiInvoice.vendor_address,
//     vendor_gst_no: apiInvoice.vendor_gst_no,
//     vendor_code: apiInvoice.vendor_code,
//     originalData: apiInvoice
//   };
  
  
  
//   return transformed;
// };


// const fetchEmployees = async () => {
//   setIsLoading(true);
//   setErrorMessage("");
  
//   try {
//     let url = `${API_URL}/employees/get_employees`;
//     const params = new URLSearchParams();
    
   
//     if (selectedEmployeeStatus && selectedEmployeeStatus !== "") {
//       params.append('status', selectedEmployeeStatus);
//     }
    
//     if (params.toString()) {
//       url += `?${params.toString()}`;
//     }
    
    
//     const response = await fetch(url);
    
//     if (response.ok) {
//       const result = await response.json();
    
      
//       let employeesData = [];
      
//       if (Array.isArray(result)) {
//         employeesData = result;
//       } else if (result.employees && Array.isArray(result.employees)) {
//         employeesData = result.employees;
//       }
      
//       const employeesWithImages = employeesData.map(employee => {
//   const employeeId = employee.employee_id || employee.id;
//   const storedImage = localStorage.getItem(`employee_${employeeId}_profileImage`);
//   return {
//     ...employee,
//     id: employeeId,
//     profileImage: storedImage,
//     avatar: storedImage || '👤'
//   };
// });


// employeesWithImages.sort((a, b) => {
//   const idA = parseInt(a.id) || 0;
//   const idB = parseInt(b.id) || 0;
//   return idA - idB;
// });


// setEmployees(employeesWithImages);
      
     
//       setEmployees(employeesWithImages);
      
//       const accessLevel = localStorage.getItem('accessLevel');
//       if (accessLevel === 'full') {
//         localStorage.setItem('allEmployeesData', JSON.stringify(employeesData));
//       }
//     } else {
    
//       setEmployees([]);
//     }
    
//   } catch (error) {
   
//     setEmployees([]);
//   } finally {
//     setIsLoading(false);
//   }
// };


//   const handlePerformaInvoicesPageClick = async () => {
 
    
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);
    
//     setShowReportSubmission(false);
// setShowReportSubmissionView(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//     setShowInvoices(false);
//     setShowPerformaInvoiceForm(false);
//     setShowUpdatePerformaInvoice(false);
    
//     setShowPerformaInvoices(true);

//     await fetchPerformaInvoices();
//   };

// const handleInvoicesPageClick = async () => {
   
    
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);

//     setShowReportSubmission(false);
// setShowReportSubmissionView(false);
    
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//     setShowPerformaInvoices(false);        
//     setShowPerformaInvoiceForm(false);     
//     setShowUpdatePerformaInvoice(false);   
    
//     setShowInvoices(true);

//     await fetchInvoices(); 
//   };
//   const handleBackFromInvoices = () => {
//     setShowInvoices(false);
//   };

//   const filteredInvoices = invoices.filter((invoice) => {
//     const invoiceNumber = invoice.invoice_number || '';
//     const clientName = invoice.client_name || '';
//     const vendorName = invoice.vendor_name || '';
//     const amount = invoice.amount ? invoice.amount.toString() : '';
    
//     return invoiceNumber.toLowerCase().includes(invoiceSearchQuery.toLowerCase()) ||
//           clientName.toLowerCase().includes(invoiceSearchQuery.toLowerCase()) ||
//           vendorName.toLowerCase().includes(invoiceSearchQuery.toLowerCase()) ||
//           amount.includes(invoiceSearchQuery);
//   });

// const handleEmployeesManagementClick = async () => {
//   setShowReportSubmission(false);
// setShowReportSubmissionView(false);
 
//   setShowManageLeaves(true);
//   setShowLeaves(false);
//   setShowProjects(false);
//   setShowReports(false);  
//   setShowProjectsDropdown(false);
//   setShowEmployeesDropdown(false);
//   setShowClientsDropdown(false);
//   setShowInvoicesDropdown(false);
//   setShowAddProject(false);
//   setShowExpenses(false);
//   setShowProjectUpdate(false);
//   setShowVendors(false);
//   setShowClients(false);
//   setShowAddVendor(false);
//   setShowAddClient(false);
//   setShowEditVendor(false);
//   setShowViewVendor(false);
//   setShowTaxInvoice(false);
//   setShowProformaInvoice(false);
//   setShowUpdateTaxInvoice(false);
//   setShowViewInvoice(false);
//   setShowPerformaInvoices(false);
//   setShowPerformaInvoiceForm(false);
//   setShowUpdatePerformaInvoice(false);
//   setShowEmployeeProject(false);

//   await fetchEmployees();
// };


// const resetAllViews = () => {
//    setShowReportSubmissionView(false);
//   setShowReportSubmission(false);
//   setShowManageLeaves(false);
//   setShowLeaves(false);
//   setShowProjects(false);
//   setShowReports(false);
//   setShowProjectsDropdown(false);
//   setShowEmployeesDropdown(false);
//   setShowClientsDropdown(false);
//   setShowInvoicesDropdown(false);
//   setShowAddProject(false);
//   setShowExpenses(false);
//   setShowProjectUpdate(false);
//   setShowVendors(false);
//   setShowClients(false);
//   setShowAddVendor(false);
//   setShowAddClient(false);
//   setShowEditVendor(false);
//   setShowViewVendor(false);
//   setShowTaxInvoice(false);
//   setShowProformaInvoice(false);
//   setShowUpdateTaxInvoice(false);
//   setShowViewInvoice(false);
//   setShowPerformaInvoices(false);
//   setShowPerformaInvoiceForm(false);
//   setShowUpdatePerformaInvoice(false);
//   setShowEmployeeProject(false);
//   setShowUserProfile(false);
//   setShowEditClient(false);
//   setShowViewClient(false);
//   setShowGetReports(false);
//   setShowReportsList(false);
// };

//   const handleInvoicesClick = () => {
//     setShowInvoicesDropdown(!showInvoicesDropdown);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
    
//     if (!showInvoicesDropdown) {
//       handleInvoicesPageClick();
//     }
//   };
  
//   const handleTaxInvoiceClick = () => {
//     setShowTaxInvoice(true);
//     setShowProformaInvoice(false);
//     setRefreshInvoiceNumber(Date.now());
//     setShowClients(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);  
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowInvoices(false);   
   
//   };

//   const handleProformaInvoiceClick = () => {
//     setShowProformaInvoice(true);
//     setShowTaxInvoice(false);
//     setShowClients(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
   
//   };

//   const handleBackFromProformaInvoice = async (shouldRefresh = false) => {
//     setShowProformaInvoice(false);
//     setShowInvoices(true);
    
//     if (shouldRefresh) {
//       await fetchPerformaInvoices();
//     }
//   };

//   const handleBackFromTaxInvoice = async (shouldRefresh = false) => {
//     setShowTaxInvoice(false);
//     setShowInvoices(true);
    
//     if (shouldRefresh) {
//       await fetchInvoices();
//     }
//   };

//   const handleLeavesClick = async () => {
   
    
//     setShowReportSubmission(false);
// setShowReportSubmissionView(false);
//     setShowLeaves(true);
//     setShowManageLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);

//     try {
//       await fetchEmployeeLeaves();
//     } catch (error) {
   
//       setErrorMessage("Failed to load leaves data");
//     }
//   };

//   const handleExpensesClick = () => {
//     setShowExpenses(true);
//     setShowLeaves(false);
//     setShowManageLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowAddProject(false);
//     setShowProjectUpdate(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);
//     setSelectedProject(null);
//   };

//   const handleAddVendor = () => {
//     setShowAddVendor(true);
//     setShowVendors(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowClients(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);
 
//   };

//   const handleAddClient = () => {
//     setShowAddClient(true);
//     setShowClients(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowAddVendor(false);
//     setShowTaxInvoice(false);
    
//   };

//   const handleBackFromAddVendor = () => {
//     setShowAddVendor(false);
//     setShowVendors(true);
//     fetchVendors();
//   };

//   const handleBackFromEditVendor = () => {
//     setShowEditVendor(false);
//     setSelectedVendor(null);
//     setShowVendors(true);
//     fetchVendors();
//   };

//   const handleBackFromViewVendor = () => {
//     setShowViewVendor(false);
//     setSelectedVendor(null);
//     setShowVendors(true);
//   };

//   const handleBackFromViewClient = () => {
//     setShowViewClient(false);
//     setSelectedClient(null);
//     setShowClients(true);
//   };
//   const ViewVendor = ({ vendorData, onBack }) => {
//     if (!vendorData) return null;
//     const hasValue = (value) => {
//       return value && value !== 'N/A' && value !== '' && value !== null && value !== undefined;
//     };
//     return (
//       <div className="user-profile-container">
//         <div className="user-profile-wrapper">
//           <div className="user-profile-header">
//             <button onClick={onBack} className="back-button">←</button>
//             <h2 className="user-profile-title">Vendor Details</h2>
//           </div>

//         {hasValue(vendorData.vendor_logo) && (
//     <div className="user-profile-image-section">
//       <img 
//         src={vendorData.vendor_logo} 
//         alt="Vendor Logo" 
//         className="user-profile-image"
//         onError={(e) => {
//           e.target.style.display = 'none';
//         }}
//       />
//       <h3 className="user-profile-name">{vendorData.vendor_name}</h3>
//     </div>
//   )}

//   {!hasValue(vendorData.vendor_logo) && (
//     <div className="user-profile-image-section">
//       <div className="user-profile-placeholder">
//         <FaUserTie style={{ fontSize: '48px' }} />
//       </div>
//       <h3 className="user-profile-name">{vendorData.vendor_name}</h3>
//     </div>
//   )}
//           <div className="user-profile-info">
//             <h4 className="user-profile-info-title">Basic Information</h4>
//             <div className="user-profile-info-grid">
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Vendor ID:</strong>
//                 <span className="info-value">{vendorData.vendor_id || vendorData.id || 'N/A'}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Vendor Name:</strong>
//                 <span className="info-value">{vendorData.vendor_name || 'N/A'}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Name:</strong>
//                 <span className="info-value">{vendorData.name || 'N/A'}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Contact Number:</strong>
//                 <span className="info-value">{vendorData.contact_number || 'N/A'}</span>
//               </div>
//               {vendorData.email && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Email:</strong>
//                   <span className="info-value">{vendorData.email}</span>
//                 </div>
//               )}
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Status:</strong>
//                 <span className={`info-value status-${(vendorData.status || 'Active').toLowerCase()}`}>
//                   {vendorData.status || 'Active'}
//                 </span>
//               </div>
//             </div>
//             <h4 className="user-profile-info-title">Address Information</h4>
//             <div className="user-profile-info-grid">
//               {(vendorData.vendor_address || vendorData.address) && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Address Line 1:</strong>
//                   <span className="info-value">{vendorData.vendor_address || vendorData.address}</span>
//                 </div>
//               )}
//               {(vendorData.vendor_address2 || vendorData.address2) && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Address Line 2:</strong>
//                   <span className="info-value">{vendorData.vendor_address2 || vendorData.address2}</span>
//                 </div>
//               )}
//               {(vendorData.vendor_state || vendorData.state) && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">State:</strong>
//                   <span className="info-value">{vendorData.vendor_state || vendorData.state}</span>
//                 </div>
//               )}
//             </div>

//             <h4 className="user-profile-info-title">Tax Information</h4>
//             <div className="user-profile-info-grid">
//               <div className="user-profile-info-row">
//                 <strong className="info-label">GST Number:</strong>
//                 <span className="info-value">{vendorData.vendor_gst_no || vendorData.gst_no || 'N/A'}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">PAN Number:</strong>
//                 <span className="info-value">{vendorData.vendor_pan_no || vendorData.pan_no || 'N/A'}</span>
//               </div>
//             </div>

//             <h4 className="user-profile-info-title">Banking Information</h4>
//             <div className="user-profile-info-grid">
//               {vendorData.bank_name && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Bank Name:</strong>
//                   <span className="info-value">{vendorData.bank_name}</span>
//                 </div>
//               )}
//               {vendorData.bank_account_number && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Account Number:</strong>
//                   <span className="info-value">{vendorData.bank_account_number}</span>
//                 </div>
//               )}
//               {vendorData.ifsc_code && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">IFSC Code:</strong>
//                   <span className="info-value">{vendorData.ifsc_code}</span>
//                 </div>
//               )}
//             </div>

//             <h4 className="user-profile-info-title">System Information</h4>
//             <div className="user-profile-info-grid">
//               {vendorData.created_on && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Created On:</strong>
//                   <span className="info-value">{new Date(vendorData.created_on).toLocaleDateString()}</span>
//                 </div>
//               )}
//               {vendorData.updated_on && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Last Updated:</strong>
//                   <span className="info-value">{new Date(vendorData.updated_on).toLocaleDateString()}</span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };
//   const ViewClient = ({ clientData, onBack }) => {
//     if (!clientData) return null;
//     const hasValue = (value) => {
//       return value && value !== 'N/A' && value !== '' && value !== null && value !== undefined;
//     };
//     return (
//       <div className="user-profile-container">
//         <div className="user-profile-wrapper">
//           <div className="user-profile-header">
//             <button onClick={onBack} className="back-button">←</button>
//             <h2 className="user-profile-title">Client Details</h2>
//           </div>
//           {hasValue(clientData.client_logo) && (
//             <div className="user-profile-image-section">
//               <img 
//                 src={clientData.client_logo} 
//                 alt="Client Logo" 
//                 className="user-profile-image"
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                 }}
//               />
//               <h3 className="user-profile-name">{clientData.client_name}</h3>
//             </div>
//           )}

//           {!hasValue(clientData.client_logo) && (
//             <div className="user-profile-image-section">
//               <div className="user-profile-placeholder">
//                 <FaUserTie style={{ fontSize: '48px' }} />
//               </div>
//               <h3 className="user-profile-name">{clientData.client_name}</h3>
//             </div>
//           )}  
//           <div className="user-profile-info">
//             <h4 className="user-profile-info-title">Basic Information</h4>
//             <div className="user-profile-info-grid">
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Client Name:</strong>
//                 <span className="info-value">{clientData.client_name || 'N/A'}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Name:</strong>
//                 <span className="info-value">{clientData.name || 'N/A'}</span>
//               </div>
              
//               {hasValue(clientData.client_id) && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Client ID:</strong>
//                   <span className="info-value">{clientData.client_id}</span>
//                 </div>
//               )}

//               <div className="user-profile-info-row">
//                 <strong className="info-label">GST NO:</strong>
//                 <span className="info-value">{clientData.gst_no || clientData.client_gst_no || 'N/A'}</span>
//               </div>

//               {hasValue(clientData.pan_no || clientData.client_pan_no) && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">PAN NO:</strong>
//                   <span className="info-value">{clientData.pan_no || clientData.client_pan_no}</span>
//                 </div>
//               )}

//               <div className="user-profile-info-row">
//                 <strong className="info-label">Contact Number:</strong>
//                 <span className="info-value">{clientData.contact_number || 'N/A'}</span>
//               </div>

//               {hasValue(clientData.email) && (
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Email:</strong>
//                   <span className="info-value">{clientData.email}</span>
//                 </div>
//               )}
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Status:</strong>
//                 <span className={`info-value status-${(clientData.status || 'Active').toLowerCase()}`}>
//                   {clientData.status || 'Active'}
//                 </span>
//               </div>
//             </div>
//           </div>
//           {(hasValue(clientData.client_address) || hasValue(clientData.address) || 
//             hasValue(clientData.client_address2) || hasValue(clientData.address2) || 
//             hasValue(clientData.state) || hasValue(clientData.client_state)) && (
//             <div className="user-profile-info">
//               <h4 className="user-profile-info-title">Address Information</h4>
//               <div className="user-profile-info-grid">
//                 {hasValue(clientData.client_address || clientData.address) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Address Line 1:</strong>
//                     <span className="info-value">{clientData.client_address || clientData.address}</span>
//                   </div>
//                 )}

//                 {hasValue(clientData.client_address2 || clientData.address2) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Address Line 2:</strong>
//                     <span className="info-value">{clientData.client_address2 || clientData.address2}</span>
//                   </div>
//                 )}

//                 {hasValue(clientData.state || clientData.client_state) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">State:</strong>
//                     <span className="info-value">{clientData.state || clientData.client_state}</span>
//                   </div>
//                 )}

//                 {hasValue(clientData.city) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">City:</strong>
//                     <span className="info-value">{clientData.city}</span>
//                   </div>
//                 )}

//                 {hasValue(clientData.pincode) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Pincode:</strong>
//                     <span className="info-value">{clientData.pincode}</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//           {(hasValue(clientData.bank_name) || hasValue(clientData.bank_account_number) || 
//             hasValue(clientData.ifsc_code)) && (
//             <div className="user-profile-info">
//               <h4 className="user-profile-info-title">Bank Details</h4>
//               <div className="user-profile-info-grid">
//                 {hasValue(clientData.bank_name) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Bank Name:</strong>
//                     <span className="info-value">{clientData.bank_name}</span>
//                   </div>
//                 )}

//                 {hasValue(clientData.bank_account_number) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Account Number:</strong>
//                     <span className="info-value">{clientData.bank_account_number}</span>
//                   </div>
//                 )}

//                 {hasValue(clientData.ifsc_code) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">IFSC Code:</strong>
//                     <span className="info-value">{clientData.ifsc_code}</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}     
//           {(hasValue(clientData.created_on) || hasValue(clientData.updated_on)) && (
//             <div className="user-profile-info">
//               <h4 className="user-profile-info-title">System Information</h4>
//               <div className="user-profile-info-grid">
//                 {hasValue(clientData.created_on) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Created On:</strong>
//                     <span className="info-value">
//                       {new Date(clientData.created_on).toLocaleDateString('en-IN', {
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric',
//                         hour: '2-digit',
//                         minute: '2-digit'
//                       })}
//                     </span>
//                   </div>
//                 )}
//                 {hasValue(clientData.updated_on) && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Last Updated:</strong>
//                     <span className="info-value">
//                       {new Date(clientData.updated_on).toLocaleDateString('en-IN', {
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric',
//                         hour: '2-digit',
//                         minute: '2-digit'
//                       })}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}     
//         </div>
//       </div>
//     );
//   };
//   const handleBackFromAddClient = () => {
//     setShowAddClient(false);
//     setShowClients(true);
//     fetchClients();
//   };
//   const handleBackFromLeaves = async () => {
//     setShowLeaves(false);
//     setShowManageLeaves(true); 
//     await fetchEmployees();
//   };

//   const handleVendorSubmit = (newVendorData) => {
    
    
//     setVendors(prevVendors => [
//       ...prevVendors,
//       newVendorData
//     ]);
    
//   };
//   const handleVendorUpdated = (updatedVendorData) => {
   
//     setVendors(prevVendors => 
//       prevVendors.map(vendor => 
//         vendor.id === updatedVendorData.id || vendor.vendor_id === updatedVendorData.vendor_id
//           ? updatedVendorData 
//           : vendor
//       )
//     );
   
//   };

//   const handleClientSubmit = (newClientData) => {
   
    
//     setClients(prevClients => [
//       ...prevClients,
//       newClientData
//     ]);
    
    
//   };

//   const handleCurrentEmployeeUpdate = (employeeData) => {
    
    
//     setCurrentUser(employeeData);
//     setUserName(employeeData.name || "User Name");
    
//     if (employeeData.profileImage) {
//       setProfileImage(employeeData.profileImage);
//       localStorage.setItem('currentUserProfileImage', employeeData.profileImage);
//     }
    
//     localStorage.setItem('currentUser', JSON.stringify(employeeData));
//     localStorage.setItem('currentUserName', employeeData.name);
//     localStorage.setItem('currentUserId', employeeData.id.toString());
//     localStorage.setItem('currentUserEmail', employeeData.email);
   
//   };
//   const handleProfileImageUpdate = (imageDataUrl, name) => {
//     setProfileImage(imageDataUrl);
//     setUserName(name || "User Name");
//     if (imageDataUrl) {
//       localStorage.setItem('currentUserProfileImage', imageDataUrl);
//       localStorage.setItem('currentUserName', name || "User Name");
//     }
//   };
//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };
//   const handleSearchChange = (value, setter) => {
//     setter(value);
//   };
//   const handleUploadClick = () => {
//     fileInputRef.current?.click();
//   };
//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const allowedTypes = [
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
//       'application/msword', 
//       'application/pdf',
//       'image/jpeg',
//       'image/png',
//       'image/jpg',
//       'text/plain',
//       'application/vnd.ms-excel', 
//       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
//     ];

//     if (!allowedTypes.includes(file.type)) {
//       alert('Please upload a valid file (Word, PDF, Excel, Image, or Text file)');
//       return;
//     }

//     if (file.size > 10 * 1024 * 1024) {
//       alert('File size must be less than 10MB');
//       return;
//     }

//     setIsUploading(true);
//     setErrorMessage("");

//     try {
//       const formData = new FormData();
//       formData.append('file', file);
//       formData.append('project_name', file.name.split('.')[0]);
//       formData.append('location', 'Unknown'); 
//       formData.append('status', 'Uploaded'); 
//       formData.append('upload_date', new Date().toISOString().split('T')[0]);

//       const response = await fetch(`${API_URL}/reports/upload`, {
//         method: 'POST',
//         body: formData,
//         mode: 'cors',
//       });

//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(`Upload failed: ${response.status} - ${errorData.message || response.statusText}`);
//       }

//       const result = await response.json();
      

//       setUploadSuccess(true);
//       setTimeout(() => setUploadSuccess(false), 3000);

//       if (showReports) {
//         await fetchReports();
//       }

//       event.target.value = '';

//     } catch (error) {
     
      
//       const newReport = {
//         id: Date.now(),
//         name: file.name.split('.')[0],
//         blocks: "1 Block",
//         status: "Uploaded",
//         location: "Document Upload",
//         project_name: file.name.split('.')[0],
//         no_of_blocks: "1",
//         upload_date: new Date().toISOString().split('T')[0],
//         file_type: file.type,
//         file_size: (file.size / 1024).toFixed(2) + ' KB'
//       };

//       setReports(prevReports => [newReport, ...prevReports]);
//       setUploadSuccess(true);
//       setTimeout(() => setUploadSuccess(false), 3000);
      
//       event.target.value = '';
//     } finally {
//       setIsUploading(false);
//     }
//   };

// const filteredReports = reports.filter((report) => {
//   const reportName = report.project_name || report.name || '';
//   const reportLocation = report.location || '';
//   const reportStatus = report.status || '';
  
//   const matchesSearch = reportName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                       reportLocation.toLowerCase().includes(searchQuery.toLowerCase());
//   const matchesStatus = selectedProjectStatus === "" || reportStatus === selectedProjectStatus;
  
//   const role = getUserRole();
//   if (role === 'EMPLOYEE') {
    
//     if (assignedProjectIds.length === 0) {
//       return false;
//     }
    
//     const matchesAssignment = assignedProjectIds.includes(report.id || report.project_id);
//     return matchesSearch && matchesStatus && matchesAssignment;
//   }
  
//   return matchesSearch && matchesStatus;
// });
  
//   const filteredProjects = projects.filter((project) => {
//     const matchesSearch = project.name?.toLowerCase().includes(searchQuery.toLowerCase()) || false;
//     const matchesStatus = selectedProjectStatus === "" || project.status === selectedProjectStatus;
//     return matchesSearch && matchesStatus;
//   });

//   const filteredVendors = vendors.filter((vendor) => {
//     const vendorName = vendor.vendor_name || '';
//     const gst_no = vendor.gst_no || '';
//     const contact_number = vendor.contact_number || '';
    
//     const matchesSearch = vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           gst_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           contact_number.toLowerCase().includes(searchQuery.toLowerCase());
    
//     const matchesStatus = !selectedVendorStatus || vendor.status === selectedVendorStatus;
    
//     return matchesSearch && matchesStatus;
//   });
//   const filteredClients = clients.filter((client) => {
//     const clientName = client.client_name || '';
//     const gst_no = client.gst_no || '';
//     const contact_number = client.contact_number || '';
//     return clientName.toLowerCase().includes(clientSearchQuery.toLowerCase()) ||
//           gst_no.toLowerCase().includes(clientSearchQuery.toLowerCase()) ||
//           contact_number.toLowerCase().includes(clientSearchQuery.toLowerCase());
//   });
// const fetchReports = async () => {
//   setIsLoading(true);
//   setErrorMessage("");
  
//   try {
//     const role = getUserRole();
//     const isEmployeeRole = role === 'EMPLOYEE';
//     let employeeProjectIds = [];
//     if (isEmployeeRole) {
//       employeeProjectIds = await fetchEmployeeAssignedProjects();
//     }
//     const response = await fetch(`${API_URL}/projects/get_projects`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       mode: 'cors',
//       credentials: 'same-origin',
//     });
    
//     if (!response.ok) {
//       const errorData = await response.json().catch(() => ({}));
//       throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
//     }
//     const result = await response.json();
   
//     let reportsData = [];
//     if (Array.isArray(result)) {
//       reportsData = result;
//     } else if (result.data && Array.isArray(result.data)) {
//       reportsData = result.data;
//     } else if (result.projects && Array.isArray(result.projects)) {
//       reportsData = result.projects;
//     } else if (result.project_employees && Array.isArray(result.project_employees)) {
//       reportsData = result.project_employees;
//     }
    
//     let filteredReportsData = reportsData;
//     if (isEmployeeRole) {
//       if (employeeProjectIds.length === 0) {
       
//         filteredReportsData = [];
//       } else {
      
//         filteredReportsData = reportsData.filter(report => 
//           employeeProjectIds.includes(report.project_id || report.id)
//         );
//       }
      
//     }
    
//     const transformedReports = filteredReportsData.map(transformReportData);
  
    
//     setReports(transformedReports);
    
//   } catch (error) {
   
//     if (error.message.includes("Failed to fetch")) {
//       setErrorMessage(`Cannot connect to server. Please check if the backend is running on ${API_URL}`);
//     }
//   } finally {
//     setIsLoading(false);
//   }
// };


//   const fetchProjectReports = async (projectId) => {
//     setIsLoading(true);
//     setErrorMessage("");
    
//     try {
//       const response = await fetch(`${API_URL}/test_report/get_test_reports?project_id=${projectId}`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         mode: 'cors',
//       });
      
//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
//       }
      
//       const result = await response.json();
     
      
//       let reportsData = [];
      
//       if (Array.isArray(result)) {
//         reportsData = result;
//       } else if (result.data && Array.isArray(result.data)) {
//         reportsData = result.data;
//       } else if (result.reports && Array.isArray(result.reports)) {
//         reportsData = result.reports;
//       } else if (result.test_reports && Array.isArray(result.test_reports)) {
//         reportsData = result.test_reports;
//       }
      
     
      
    
//       setProjectReports(reportsData);
      
//       return reportsData;
      
//     } catch (error) {
     
//       setErrorMessage(`Failed to load project reports: ${error.message}`);
//       setProjectReports([]);
//       return [];
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const transformProjectData = (apiProject) => {
    
    
//     return {
//       id: apiProject.project_id,
//       project_id: apiProject.project_id,
//       name: apiProject.project_name,
//       project_name: apiProject.project_name,
//       blocks: apiProject.no_of_blocks ? `${apiProject.no_of_blocks} Blocks` : "N/A Blocks",
//       status: apiProject.status,
//       location: apiProject.location,
//       startDate: apiProject.starting_date ? apiProject.starting_date.split('T')[0] : '',
//       starting_date: apiProject.starting_date,
//       vendor: apiProject.vendor_id,
//       vendor_id: apiProject.vendor_id,
//       vendorName: apiProject.vendor_name,
//       vendor_name: apiProject.vendor_name,
//       client: apiProject.client_id,
//       client_id: apiProject.client_id,
//       clientName: apiProject.client_name,
//       client_name: apiProject.client_name,
//       quotation: apiProject.amount_in_rupees,
//       amount_in_rupees: apiProject.amount_in_rupees,
//       city: apiProject.city || '',
//       pincode: apiProject.pincode || '',
//       equipment: apiProject.equipment || '',
//       originalData: apiProject,
//       no_of_blocks: apiProject.no_of_blocks,
//       numberOfBlocks: apiProject.no_of_blocks
//     };
//   };

//   const transformReportData = (apiReport) => {
  
    
//     return {
//       id: apiReport.project_id || apiReport.id,
//       name: apiReport.project_name || apiReport.name,
//       blocks: apiReport.no_of_blocks ? `${apiReport.no_of_blocks} Blocks` : "N/A Blocks",
//       status: apiReport.status || 'Pipelined',
//       location: apiReport.location || 'Unknown Location',
//       startDate: apiReport.starting_date ? apiReport.starting_date.split('T')[0] : '',
//       vendor: apiReport.vendor_id,
//       client: apiReport.client_id,
//       quotation: apiReport.amount_in_rupees,
//           city: apiReport.city || '',
//           pincode: apiReport.pincode || '',
//           equipment: apiReport.equipment || '',
//           originalData: apiReport,
//           project_name: apiReport.project_name,
//           no_of_blocks: apiReport.no_of_blocks,
//           numberOfBlocks: apiReport.no_of_blocks
//         };
//       };

//   const transformVendorData = (apiVendor) => {
    
    
//     return {
//       id: apiVendor.vendor_id,
//       vendor_id: apiVendor.vendor_id,
//       vendor_name: apiVendor.vendor_name,
//       vendor_address: apiVendor.vendor_address || apiVendor.address,
//       vendor_address2: apiVendor.vendor_address2 || apiVendor.address2,
//       vendor_gst_no: apiVendor.vendor_gst_no || apiVendor.gst_no, 
//       vendor_pan_no: apiVendor.vendor_pan_no || apiVendor.pan_no, 
//       vendor_state: apiVendor.vendor_state || apiVendor.state, 
//       gst_no: apiVendor.gst_no || apiVendor.vendor_gst_no, 
//       name: apiVendor.name,
//       email: apiVendor.email,
//       contact_number: apiVendor.contact_number,
//       vendor_logo: apiVendor.vendor_logo,
//       status: apiVendor.status || 'Active',
//       bank_name: apiVendor.bank_name,
//       bank_account_number: apiVendor.bank_account_number,
//       ifsc_code: apiVendor.ifsc_code,
//       pan_no: apiVendor.pan_no || apiVendor.vendor_pan_no,
//       state: apiVendor.state || apiVendor.vendor_state,
//       address: apiVendor.address || apiVendor.vendor_address,
//       created_on: apiVendor.created_on,
//       updated_on: apiVendor.updated_on,
//       originalData: apiVendor
//     };
//   };

//   const transformLeaveData = (apiLeave) => {
 
    
//     return {
//       id: apiLeave.leave_id,
//       leave_id: apiLeave.leave_id,
//       employee_id: apiLeave.employee_id,
//       reason: apiLeave.reason,
//       total_days: apiLeave.total_days,
//       leave_type: apiLeave.leave_type,
//       from_date: apiLeave.from_date,
//       to_date: apiLeave.to_date,
//       originalData: apiLeave
//     };
//   };

//   const transformClientData = (apiClient) => {
   
    
//     return {
//       id: apiClient.client_id,
//       client_id: apiClient.client_id,
//       client_name: apiClient.client_name,
//       client_address: apiClient.client_address || apiClient.address,
//       client_address2: apiClient.client_address2 || apiClient.address2,
//       client_gst_no: apiClient.client_gst_no || apiClient.gst_no,
//       client_pan_no: apiClient.client_pan_no || apiClient.pan_no,
//       client_state: apiClient.client_state || apiClient.state,
//       gst_no: apiClient.gst_no || apiClient.client_gst_no,
//       name: apiClient.name,
//       email: apiClient.email,
//       contact_number: apiClient.contact_number,
//       client_logo: apiClient.client_logo,
//       status: apiClient.status || 'Active',
//       bank_name: apiClient.bank_name,
//       bank_account_number: apiClient.bank_account_number,
//       ifsc_code: apiClient.ifsc_code,
//       pan_no: apiClient.pan_no || apiClient.client_pan_no,
//       state: apiClient.state || apiClient.client_state,
//       address: apiClient.address || apiClient.client_address,
//       created_on: apiClient.created_on,
//       updated_on: apiClient.updated_on,
//       originalData: apiClient
//     };
//   };
//   const fetchVendors = async () => {
//     setIsLoading(true);
//     setErrorMessage("");
//     try {
//       let url = `${API_URL}/vendors/get_vendor`;
//       const params = new URLSearchParams();
      
//       if (selectedVendorStatus) {
//         params.append('status', selectedVendorStatus);
//       }
      
//       if (params.toString()) {
//         url += `?${params.toString()}`;
//       }
      
//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         mode: 'cors',
//       });
      
//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(`Vendors API error: ${response.status} - ${errorData.message || response.statusText}`);
//       }
      
//       const result = await response.json();
      
      
//       let vendorsData = [];
      
//       if (result.status === "success" && result.data) {
//         vendorsData = Array.isArray(result.data) ? result.data : [result.data];
//       } else if (Array.isArray(result)) {
//         vendorsData = result;
//       } else if (result.vendors && Array.isArray(result.vendors)) {
//         vendorsData = result.vendors;
//       }
      
  
      
//       const transformedVendors = vendorsData.map(transformVendorData);
     
      
//       setVendors(transformedVendors);
      
//     } catch (error) {
      
//       if (error.message.includes("Failed to fetch")) {
//         setErrorMessage("Cannot connect to server. Please check if the backend is running on ${API_URL}");
//       } 
      
//       setVendors([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchClients = async () => {
//     setIsLoading(true);
//     setErrorMessage("");
    
//     try {
//       const response = await fetch(`${API_URL}/clients/get_client`, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         mode: 'cors',
//       });
      
//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(`Clients API error: ${response.status} - ${errorData.message || response.statusText}`);
//       }
      
//       const result = await response.json();
     
      
//       let clientsData = [];
      
//       if (Array.isArray(result)) {
//         clientsData = result;
//       } else if (result.data && Array.isArray(result.data)) {
//         clientsData = result.data;
//       } else if (result.clients && Array.isArray(result.clients)) {
//         clientsData = result.clients;
//       }
      
     
      
//       const transformedClients = clientsData.map(transformClientData);
      
      
//       setClients(transformedClients);
      
//     } catch (error) {
  
//       if (error.message.includes("Failed to fetch")) {
//         setErrorMessage("Cannot connect to server. Please check if the backend is running on ${API_URL}");
//       } 
      
//       setClients([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleProjectsClick = async () => {
//   setShowProjectsDropdown(!showProjectsDropdown);
//   setShowEmployeesDropdown(false);
//   setShowClientsDropdown(false);
//   setShowInvoicesDropdown(false);
//   setShowReportSubmission(false);
// setShowReportSubmissionView(false);
  
//   if (!showProjectsDropdown) {
//     setShowInvoices(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowReports(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//     setShowAddProject(false);
//     setShowUserProfile(false);
//     setShowPerformaInvoices(false);
//     setShowPerformaInvoiceForm(false);
//     setShowUpdatePerformaInvoice(false);
    
//     setShowProjects(true);
//     setSelectedProjectStatus("");

//     const role = getUserRole();
//     if (role === 'EMPLOYEE') {
//       await fetchEmployeeAssignedProjects();
//     }
    
//     await fetchProjects();
//   }
// };
//   const handleVendorsClick = async () => {
    
          
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);

//     setShowReportSubmission(false);
// setShowReportSubmissionView(false);
    
//     setShowInvoices(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//     setShowPerformaInvoices(false);        
//     setShowPerformaInvoiceForm(false);     
//     setShowUpdatePerformaInvoice(false);   
    
//     setShowVendors(true);
//     setSelectedVendorStatus("Active");

//     await fetchVendors();
//   };

//   const handleClientsPageClick = async () => {
   
    
//     setShowClients(true);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);

//     await fetchClients();
//   };


//   const fetchProjects = async () => {
//   setIsLoading(true);
//   setErrorMessage("");
  
//   try {
//     const role = getUserRole();
//     const isEmployeeRole = role === 'EMPLOYEE';
//     let employeeProjectIds = [];
    
//     if (isEmployeeRole) {
//       employeeProjectIds = await fetchEmployeeAssignedProjects();
//     }

//     const response = await fetch(`${API_URL}/projects/get_projects`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       mode: 'cors',
//       credentials: 'same-origin',
//     });
    
//     if (!response.ok) {
//       const errorData = await response.json().catch(() => ({}));
//       throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
//     }
    
//     const result = await response.json();
  
    
//     let projectsData = [];
    
//     if (Array.isArray(result)) {
//       projectsData = result;
//     } else if (result.data && Array.isArray(result.data)) {
//       projectsData = result.data;
//     } else if (result.projects && Array.isArray(result.projects)) {
//       projectsData = result.projects;
//     } else if (result.project_employees && Array.isArray(result.project_employees)) {
//       projectsData = result.project_employees;
//     }
    
   

//     await fetchVendors();
//     await fetchClients();

//     const enrichedProjects = projectsData.map(project => {
//       const vendor = vendors.find(v => v.vendor_id === project.vendor_id || v.id === project.vendor_id);
//       const client = clients.find(c => c.client_id === project.client_id || c.id === project.client_id);
      
//       return {
//         ...project,
//         vendor_name: vendor?.vendor_name || 'Not specified',
//         client_name: client?.client_name || 'Not specified'
//       };
//     });
    
//     let filteredProjectsData = enrichedProjects;
    
//     if (isEmployeeRole) {
//       if (employeeProjectIds.length === 0) {
      
//         filteredProjectsData = [];
//       } else {
//         filteredProjectsData = enrichedProjects.filter(project => 
//           employeeProjectIds.includes(project.project_id || project.id)
//         );
       
//       }
//     }
    
//     const transformedProjects = filteredProjectsData.map(transformProjectData);

    
//     setProjects(transformedProjects);
    
//   } catch (error) {
   
//     if (error.message.includes("Failed to fetch")) {
//       setErrorMessage(`Cannot connect to server. Please check if the backend is running on ${API_URL}`);
//     } 
    
//     setProjects([]);
//   } finally {
//     setIsLoading(false);
//   }
// };


// const handleReportsClick = async () => {
//   setShowProjectsDropdown(false);
//   setShowEmployeesDropdown(false);
//   setShowClientsDropdown(false);
//   setShowInvoicesDropdown(false);

//   setShowReportSubmission(false);
// setShowReportSubmissionView(false);
  
//   setShowManageLeaves(false);
//   setShowLeaves(false);
//   setShowProjects(false);
//   setShowAddProject(false);
//   setShowExpenses(false);
//   setShowProjectUpdate(false);
//   setShowUserProfile(false);
//   setShowVendors(false);
//   setShowClients(false);
//   setShowAddVendor(false);
//   setShowAddClient(false);
//   setShowEditVendor(false);
//   setShowViewVendor(false);
//   setShowEditClient(false);
//   setShowViewClient(false);
//   setShowTaxInvoice(false);
//   setShowProformaInvoice(false);
//   setShowInvoices(false);
//   setShowUpdateTaxInvoice(false);
//   setShowViewInvoice(false);
//   setShowReportsList(false);
//   setSelectedProjectForReports(null);
//   setShowPerformaInvoices(false);
//   setShowPerformaInvoiceForm(false);
//   setShowUpdatePerformaInvoice(false);
  
//   setShowReports(true);
//   setSelectedProjectStatus("");

//   const role = getUserRole();
//   if (role === 'EMPLOYEE') {
   
//     await fetchEmployeeAssignedProjects();
//   }
  
//   await fetchReports();
// };
  
//   const handleBackFromManageLeaves = () => {
//     setShowManageLeaves(false);
//     setShowReports(true);
//   };


//   const sendLeaveApprovalNotification = (leave, approverName) => {
//   const notification = {
//     id: Date.now(),
//     type: 'leave_approved',
//     message: `Your ${leave.leave_type || 'leave'} request from ${new Date(leave.from_date).toLocaleDateString()} to ${new Date(leave.to_date).toLocaleDateString()} has been approved`,
//     details: {
//       approver: approverName,
//       leaveType: leave.leave_type,
//       fromDate: leave.from_date,
//       toDate: leave.to_date,
//       totalDays: leave.total_days
//     },
//     timestamp: new Date().toISOString(),
//     read: false
//   };

//   const existingNotifications = JSON.parse(localStorage.getItem(`notifications_${leave.employee_id}`) || '[]');
//   existingNotifications.unshift(notification);
//   localStorage.setItem(`notifications_${leave.employee_id}`, JSON.stringify(existingNotifications));
  
//   window.dispatchEvent(new Event('notificationUpdate'));
// };

//   const handleBackFromAddProject = () => {
//     setShowAddProject(false);
//     setShowProjects(true);
    
//     fetchProjects();
//   };

//   const handleBackFromExpenses = () => {
//     setShowExpenses(false);
//     setSelectedProject(null);
//     setShowProjects(true); 
//   };

//   const handleBackFromProjectUpdate = async () => {
//     setShowProjectUpdate(false);
//     setProjectToUpdate(null);
//     setShowProjects(true);
    
//     await fetchProjects();
//   };

//   const handleBackFromVendors = () => {
//     setShowVendors(false);
//     setShowReports(true); 
//   };

//   const handleBackFromClients = () => {
//     setShowClients(false);
//     setShowReports(true); 
//   };

//   const handleProjectStatusClick = (status) => {
//     setSelectedProjectStatus(status);
//     setShowProjectsDropdown(false);
    
//     if (!showProjects) {
//       setShowProjects(true);
//       setShowReports(false);
//       setShowManageLeaves(false);
//       setShowLeaves(false);
//       setShowAddProject(false);
//       setShowExpenses(false);
//       setShowProjectUpdate(false);
//       setShowVendors(false);
//       setShowClients(false);
//       setShowInvoices(false);
//       setShowTaxInvoice(false);
//       setShowProformaInvoice(false);
//       setShowUpdateTaxInvoice(false);
//     }
//   };

//   const handleAddProject = () => {
//     setShowAddProject(true);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);
    
//   };

//   const handleProjectSubmit = (newProjectData) => {
  
    
//     const transformedNewProject = transformProjectData(newProjectData);
    
//     setProjects(prevProjects => [
//       ...prevProjects,
//       transformedNewProject
//     ]);
    

//   };

//   const handleDeleteProject = async (projectId) => {
//     setProjects(prevProjects => prevProjects.filter(project => project.id !== projectId));
    
//   };

//   const handleUpdateProject = (project) => {
   
//     setProjectToUpdate(project);
//     setShowProjectUpdate(true);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);
//   };

//   const handleProjectUpdateSubmit = async (updatedProjectData) => {
    
    
//     setProjects(prevProjects => 
//       prevProjects.map(project => 
//         project.id === updatedProjectData.id ? updatedProjectData : project
//       )
//     );
    
  
    
//     handleBackFromProjectUpdate();
    
//     await fetchProjects();
//   };
//   const handleProjectClick = async (project) => {
  
    
//     try {
//       const projectExpenses = await fetchProjectExpenses(project.id);
      
//       const projectWithExpenses = {
//         ...project,
//         expenses: projectExpenses
//       };
      
//       setSelectedProject(projectWithExpenses);
//       setShowExpenses(true);
//       setShowProjects(false);
//       setShowReports(false);
//       setShowManageLeaves(false);
//       setShowLeaves(false);
//       setShowAddProject(false);
//       setShowProjectUpdate(false);
//       setShowUserProfile(false);
//       setShowVendors(false);
//       setShowClients(false);
//       setShowAddVendor(false);
//       setShowAddClient(false);
//       setShowEditVendor(false);
//       setShowViewVendor(false);
//       setShowTaxInvoice(false);
//     } catch (error) {
      
//       setSelectedProject(project);
//       setShowExpenses(true);
//       setShowProjects(false);
//     }
//   };

//   const handleEditClient = (client) => {
  
    
//     const clientForEdit = {
//       ...client,
//       id: client.id || client.client_id,
//       client_id: client.client_id || client.id,
//       client_name: client.client_name || '',
//       gst_no: client.gst_no || '',
//       contact_number: client.contact_number || '',
//       client_logo: client.client_logo || null,
//       created_on: client.created_on,
//       updated_on: client.updated_on,
//       originalData: client.originalData || client
//     };
    
   
    
//     setSelectedClient(clientForEdit);
//     setShowEditClient(true);
//     setShowClients(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//   };

//   const handleViewProfile = () => {
//     setShowUserProfile(true);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowTaxInvoice(false);
//     setShowProfileMenu(false);
//   };



//   const handleViewProjectReports = async (project) => {
   
    

//     const projectWithId = {
//       ...project,
//       project_id: project.id || project.project_id,
//       id: project.id || project.project_id,
//       project_name: project.project_name || project.name,
//       name: project.project_name || project.name,
//       location: project.location,
//       client_name: project.client_name || project.clientName,
//       vendor_name: project.vendor_name || project.vendorName,
//       status: project.status,
//       no_of_blocks: project.no_of_blocks || project.numberOfBlocks
//     };
    
   
//     setSelectedProjectForReports(projectWithId);
//     setShowGetReports(true);
//     setShowReportsList(false);
//     setShowReports(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowInvoices(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//   };
//   const handleBackFromGetReports = () => {
//     setShowGetReports(false);
//     setSelectedProjectForReports(null);
//     setProjectReports([]);
//     setShowReports(true);
//   };
//   const handleLogout = () => {
//     localStorage.removeItem('currentUser');
//     localStorage.removeItem('currentUserEmail');
//     localStorage.removeItem('currentUserName');
//     localStorage.removeItem('currentUserId');
//     localStorage.removeItem('currentUserProfileImage');
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('currentUserRole');
//     localStorage.removeItem('accessLevel');  
//     localStorage.removeItem('allEmployeesData');  
    
//     if (onLogout) {
//       onLogout();
//     }
//   };
//   const handleBackFromReportsList = () => {
//     setShowReportsList(false);
//     setSelectedProjectForReports(null);
//     setProjectReports([]);  
//     setShowReports(true);
//   };

//   const handleBackFromProfile = () => {
//     setShowUserProfile(false);
//     setShowManageLeaves(true);
//   };

//   const getCurrentPageTitle = () => {
//       if (showReportSubmission) return "Report Submission";
//     if (showGetReports) return "Reports / Test Reports"; 
//     if (showReportsList) return "Reports / Project Details"; 
//     if (showUserProfile) return "User Profile";
//     if (showManageLeaves) return "Employees";
//     if (showLeaves) return "Employees / Leaves";

//     if (showPerformaInvoices) return "Performa Invoices";
//   if (showPerformaInvoiceForm) return "Add Invoice /Performa Invoice";
//   if (showUpdatePerformaInvoice) return "Performa Invoice / Update Performa Invoice";
//     if (showProjects) {
//       const baseTitle = "Projects";
//       if (selectedProjectStatus) {
//         return `${baseTitle} / ${selectedProjectStatus}`;
//       }
//       return baseTitle;
//     }
//     if (showAddProject) return "Projects";
//     if (showVendors) return "Vendors";
//     if (showClients) return "Clients";
//     if (showAddVendor) return "Vendors ";
//     if (showAddClient) return "Clients ";
//     if (showEditVendor) return "Vendors ";
//     if (showEditClient) return "Clients ";
//     if (showViewVendor) return "Vendors ";
//     if (showInvoices) return "Tax Invoices";
//     if (showTaxInvoice) return "Add Invoice / Tax Invoice";
//     if (showProformaInvoice) return "Proforma Invoice";
//     if (showUpdateTaxInvoice) return "Tax Invoices / Update Tax Invoice";
//     if (showProjectUpdate && projectToUpdate) {
//       const projectName = projectToUpdate.name || "Unknown Project";
//       return `Projects `;
//     }
//     if (showExpenses && selectedProject) {
//       const projectName = selectedProject.project_name || selectedProject.name || "Unknown Project";
//       return `Projects`;
//     }
//     const baseTitle = "Reports";
//     if (selectedProjectStatus) {
//       return `${baseTitle} / ${selectedProjectStatus}`;
//     }
//     return baseTitle;
//   };

//   const handleEmployeeAdded = (newEmployee) => {
//     if (newEmployee.profileImage) {
//       localStorage.setItem(`employee_${newEmployee.id}_profileImage`, newEmployee.profileImage);
//     }
    
//     setEmployees(prevEmployees => [...prevEmployees, newEmployee]);
    
//     const currentUserId = localStorage.getItem('currentUserId');
//     if (currentUserId && parseInt(currentUserId) === newEmployee.id) {
//       handleProfileImageUpdate(newEmployee.profileImage, newEmployee.name);
//     }
//   };

//   const handleEmployeeUpdated = (updatedEmployee) => {
//     if (updatedEmployee.profileImage) {
//       localStorage.setItem(`employee_${updatedEmployee.id}_profileImage`, updatedEmployee.profileImage);
//     }
//     if (!canEditEmployee(updatedEmployee.id)) {
//       alert('You do not have permission to edit this employee');
//       return;
//     }
    
//     setEmployees(prevEmployees => 
//       prevEmployees.map(emp => 
//         emp.id === updatedEmployee.id ? updatedEmployee : emp
//       )
//     );
    
//     const currentUserId = localStorage.getItem('currentUserId');
//     if (currentUserId && parseInt(currentUserId) === updatedEmployee.id) {
//       handleProfileImageUpdate(updatedEmployee.profileImage, updatedEmployee.name);
//     }
//   };

//   const handleViewVendor = (vendor) => {
    
//     setSelectedVendor(vendor);
//     setShowViewVendor(true);
//     setShowVendors(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//     setShowTaxInvoice(false);
//     setShowProformaInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowViewInvoice(false);
//     setShowInvoices(false);
//   };

//   const handleEditVendor = (vendor) => {
  
//     setSelectedVendor(vendor);
//     setShowEditVendor(true);
//     setShowVendors(false);
//     setShowViewVendor(false);
//   };

// const handleViewInvoice = (invoice) => {


//   const invoiceWithType = {
//     ...invoice,
//     invoice_type: invoice.invoice_type || 
//                   (invoice.performa_invoice_no ? 'Performa Invoice' : 'Tax Invoice'),
//     sourceNavbar: invoice.performa_invoice_no ? 'performa' : 'tax'
//   };

//     setViewInvoiceData(invoiceWithType);
//     setShowViewInvoice(true);
//     setShowInvoices(false);
//     setShowPerformaInvoices(false);
//     setShowManageLeaves(false);
//     setShowLeaves(false);
//     setShowProjects(false);
//     setShowReports(false);
//     setShowProjectsDropdown(false);
//     setShowEmployeesDropdown(false);
//     setShowClientsDropdown(false);
//     setShowInvoicesDropdown(false);
//     setShowProformaInvoice(false);
//     setShowTaxInvoice(false);
//     setShowUpdateTaxInvoice(false);
//     setShowAddProject(false);
//     setShowExpenses(false);
//     setShowProjectUpdate(false);
//     setShowUserProfile(false);
//     setShowVendors(false);
//     setShowClients(false);
//     setShowAddVendor(false);
//     setShowAddClient(false);
//     setShowEditVendor(false);
//     setShowViewVendor(false);
//     setShowEditClient(false);
//     setShowViewClient(false);
//   };

// const handleBackFromViewInvoice = (invoiceType) => {
//   setShowViewInvoice(false);
//   const sourceNavbar = viewInvoiceData?.sourceNavbar;
//   setViewInvoiceData(null);
  
//   if (invoiceType === 'Performa Invoice' || sourceNavbar === 'performa') {
//     setShowPerformaInvoices(true);
//     setShowInvoices(false);
//   } else {
//     setShowInvoices(true);
//     setShowPerformaInvoices(false);
//   }
// };

//   const ViewInvoice = ({ invoiceData, onBack }) => {
//     if (!invoiceData) return null;

//     return (
//       <div className="user-profile-container">
//         <div className="user-profile-wrapper">
//           <div className="user-profile-header">
//             <button onClick={onBack} className="back-button">←</button>
//             <h2 className="user-profile-title">Invoice Details</h2>
//           </div>

//           <div className="user-profile-info">
//             <div className="user-profile-info-grid">
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Invoice Number:</strong>
//                 <span className="info-value">{invoiceData.invoice_number}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Vendor Name:</strong>
//                 <span className="info-value">{invoiceData.vendor_name || 'N/A'}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Billed To:</strong>
//                 <span className="info-value">{invoiceData.client_name}</span>
//               </div>
              
//               <div className="user-profile-info-row">
//                 <strong className="info-label">Gross Amount:</strong>
//                 <span className="info-value">₹{invoiceData.gross_amount?.toLocaleString()}</span>
//               </div>
//               <div className="user-profile-info-row">
//                 <strong className="info-label">IGST:</strong>
//                 <span className="info-value">₹{invoiceData.igst_amount?.toLocaleString()}</span>
//               </div>
//               <div className="user-profile-info-row">
//     <strong className="info-label">CGST:</strong>
//     <span className="info-value">₹{invoiceData.cgst_amount?.toLocaleString()}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">SGST:</strong>
//     <span className="info-value">₹{invoiceData.sgst_amount?.toLocaleString()}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">Grand Total:</strong>
//     <span className="info-value">₹{invoiceData.amount?.toLocaleString()}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">Date:</strong>
//     <span className="info-value">{new Date(invoiceData.date || invoiceData.created_on).toLocaleDateString()}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">Description:</strong>
//     <span className="info-value">{invoiceData.description || 'N/A'}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">Rate:</strong>
//     <span className="info-value">₹{invoiceData.rate?.toLocaleString()}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">Quantity:</strong>
//     <span className="info-value">{invoiceData.quantity}</span>
//   </div>
//   <div className="user-profile-info-row">
//     <strong className="info-label">Status:</strong>
//     <span className="info-value status-active">{invoiceData.status}</span>
//   </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };
//     const handleBackFromUpdateTaxInvoice = () => {
//       setShowUpdateTaxInvoice(false);
//       setSelectedInvoice(null);
//       setShowInvoices(true);
    
//       fetchInvoices();
//     };

//     const handleDeleteVendor = async (vendorId) => {
//       try {
//         setIsLoading(true);
//         setErrorMessage("");

//         const formData = new FormData();
//         formData.append('vendor_id', vendorId);

//         const response = await fetch(`${API_URL}/vendors/delete_vendor`, {
//           method: 'DELETE',
//           body: formData,
//           mode: 'cors',
//         });

//         if (!response.ok) {
//           const errorData = await response.json().catch(() => ({}));
//           throw new Error(`Failed to delete vendor: ${errorData.message || response.statusText}`);
//         }

//         const result = await response.json();
       

//         setVendors(prevVendors => 
//           prevVendors.map(vendor => 
//             vendor.id === vendorId || vendor.vendor_id === vendorId
//               ? { ...vendor, status: 'Inactive' }
//               : vendor
//           )
//         );

//         alert('Vendor has been marked as Inactive successfully!');
        
//         await fetchVendors();

//       } catch (error) {
       
//         alert('Failed to update vendor status');
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     const handleViewClient = (client) => {
      
//       setSelectedClient(client);
//       setShowViewClient(true);
//       setShowClients(false);
//       setShowManageLeaves(false);
//       setShowLeaves(false);
//       setShowProjects(false);
//       setShowReports(false);
//       setShowProjectsDropdown(false);
//       setShowEmployeesDropdown(false);
//       setShowClientsDropdown(false);
//       setShowInvoicesDropdown(false);
//       setShowAddProject(false);
//       setShowExpenses(false);
//       setShowProjectUpdate(false);
//       setShowUserProfile(false);
//       setShowVendors(false);
//       setShowAddVendor(false);
//       setShowAddClient(false);
//       setShowEditVendor(false);
//       setShowEditClient(false);
//       setShowViewVendor(false);
//       setShowTaxInvoice(false);
//       setShowProformaInvoice(false);
//       setShowUpdateTaxInvoice(false);
//       setShowViewInvoice(false);
//       setShowInvoices(false);
//     };

//     const handleDeleteClient = async (clientId) => {
//       try {
//         setIsLoading(true);
//         setErrorMessage("");

//         const formData = new FormData();
//         formData.append('client_id', clientId);

//         const response = await fetch(`${API_URL}/clients/delete_client`, {
//           method: 'DELETE',
//           body: formData,
//           mode: 'cors',
//         });

//         if (!response.ok) {
//           const errorData = await response.json().catch(() => ({}));
//           throw new Error(`Failed to delete client: ${errorData.message || response.statusText}`);
//         }

//         const result = await response.json();
        

//         setClients(prevClients => 
//           prevClients.map(client => 
//             client.id === clientId || client.client_id === clientId
//               ? { ...client, status: 'Inactive' }
//               : client
//           )
//         );

//         alert('Client has been marked as Inactive successfully!');
        
//         await fetchClients();

//       } catch (error) {
    
//         alert('Failed to update client status');
//       } finally {
//         setIsLoading(false);
//       }
//     };
      
//     const UserProfile = () => {
//       return (
//         <div className="user-profile-container">
//           <div className="user-profile-wrapper">
//             <div className="user-profile-header">
//               <button 
//                 onClick={handleBackFromProfile}
//                 className="back-button"
//               >
//                 ←
//               </button>
//               <h2 className="user-profile-title">User Profile</h2>
//             </div>

//             <div className="user-profile-image-section">
//               {profileImage ? (
//                 <img 
//                   src={profileImage} 
//                   alt="Profile" 
//                   className="user-profile-image"
//                 />
//               ) : (
//                 <div className="user-profile-placeholder">
//                   <FaUser />
//                 </div>
//               )}
//               <h3 className="user-profile-name">{userName}</h3>
//               <p className="user-profile-email">{currentUser?.email || localStorage.getItem('currentUserEmail') || 'No email available'}</p>
//             </div>

//             <div className="user-profile-info">
//               <h4 className="user-profile-info-title">Personal Information</h4>
//               <div className="user-profile-info-grid">
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Full Name:</strong>
//                   <span className="info-value">{userName}</span>
//                 </div>
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Email:</strong>
//                   <span className="info-value">{currentUser?.email || localStorage.getItem('currentUserEmail') || 'Not available'}</span>
//                 </div>
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Employee ID:</strong>
//                   <span className="info-value">{currentUser?.employee_id || currentUser?.id || localStorage.getItem('currentUserId') || 'Not available'}</span>
//                 </div>
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Role:</strong>
//                   <span className="info-value">{currentUser?.role || 'User'}</span>
//                 </div>
//                 <div className="user-profile-info-row">
//                   <strong className="info-label">Status:</strong>
//                   <span className="info-value status-active">{currentUser?.status || 'Active'}</span>
//                 </div>
//                 {currentUser?.phone && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Phone:</strong>
//                     <span className="info-value">{currentUser.phone}</span>
//                   </div>
//                 )}
//                 {currentUser?.department && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Department:</strong>
//                     <span className="info-value">{currentUser.department}</span>
//                   </div>
//                 )}
//                 {currentUser?.joinDate && (
//                   <div className="user-profile-info-row">
//                     <strong className="info-label">Join Date:</strong>
//                     <span className="info-value">{new Date(currentUser.joinDate).toLocaleDateString()}</span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="user-profile-logout-section">
//               <button
//                 onClick={handleLogout}
//                 className="logout-button"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       );
//     };

//     function hasImage(logo) {
//       if (!logo || typeof logo !== "string") return false;
//       return (
//         logo.startsWith("data:image/") ||
//         logo.startsWith("http://") ||
//         logo.startsWith("https://")
//       );
//     }

//     const handleBackFromEditClient = () => {
//       setShowEditClient(false);
//       setSelectedClient(null);
//       setShowClients(true);
//       fetchClients(); 
//     };

//     const handleClientUpdated = (updatedClientData) => {
     
      
//       setClients(prevClients => 
//         prevClients.map(client => 
//           client.id === updatedClientData.id || client.client_id === updatedClientData.client_id
//             ? updatedClientData 
//             : client
//         )
//       );
      
      
//     };

//     const transformExpenseData = (apiExpense) => {
   
      
//       return {
//         id: apiExpense.expense_id || apiExpense.id,
//         expense_id: apiExpense.expense_id,
//         project_id: apiExpense.project_id,
//         expense_type: apiExpense.expense_type,
//         amount: apiExpense.amount,
//         description: apiExpense.description,
//         date: apiExpense.expense_date ? apiExpense.expense_date.split('T')[0] : '',
//         created_date: apiExpense.created_date,
//         updated_date: apiExpense.updated_date,
//         receipt_image: apiExpense.receipt_image,
//         category: apiExpense.category,
//         vendor_name: apiExpense.vendor_name,
//         originalData: apiExpense
//       };
//     };

//     const handleInvoiceUpdated = (updatedInvoiceData) => {
    
      
//       setInvoices(prevInvoices => 
//         prevInvoices.map(invoice => 
//           invoice.id === updatedInvoiceData.id || invoice.invoice_id === updatedInvoiceData.invoice_id
//             ? updatedInvoiceData 
//             : invoice
//         )
//       );
      
    
//     };
//     const handleExpenseAdded = async (newExpense, projectId) => {
     
      
//       if (selectedProject && (selectedProject.project_id === projectId || selectedProject.id === projectId)) {
//         const updatedExpenses = await fetchProjectExpenses(projectId);
        
//         const updatedProject = {
//           ...selectedProject,
//           expenses: updatedExpenses
//         };
        
//         setSelectedProject(updatedProject);
     
//       }
//     };
//     const handleExpenseUpdated = async (updatedExpense, projectId) => {
   
      
//       if (selectedProject && (selectedProject.project_id === projectId || selectedProject.id === projectId)) {
//         const updatedExpenses = await fetchProjectExpenses(projectId);
        
//         const updatedProject = {
//           ...selectedProject,
//           expenses: updatedExpenses
//         };
        
//         setSelectedProject(updatedProject);
       
//       }
//     };





// const ReportSubmissionDisplay = ({ 
//   reports, 
//   searchQuery, 
//   onSearchChange,
//   onViewReport,
//   onUploadReport
// }) => {
//   const filteredReports = reports.filter((report) => {
//     const reportName = report.project_name || report.name || '';
//     const reportLocation = report.location || '';
//     const reportStatus = report.status || '';
    
//     return reportName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//            reportLocation.toLowerCase().includes(searchQuery.toLowerCase()) ||
//            reportStatus.toLowerCase().includes(searchQuery.toLowerCase());
//   });

//   return (
//     <div>
//       <div className="search-add-section">
//         <div className="search-container">
//           <div className="icon-wrapper"><FaSearch /></div>
//           <div className="Search-bar">
//             <input
//               type="text"
//               placeholder="        Search Report Details"
//               value={searchQuery}
//               onChange={(e) => onSearchChange(e.target.value)}
//             />
//           </div>
//         </div>
//       </div>

//       <section className="data-container">
//         <div className="header-row1">
//           <div className="column1"><span>Project Name</span></div>
//           <div className="column1"><span>No.Of.Blocks</span></div>
//           <div className="column1"><span>Location</span></div>
//           <div className="column1"><span>Actions</span></div>
//         </div>
//         <hr className="divider" />
        
//         {filteredReports.length === 0 ? (
//           <div className="no-data-message">
//             {searchQuery ? `No reports match "${searchQuery}"` : "No reports found"}
//           </div>
//         ) : (
//           <>
//             <div className="data-count-info">
//               Showing {filteredReports.length} of {reports.length} reports
//             </div>
//             {filteredReports.map((report) => (
//               <div key={report.id} className="data-row">
//                 <div className="column1">
//                   <span>{report.project_name || report.name}</span>
//                 </div>
//                 <div className="column1">
//                   <span>{report.no_of_blocks || report.blocks}</span>
//                 </div>
//                 <div className="column1">
//                   <span>{report.location}</span>
//                 </div>
//                 <div className="column1 actions">
//                   <FaEye
//                     className="action-icon view-icon"
//                     title="View Reports"
//                     onClick={() => onViewReport(report)}
//                   />
//                   <FaUpload
//                     className="action-icon edit-icon"
//                     title="Upload Report"
//                     onClick={() => onUploadReport(report)}
//                   />
//                 </div>
//               </div>
//             ))}
//           </>
//         )}
//       </section>
//     </div>
//   );
// };


// const handleViewReportSubmission = (report) => {
 
//   setSelectedReportForSubmission(report);
//   setShowReportSubmissionView(true);
//   setShowReportSubmission(false);
// };

// const handleUploadReportSubmission = (report) => {
 
//   setSelectedReportForSubmission(report);
//   setShowReportSubmissionView(true);
//   setShowReportSubmission(false);
// };

// const handleBackFromReportSubmissionView = () => {
//   setShowReportSubmissionView(false);
//   setSelectedReportForSubmission(null);
//   setShowReportSubmission(true);
// };

//     const handleExpenseDeleted = async (deletedExpenseId, projectId) => {
    
      
//       if (selectedProject && (selectedProject.project_id === projectId || selectedProject.id === projectId)) {
//         const updatedExpenses = await fetchProjectExpenses(projectId);
        
//         const updatedProject = {
//           ...selectedProject,
//           expenses: updatedExpenses
//         };
        
//         setSelectedProject(updatedProject);
        
//       }
//     };
//     const fetchEmployeeLeaves = async () => {
//       setIsLoading(true);
//       setErrorMessage("");
      
//       try {
//         const response = await fetch(`${API_URL}/payslips/get_employee_leaves`, {
//           method: 'GET',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           mode: 'cors',
//         });
        
//         if (!response.ok) {
//           const errorData = await response.json().catch(() => ({}));
//           throw new Error(`Employee leaves API error: ${response.status} - ${errorData.message || response.statusText}`);
//         }
        
//         const result = await response.json();
      
        
//         let leavesData = [];
        
//         if (result.status === "success" && result.data) {
//           leavesData = Array.isArray(result.data) ? result.data : [result.data];
//         } else if (Array.isArray(result)) {
//           leavesData = result;
//         } else if (result.leaves && Array.isArray(result.leaves)) {
//           leavesData = result.leaves;
//         }
        
       
//         setEmployeeLeaves(leavesData);
        
//       } catch (error) {
      
        
//         if (error.message.includes("Failed to fetch")) {
//           setErrorMessage("Network connection failed");
//         } else if (error.name === 'TypeError') {
//           setErrorMessage("Data processing error");  
//         } else if (error.message.includes("JSON")) {
//           setErrorMessage("Invalid response format");
//         } else {
//           setErrorMessage(`Error fetching employee leaves: ${error.message}`);
//         }
        
//         setEmployeeLeaves([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     return (
//       <>
//         <section className="container">
//           <aside className="sidebar">
//             <div className="logo">
//               <img className="img1" src="https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg" alt="Logo" />
//             </div>
//           <nav className="menu">
//     {isMenuItemVisible('EMPLOYEES') && (
//       <div className="menu-item-with-dropdown">
//         <div className="menu-item" onClick={handleEmployeesClick}>
//           <FaUsers className="icon" />
//           <p>Employees</p>
//           <FaChevronDown className={`dropdown-arrow ${showEmployeesDropdown ? 'rotated' : ''}`} />
//         </div>
//         {showEmployeesDropdown && (
//           <div className="dropdown-menu0010">
//             <div className="dropdown-item00100" onClick={handleEmployeesManagementClick}>
//               Employees
//             </div>
//             <div className="dropdown-item00100" onClick={handleLeavesClick}>
//               Leaves
//             </div>
//           </div>
//         )}
//       </div>
//     )}
//     {isMenuItemVisible('PROJECTS') && (
//       <div className="menu-item-with-dropdown">
//         <div className="menu-item" onClick={handleProjectsClick}>
//           <FaProjectDiagram className="icon" />
//           <p>Projects</p>
//           <FaChevronDown className={`dropdown-arrow ${showProjectsDropdown ? 'rotated' : ''}`} />
//         </div>
//         {showProjectsDropdown && (
//           <div className="dropdown-menu0010">
//             <div className={`dropdown-item00100 ${selectedProjectStatus === "Ongoing" ? "active" : ""}`} onClick={() => handleProjectStatusClick("Ongoing")}>
//               OnGoing
//             </div>
//             <div className={`dropdown-item00100 ${selectedProjectStatus === "Completed" ? "active" : ""}`} onClick={() => handleProjectStatusClick("Completed")}>
//               Completed
//             </div>
//             <div className={`dropdown-item00100 ${selectedProjectStatus === "Pipelined" ? "active" : ""}`} onClick={() => handleProjectStatusClick("Pipelined")}>
//               Pipelined
//             </div>
//           </div>
//         )}
//       </div>
//     )}
//     {isMenuItemVisible('REPORTS') && (
//       <div className="menu-item" onClick={handleReportsClick}>
//         <FaFileAlt className="icon" />
//         <p>Reports</p>
//       </div>
//     )}
//     {isMenuItemVisible('VENDORS') && (
//       <div className="menu-item" onClick={handleVendorsClick}>
//         <FaStore className="icon" />
//         <p>Vendors</p>
//       </div>
//     )}

//     {isMenuItemVisible('CLIENTS') && (
//       <div className="menu-item" onClick={handleClientsClick}>
//         <FaUserTie className="icon" />
//         <p>Clients</p>
//       </div>
//     )}
//     {isMenuItemVisible('TAX_INVOICES') && (
//       <div className="menu-item" onClick={handleInvoicesPageClick}>
//         <FaFileInvoiceDollar className="icon" />
//         <p>Tax Invoices</p>
//       </div>
//     )}

//     {isMenuItemVisible('PERFORMA_INVOICES') && (
//       <div className="menu-item" onClick={handlePerformaInvoicesPageClick}>
//         <FaFileInvoiceDollar className="icon" />
//         <p>Performa Invoices</p>
//       </div>
//     )}

//      {isMenuItemVisible('REPORT_SUBMISSION') && (
//   <div className="menu-item" onClick={handleReportSubmissionPageClick}>
//     <FaClipboardCheck className="icon" />
//     <p>Report Submission</p>
//   </div>
// )}
//   </nav>
//           </aside>
//   <main className="content">

//     <header className="header">
//   <h2>{getCurrentPageTitle()}</h2>


  
// <div 
//   className="notification-section"
//   onClick={(e) => {
//     e.stopPropagation();
//     setShowNotifications(!showNotifications);
//     setShowProfileMenu(false);
//   }}
// >
//   <FaBell className="notification-icon" />
//   {unreadCount > 0 && (
//     <span className="notification-badge">{unreadCount}</span>
//   )}
// </div>

// {/* Add this notification panel right after the header closing tag */}
// {showNotifications && (
//   <div className="HM-notification-panel">
//     <div className="HM-notification-panel-header">
//       <h3>Notifications</h3>
//       <button 
//         className="HM-close-panel-btn"
//         onClick={() => setShowNotifications(false)}
//       >
//         <FaTimes />
//       </button>
//     </div>

   


//     <div className="HM-notification-filters">
//   <button 
//     className={`HM-filter-btn ${filterType === 'all' ? 'active' : ''}`}
//     onClick={() => setFilterType('all')}
//   >
//     All ({notifications.length})
//   </button>
//   <button 
//     className={`HM-filter-btn ${filterType === 'leave' ? 'active' : ''}`}
//     onClick={() => setFilterType('leave')}
//   >
//     Leaves
//   </button>
//   <button 
//     className={`HM-filter-btn ${filterType === 'project' ? 'active' : ''}`}
//     onClick={() => setFilterType('project')}
//   >
//     Projects
//   </button>
//   <button 
//     className={`HM-filter-btn ${filterType === 'employee' ? 'active' : ''}`}
//     onClick={() => setFilterType('employee')}
//   >
//     Updates
//   </button>
// </div>


//     {notifications.length > 0 && (
//       <div className="HM-notification-actions">
//         {unreadCount > 0 && (
//           <button 
//             className="HM-action-btn"
//             onClick={handleMarkAllRead}
//           >
//             Mark all as read
//           </button>
//         )}
//         <button 
//           className="HM-action-btn danger"
//           onClick={handleClearAll}
//         >
//           Clear all
//         </button>
//       </div>
//     )}

//     <div className="HM-notification-panel-list">
//       {filteredNotifications.length === 0 ? (
//         <div className="HM-no-notifications">
//           <FaBell className="HM-no-notif-icon" />
//           <p>No notifications yet</p>
//           <span>You'll see updates from CEO and Admin here</span>
//         </div>
//       ) : (
//         filteredNotifications.map((notification) => (
//           <div 
//             key={notification.id} 
//             className={`HM-notification-panel-item ${notification.read ? 'read' : 'unread'}`}
//             onClick={() => handleNotificationClick(notification.id)}
//           >
//             <div className="HM-notif-icon-wrapper">
//               {getNotificationIcon(notification.type)}
//             </div>
            
//             <div className="HM-notif-content">
//               <p className="HM-notif-message">{notification.message}</p>
              
            



// {notification.details && Object.keys(notification.details).length > 0 && (
//   <div className="HM-notif-details">
//     {notification.details.approver && (
//       <span className="HM-notif-detail">By: {notification.details.approver}</span>
//     )}
//     {notification.details.updatedBy && (
//       <span className="HM-notif-detail">By: {notification.details.updatedBy}</span>
//     )}
//     {notification.details.employeeName && (
//       <span className="HM-notif-detail">Employee: {notification.details.employeeName}</span>
//     )}
//     {notification.details.project && (
//       <span className="HM-notif-detail">Project: {notification.details.project}</span>
//     )}
//     {notification.details.amount && (
//       <span className="HM-notif-detail">Amount: ₹{notification.details.amount}</span>
//     )}
//     {notification.details.reason && (
//       <span className="HM-notif-detail">Reason: {notification.details.reason}</span>
//     )}
//     {notification.details.changes && (
//       <span className="HM-notif-detail">Changed: {notification.details.changes}</span>
//     )}
//   </div>
// )}
              
//               <span className="HM-notif-time">{getTimeAgo(notification.timestamp)}</span>
//             </div>

//             <button 
//               className="HM-delete-notif-btn"
//               onClick={(e) => handleDeleteNotification(notification.id, e)}
//             >
//               <FaTimes />
//             </button>
//           </div>
//         ))
//       )}
//     </div>
//   </div>
// )}
//      <div
//       className="profile-section"
//       onClick={() => setShowProfileMenu(!showProfileMenu)}
//     >
//       {profileImage ? (
//         <img src={profileImage} alt="Profile" className="profile-image" />
//       ) : (
//         <FaUser className="profile-icon" />
//       )}
//       {userName}
//       {showProfileMenu && (
//         <div className="profile-menu">
//           <p onClick={handleViewProfile}>View Profile</p>
//           <p onClick={handleLogout}>Logout</p>
//         </div>
//       )}
//     </div>
  


// </header>
//     <hr className="divider" />
//     {uploadSuccess && (
//       <div className="success-alert">
//         ✓ File uploaded successfully! Report has been added to the list.
//       </div>
//     )}
//     {isLoading && <div className="loading-message">Loading...</div>}
//     {errorMessage && <div className="error-message">{errorMessage}</div>}

//  {
//   showReportSubmissionView && selectedReportForSubmission ? (
//     <ReportSubmission
//       project={selectedReportForSubmission}
//       onBack={handleBackFromReportSubmissionView}
//     />
//   ) : showReportSubmission ? (
//     <ReportSubmissionDisplay
//       reports={projects}
//       searchQuery={reportSubmissionSearchQuery}
//       onSearchChange={setReportSubmissionSearchQuery}
//       onViewReport={handleViewReportSubmission}
//       onUploadReport={handleUploadReportSubmission}
//     />
//   ) : showUserProfile ? (
//     <UserProfile />
//   ) :  showGetReports && selectedProjectForReports ? (
//       <Get 
//         onCancel={handleBackFromGetReports} 
//         project={selectedProjectForReports}
//       />
//     ) : showReportsList && selectedProjectForReports ? (
//       <CreateReport
//         project={selectedProjectForReports}
//         goBack={handleBackFromReportsList}
//         reports={projectReports}
//       />
//     ) : showTaxInvoice ? (
//       <TaxInvoice onBack={handleBackFromTaxInvoice}
//       refreshInvoiceNumber={refreshInvoiceNumber}  />
//     ) : showProformaInvoice ? (
//       <Performa onBack={handleBackFromProformaInvoice} />
//     ) : showAddVendor ? (
//       <AddVendor
//         onBack={handleBackFromAddVendor}
//         onSubmit={handleVendorSubmit}
//       />
//     ) : showUpdateTaxInvoice ? (
//       <UpdateTaxinvoice
//         invoiceData={selectedInvoice}
//         invoiceId={selectedInvoice?.invoice_id || selectedInvoice?.id}
//         onBack={handleBackFromUpdateTaxInvoice}
//         onInvoiceUpdated={(updatedInvoice) => {
//           const transformedInvoice = transformInvoiceData(updatedInvoice);
//           setInvoices((prevInvoices) =>
//             prevInvoices.map((inv) =>
//               inv.id === transformedInvoice.id ||
//               inv.invoice_id === transformedInvoice.invoice_id
//                 ? transformedInvoice
//                 : inv
//             )
//           );
//           handleBackFromUpdateTaxInvoice();
//         }}
//       />
//     ) : showUpdatePerformaInvoice && selectedPerformaInvoice?.invoice_type === 'Performa Invoice' ? (
//       <PerformaUpdate
//         invoiceData={selectedPerformaInvoice}
//         invoiceId={selectedPerformaInvoice?.invoice_id || selectedPerformaInvoice?.id}
//         onBack={handleBackFromUpdatePerformaInvoice}
//         onInvoiceUpdated={(updatedInvoice) => {
//           const transformedInvoice = transformInvoiceData(updatedInvoice);
//           setPerformaInvoices((prevInvoices) =>
//         prevInvoices.map((inv) =>
//           inv.id === transformedInvoice.id ||
//           inv.invoice_id === transformedInvoice.invoice_id
//             ? transformedInvoice
//             : inv
//         )
//       );

          
//           handleBackFromUpdatePerformaInvoice();
//         }}
//       />
//     ) : showViewInvoice ? (
//       <ViewTaxInvoice 
//         invoiceData={viewInvoiceData} 
//         onBack={handleBackFromViewInvoice} 
//       />
//     ) : showInvoices ? (
//       <InvoicesDisplay
//         invoices={invoices}
//         searchQuery={invoiceSearchQuery}
//         onSearchChange={setInvoiceSearchQuery}
//         onTaxInvoiceClick={handleTaxInvoiceClick}
//         onProformaInvoiceClick={handleProformaInvoiceClick}
//         onEditInvoice={handleEditInvoice}
//         onViewInvoice={handleViewInvoice}  
//       />
//     ) : showPerformaInvoices ? (
//   <PerformaInvoicesDisplay
//     invoices={performaInvoices}
//     searchQuery={performaInvoiceSearchQuery}
//     onSearchChange={setPerformaInvoiceSearchQuery}
//     onAddPerformaInvoice={handleAddPerformaInvoice}
//     onEditInvoice={handleEditPerformaInvoice}
//     onViewInvoice={handleViewInvoice}
//   />
//     ) : showPerformaInvoiceForm ? (
//       <Performa onBack={handleBackFromPerformaInvoiceForm} />
//     ) : showViewVendor ? (
//       <ViewVendor 
//         vendorData={selectedVendor} 
//         onBack={handleBackFromViewVendor} 
//       />
//     ) : showEditVendor ? (
//       <EditVendor
//         onBack={handleBackFromEditVendor}
//         onVendorUpdated={handleVendorUpdated}
//         vendorData={selectedVendor}
//       />
//     ) : showVendors ? (
//       <VendorsDisplay
//         vendors={vendors}
//         searchQuery={vendorSearchQuery}
//         onSearchChange={setVendorSearchQuery}
//         onAddVendor={handleAddVendor}
//         onViewVendor={handleViewVendor}
//         onEditVendor={handleEditVendor}
//         onDeleteVendor={handleDeleteVendor}
//         selectedVendorStatus={selectedVendorStatus}
//         onStatusChange={handleVendorStatusChange}
//       />
//     ) : showViewClient ? (
//       <ViewClient 
//         clientData={selectedClient} 
//         onBack={handleBackFromViewClient} 
//       />
//     ) : showAddClient ? (
//       <Client onBack={handleBackFromAddClient} onSubmit={handleClientSubmit} />
//     ) : showEditClient ? (
//       <EditClient
//         onBack={handleBackFromEditClient}
//         onClientUpdated={handleClientUpdated}
//         clientData={selectedClient}
//       />
//     ) : showClients ? (
//       <ClientsDisplay
//         clients={clients}
//         searchQuery={clientSearchQuery}
//         onSearchChange={setClientSearchQuery}
//         onAddClient={handleAddClient}
//         onViewClient={handleViewClient}
//         onEditClient={handleEditClient}
//         onDeleteClient={handleDeleteClient}
//         selectedClientStatus={selectedClientStatus}
//         onStatusChange={handleClientStatusChange}
//       />
//     ) : showLeaves ? (
//       <ManageLeaves
//         onBack={handleBackFromLeaves}
//         employeeLeaves={employeeLeaves}
//         isLoading={isLoading}
//         errorMessage={errorMessage}
//         onRefresh={fetchEmployeeLeaves}
//       />
//     ) : showExpenses && !selectedProject ? (
//       <ExpenseList project={null} goBack={() => setShowReports(true)} />
//     ) : showExpenses && selectedProject ? (
//       <ExpenseList
//         project={selectedProject}
//         goBack={handleBackFromExpenses}
//         onExpenseAdded={handleExpenseAdded}
//         onExpenseUpdated={handleExpenseUpdated}
//         onExpenseDeleted={handleExpenseDeleted}
//       />
//     ) : showManageLeaves ? (
//     <AddEmployees
//     goBack={handleBackFromManageLeaves}
//     employees={getFilteredEmployees()}
//     setEmployees={setEmployees}
//     isLoading={isLoading}
//     errorMessage={errorMessage}
//     onProfileImageUpdate={handleProfileImageUpdate}
//     onEmployeeAdded={handleEmployeeAdded}
//     onEmployeeUpdated={handleEmployeeUpdated}
//     onCurrentEmployeeUpdate={handleCurrentEmployeeUpdate}
//     isCEO={isCEO()}
//     canEditEmployee={canEditEmployee}
//     selectedEmployeeStatus={selectedEmployeeStatus}
//     onStatusChange={handleEmployeeStatusChange}
//     onDeleteEmployee={handleDeleteEmployee}
//   />
//     ) : showAddProject ? (
//       <AddProject
//         goBack={handleBackFromAddProject}
//         onBack={handleBackFromAddProject}
//         onSubmit={handleProjectSubmit}
//       />
//     ) : showProjectUpdate ? (
//       <ProjectUpdate
//         project={projectToUpdate}
//         onBack={handleBackFromProjectUpdate}
//         onSubmit={handleProjectUpdateSubmit}
//       />
//     ) : showProjects ? (
//      <ProjectNavbar
//     projects={getFilteredProjects()}
//     onDeleteProject={handleDeleteProject}
//     onAddProject={handleAddProject}
//     onProjectClick={handleProjectClick}
//     onUpdateProject={handleUpdateProject}
//     onManageEmployees={handleManageEmployees}
//     selectedStatus={selectedProjectStatus}
//     isLoading={isLoading}
//     searchQuery={searchQuery}
//     setSearchQuery={setSearchQuery}
//     isCEO={isCEOUser()}
//   />
//     ) : showEmployeeProject && selectedProjectForEmployees ? (
//   <AddEmployeeProject 
//     project={selectedProjectForEmployees}
//     onClose={handleBackFromEmployeeProject}
//     onEmployeeAdded={async (newEmployee) => {
   
//     }}
//   />
//     ) : showReports ? (
//       <>
//         <div className="search-add-section">
//           <div className="search-container">
//             <div className="icon-wrapper">
//               <FaSearch />
//             </div>
//             <div className="Search-bar">
//               <input
//                 type="text"
//                 placeholder="        Search Report Details"
//                 value={searchQuery}
//                 onChange={handleSearch}
//               />
//             </div>
//           </div>
//         </div>
//         <input
//           type="file"
//           ref={fileInputRef}
//           onChange={handleFileUpload}
//           className="hidden-file-input"
//           accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.xls,.xlsx"
//           multiple={false}
//         />

//         <section className="data-container">
//           <div className="header-row1">
//             <div className="column1">
//               <span>Project Name</span>
//             </div>
//             <div className="column1">
//               <span>No of Blocks</span>
//             </div>
//             <div className="column1">
//               <span>Status</span>
//             </div>
//             <div className="column1">
//               <span>Location</span>
//             </div>
//             <div className="column1">
//               <span>Actions</span>
//             </div>
//           </div>
//           <hr className="divider" />

//           {filteredReports.length === 0 ? (
//             <div className="no-data-message">
//               {selectedProjectStatus
//                 ? `No ${selectedProjectStatus.toLowerCase()} reports found`
//                 : searchQuery
//                 ? `No reports match "${searchQuery}"`
//                 : "No reports found"}
//             </div>
//           ) : (
//             <>
//               <div className="data-count-info">
//                 Showing {filteredReports.length} of {reports.length} reports
//               </div>
//               {filteredReports.map((report) => (
//                 <div key={report.id} className="data-row">
//                   <div className="column1">
//                     <span>{report.name}</span>
//                   </div>
//                   <div className="column1">
//                     <span>{report.blocks || report.no_of_blocks}</span>
//                   </div>
//                   <div className="column1">
//                     <span
//                       className={`status-${report.status
//                         .toLowerCase()
//                         .replace(/\s+/g, "-")}`}
//                     >
//                       {report.status}
//                     </span>
//                   </div>
//                   <div className="column1">
//                     <span>{report.location}</span>
//                   </div>
//                   <div className="column1 actions">
//                     <FaEye
//                       className="action-icon view-icon"
//                       title="View Project Reports"
//                       onClick={() => handleViewProjectReports(report)}
//                     />
//                     <FaPlus
//                       className="action-icon edit-icon"
//                       title="Add Report"
//                       onClick={() => {
//                         const projectData = {
//                           name: report.project_name || report.name,
//                           project_id: report.id || report.project_id,  
//                           id: report.id || report.project_id,
//                           location: report.location,
//                           client: report.client,
//                           vendor: report.vendor,
//                           numberOfBlocks: report.no_of_blocks || report.blocks,
//                           customer: report.customer || "Customer Name",
//                         };
//                         setShowPopup(true);
//                         setSelectedProjectData(projectData);
//                       }}
//                     />
//                   </div>
//                 </div>
//               ))}
//             </>
//           )}
//         </section>
//       </>
//     ) : null}
//   </main>
//         </section>
//         {showPopup && <CreateReport goBack={() => setShowPopup(false)} project={selectedProjectData} />}
//         {showProjectModal && <Get onClose={() => setShowProjectModal(false)} />}
//       </>
//     );
//   };

//   export default Navbar;  





















































 import React, { useState, useEffect, useRef } from "react";
 import { FaSearch, FaUsers, FaBell,FaUserEdit,FaClipboardCheck, FaHome, FaProjectDiagram, FaFileAlt, FaEye, FaEdit, FaUser, FaChevronDown, FaPlus, FaUpload, FaTimes, FaStore, FaUserTie, FaTrash, FaFileInvoiceDollar, FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaClipboardList, FaEnvelope, FaSms } from "react-icons/fa";
  import "./Navbar.css";
  import CreateReport from "./CreateReport";
  import Get from "./Get";
  import AddEmployees from "./AddEmployees";
  import ManageLeaves from "./ManageLeaves";
  import AddProject from "./AddProject";
  import ProjectNavbar from "./ProjectNavbar"; 
  import ExpenseList from "./Expenses";
  import ProjectUpdate from "./ProjectUpdate"; 
  import AddVendor from "./AddVendor";
  import Client from "./Client";
  import EditVendor from "./EditVendor";
  import EditClient from "./EditClient"; 
  import TaxInvoice from "./TaxInvoice";
  import UpdateTaxinvoice from "./UpdateTaxinvoice";
  import Performa from "./Performa";
  import Invoice from "./Invoice";
  import { API_URL } from "./API";
  import PerformaUpdate from "./PerformaUpdate";
  import ViewTaxInvoice from "./ViewTaxinvoice";
  import AddEmployeeProject from "./AddEmployeeProject";
  import ReportSubmission from "./ReportSubmission";

  const VendorsDisplay = ({ 
    vendors, 
    searchQuery, 
    onSearchChange, 
    onAddVendor, 
    onViewVendor,
    onEditVendor, 
    onDeleteVendor,
    selectedVendorStatus,
    onStatusChange
  }) => {
    const filteredVendors = vendors.filter((vendor) => {
      const vendorName = vendor.vendor_name || '';
      const gst_no = vendor.gst_no || '';
      const contact_number = vendor.contact_number || '';
      
      const matchesSearch = vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            gst_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
            contact_number.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = selectedVendorStatus ? vendor.status === selectedVendorStatus : true;
      
      return matchesSearch && matchesStatus;
    });

   function hasImage(logo) {
      if (!logo || typeof logo !== "string") return false;
      return (
        logo.startsWith("data:image/") ||
        logo.startsWith("http://") ||
        logo.startsWith("https://")
      );
    }

    return (
      <div>
        <div className="search-add-section">
          <div className="search-container">
            <div className="icon-wrapper"><FaSearch /></div>
            <div className="Search-bar">
              <input
                type="text"
                placeholder=" Search Vendor Details"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          </div>
          <div className="status-filter-container">
            <select 
    value={selectedVendorStatus} 
    onChange={(e) => onStatusChange(e.target.value)}
    className="status-filter-dropdown"
  >
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
  </select>
          </div>
          <div className="add-button-container">
            <button className="add-button" onClick={onAddVendor}>
              <FaPlus className="add-icon" />
              Add Vendor
            </button>
          </div>
        </div>
        <section className="data-container">
          <div className="header-row1">
            <div className="column1"><span>Vendor Name</span></div>
            <div className="column1"><span>GST NO</span></div>
            <div className="column1"><span>Contact Number</span></div>
            <div className="column1"><span>Vendor Logo</span></div>
            <div className="column1"><span>Status</span></div>
            <div className="column1"><span>Actions</span></div>
          </div>
          <hr className="divider" />
          {filteredVendors.length === 0
            ? <div className="no-data-message">{searchQuery ? `No vendors match "${searchQuery}"` : "No vendors found"}</div>
            : <>
              <div className="data-count-info">Showing {filteredVendors.length} of {vendors.length} vendors</div>
              {filteredVendors.map((vendor) => (
                <div key={vendor.id} className="data-row">
                  <div className="column"><span>{vendor.vendor_name}</span></div>
                  <div className="column"><span>{vendor.gst_no || 'N/A'}</span></div>
                  <div className="column"><span>{vendor.contact_number || 'N/A'}</span></div>
                  <div className="column">
                    {hasImage(vendor.vendor_logo) ? (
                      <img
                        src={vendor.vendor_logo}
                        alt="Vendor Logo"
                        className="entity-logo"
                        onError={(e)=>{e.target.onerror=null;e.target.style.display="none"}}
                      />
                    ) : (
                      <div className="entity-logo-placeholder">
                        <FaStore />
                      </div>
                    )}
                  </div>
                  <div className="column">
                    <span className={`status-${(vendor.status || 'Active').toLowerCase()}`}>
                      {vendor.status || 'Active'}
                    </span>
                  </div>
                  <div className="column actions">
                    <FaEye
                      className="action-icon view-icon"
                      title="View"
                      onClick={() => onViewVendor(vendor)}
                    />
                    <FaEdit
                      className="action-icon edit-icon"
                      title="Edit"
                      onClick={() => onEditVendor(vendor)}
                    />
                    <FaTrash
                      className="action-icon delete-icon"
                      title="Delete"
                      onClick={() => onDeleteVendor(vendor.id)}
                    />
                  </div>
                </div>
              ))}
            </>
          }
        </section>
      </div>
    );
  };

  const ClientsDisplay = ({ 
    clients, 
    searchQuery, 
    onSearchChange, 
    onAddClient, 
    onViewClient,
    onEditClient, 
    onDeleteClient,
    selectedClientStatus,
    onStatusChange
  }) => {
    const filteredClients = clients.filter((client) => {
      const clientName = client.client_name || '';
      const gst_no = client.gst_no || '';
      const contact_number = client.contact_number || '';
      
      const matchesSearch = clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            gst_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
            contact_number.toLowerCase().includes(searchQuery.toLowerCase());
      
      const matchesStatus = !selectedClientStatus || client.status === selectedClientStatus;
      
      return matchesSearch && matchesStatus;
    });

    function hasImage(logo) {
      if (!logo || typeof logo !== "string") return false;
      return (
        logo.startsWith("data:image/") ||
        logo.startsWith("http://") ||
        logo.startsWith("https://")
      );
    }

    return (
      <div>
        <div className="search-add-section">
          <div className="search-container">
            <div className="icon-wrapper"><FaSearch /></div>
            <div className="Search-bar">
              <input
                type="text"
                placeholder="        Search Client Details"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          </div>
          <div className="status-filter-container">
            <select 
              value={selectedClientStatus} 
              onChange={(e) => onStatusChange(e.target.value)}
              className="status-filter-dropdown"
            >
            
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div className="add-button-container">
            <button className="add-button" onClick={onAddClient}>
              <FaPlus className="add-icon" />
              Add Client
            </button>
          </div>
        </div>
        <section className="data-container">
          <div className="header-row1">
            <div className="column1"><span>Client Name</span></div>
            <div className="column1"><span>GST NO</span></div>
            <div className="column1"><span>Contact Number</span></div>
            <div className="column1"><span>Client Logo</span></div>
            <div className="column1"><span>Status</span></div>
            <div className="column1"><span>Actions</span></div>
          </div>
          <hr className="divider" />
          {filteredClients.length === 0
            ? <div className="no-data-message">{searchQuery ? `No clients match "${searchQuery}"` : "No clients found"}</div>
            : <>
              <div className="data-count-info">Showing {filteredClients.length} of {clients.length} clients</div>
              {filteredClients.map((client) => (
                <div key={client.id} className="data-row">
                  <div className="column"><span>{client.client_name}</span></div>
                  <div className="column"><span>{client.gst_no || 'N/A'}</span></div>
                  <div className="column"><span>{client.contact_number || 'N/A'}</span></div>
                  <div className="column">
                    {hasImage(client.client_logo) ? (
                      <img
                        src={client.client_logo}
                        alt="Client Logo"
                        className="entity-logo"
                        onError={(e)=>{e.target.onerror=null;e.target.style.display="none"}}
                      />
                    ) : (
                      <div className="entity-logo-placeholder">
                        <FaUserTie />
                      </div>
                    )}
                  </div>
                  <div className="column">
                    <span className={`status-${(client.status || 'Active').toLowerCase().replace(/\s+/g, "-")}`}>
                      {client.status || 'Active'}
                    </span>
                  </div>
                  <div className="column actions">
                    <FaEye
                      className="action-icon view-icon"
                      title="View"
                      onClick={() => onViewClient(client)}
                    />
                    <FaEdit
                      className="action-icon edit-icon"
                      title="Edit"
                      onClick={() => onEditClient(client)}
                    />
                    <FaTrash
                      className="action-icon delete-icon"
                      title="Delete"
                      onClick={() => onDeleteClient(client.id)}
                    />
                  </div>
                </div>
              ))}
            </>
          }
        </section>
      </div>
    );
  };

const getCurrentFinancialYear = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  
  if (currentMonth >= 4) {
    return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
  } else {
    return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
  }
};

const getCurrentQuarter = () => {
  const month = new Date().getMonth() + 1;
  if (month >= 4 && month <= 6) return "Q1 (Apr-Jun)";
  if (month >= 7 && month <= 9) return "Q2 (Jul-Sep)";
  if (month >= 10 && month <= 12) return "Q3 (Oct-Dec)";
  return "Q4 (Jan-Mar)";
};;

const getCurrentPeriod = () => {
  const monthNames = ["January", "February", "March", "April", "May", "June",
                     "July", "August", "September", "October", "November", "December"];
  return monthNames[new Date().getMonth()];
};


const parseInvoiceDate = (dateString) => {
  if (!dateString) return null;
  
  if (dateString.includes('-')) {
    const parts = dateString.split('-');
    if (parts[0].length === 2) {
      const [day, month, year] = parts;
      return new Date(`${year}-${month}-${day}`);
    }
  }
  
  return new Date(dateString);
};

const getInvoiceFinancialYear = (invoiceDate) => {
  const date = parseInvoiceDate(invoiceDate);
  if (!date || isNaN(date.getTime())) return null;
  
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  
  if (month >= 4) {
    return `${year}-${(year + 1).toString().slice(-2)}`;
  } else {
    return `${year - 1}-${year.toString().slice(-2)}`;
  }
};

const checkInvoiceMatchesFilters = (invoice, filters) => {
  const dateString = invoice.invoice_date || invoice.date || invoice.created_on;
  const invoiceDate = parseInvoiceDate(dateString);
  
  if (!invoiceDate || isNaN(invoiceDate.getTime())) {
    return false;
  }

  const invoiceFY = getInvoiceFinancialYear(dateString);
  if (invoiceFY !== filters.financialYear) {
    return false;
  }

  const invoiceMonthName = invoiceDate.toLocaleString('en-US', { month: 'long' });
  if (invoiceMonthName !== filters.period) {
    return false;
  }

  if (filters.status !== "ALL INVOICES") {
    const invoiceStatus = (invoice.status || 'ACTIVE').toUpperCase();
    if (invoiceStatus !== filters.status) {
      return false;
    }
  }

  return true;
};

const FilterSection = ({ 
  onSearch, 
  financialYear, 
  setFinancialYear, 
  quarter, 
  setQuarter, 
  period, 
  setPeriod, 
  status, 
  setStatus 
}) => {
  const quarterMonths = {
    "Q1 (Apr-Jun)": ["April", "May", "June"],
    "Q2 (Jul-Sep)": ["July", "August", "September"],
    "Q3 (Oct-Dec)": ["October", "November", "December"],
    "Q4 (Jan-Mar)": ["January", "February", "March"],
  };

  React.useEffect(() => {
    const months = quarterMonths[quarter];
    if (months && !months.includes(period)) {
      setPeriod(months[0]);
    }
  }, [quarter]);

  React.useEffect(() => {
    onSearch({ financialYear, quarter, period, status });
  }, [financialYear, period, status]);

  return (
    <div className="filter-container">
      <div className="filter-grid">
        <div className="filter-field">
          <label className="filter-label">Financial Year</label>
          <select className="filter-select" value={financialYear} onChange={(e) => setFinancialYear(e.target.value)}>
            <option value="2026-27"> 2026-27</option>
            <option value="2025-26"> 2025-26</option>
            <option value="2024-25"> 2024-25</option>
            <option value="2023-24"> 2023-24</option>
            <option value="2022-23"> 2022-23</option>
            <option value="2021-22"> 2021-22</option>
            <option value="2020-21"> 2020-21</option>
           
          </select>
        </div>

        <div className="filter-field">
          <label className="filter-label">Quarter</label>
          <select className="filter-select" value={quarter} onChange={(e) => setQuarter(e.target.value)}>
            <option value="Q1 (Apr-Jun)">Q1 (Apr-Jun)</option>
            <option value="Q2 (Jul-Sep)">Q2 (Jul-Sep)</option>
            <option value="Q3 (Oct-Dec)">Q3 (Oct-Dec)</option>
            <option value="Q4 (Jan-Mar)">Q4 (Jan-Mar)</option>
          </select>
        </div>

        <div className="filter-field">
          <label className="filter-label">Month</label>
          <select className="filter-select" value={period} onChange={(e) => setPeriod(e.target.value)}>
            {quarterMonths[quarter].map((month) => (
              <option key={month} value={month}>{month}</option>
            ))}
          </select>
        </div>

        <div className="filter-field">
          <label className="filter-label">Status</label>
          <select className="filter-select" value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="ALL INVOICES">All Invoices</option>
            <option value="ACTIVE">Active</option>
            <option value="CANCEL">Cancelled</option>
          </select>
        </div>
      </div>
    </div>
  );
};

const getStatusClassName = (status) => {
  const normalizedStatus = (status || 'Active').toLowerCase();
  if (normalizedStatus === 'active') {
    return 'status-active';
  } else if (normalizedStatus === 'cancel') {
    return 'status-cancel';
  }
  return 'status-active';
};



const InvoicesDisplay = ({ 
  invoices, 
  searchQuery, 
  onSearchChange, 
  onTaxInvoiceClick, 
  onProformaInvoiceClick, 
  onEditInvoice,
  onViewInvoice  
}) => {
  const [financialYear, setFinancialYear] = React.useState(getCurrentFinancialYear());
  const [quarter, setQuarter] = React.useState(getCurrentQuarter());
  const [period, setPeriod] = React.useState(getCurrentPeriod());
  const [status, setStatus] = React.useState("ALL INVOICES");
  const [appliedFilters, setAppliedFilters] = React.useState(null);

  const handleFilterSearch = (filters) => {
    setAppliedFilters(filters);
  };

const filteredInvoices = invoices.filter((invoice) => {
  const invoiceNumber = invoice.invoice_number || invoice.invoice_no || '';
  const clientName = invoice.client_name || invoice.billed_name || '';
  const vendorName = invoice.vendor_name || '';
  const amount = invoice.amount || invoice.grand_total || 0;
  
  const matchesSearch = 
    invoiceNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
    clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    amount.toString().includes(searchQuery);

  if (!matchesSearch) {
    return false;
  }

  if (!appliedFilters) {
    return true;
  }

  return checkInvoiceMatchesFilters(invoice, appliedFilters);
});

  const handleSendEmail = (invoice) => {
    console.log("Send email for invoice:", invoice);
  };

  const handleSendSMS = (invoice) => {
    console.log("Send SMS for invoice:", invoice);
  };

  return (
    <div>
      <div className="search-add-section">
        <div className="search-container">
          <div className="icon-wrapper"><FaSearch /></div>
          <div className="Search-bar">
            <input
              type="text"
              placeholder="        Search Tax Invoice Details"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
        <div className="IV-04">
          <button className="IV-05" onClick={onTaxInvoiceClick}>+ Tax Invoice</button>
        </div>
      </div>

      <FilterSection 
        onSearch={handleFilterSearch}
        financialYear={financialYear}
        setFinancialYear={setFinancialYear}
        quarter={quarter}
        setQuarter={setQuarter}
        period={period}
        setPeriod={setPeriod}
        status={status}
        setStatus={setStatus}
      />
      
      <section className="data-container">
        <div className="header-row1">
          <div className="column1"><span>Invoice Number</span></div>
          <div className="column1"><span>Status</span></div>
          <div className="column1"><span>Billed To</span></div>
          <div className="column1"><span>Date</span></div>
          <div className="column1"><span>Grand Total</span></div>
          <div className="column1"><span>Actions</span></div>
        </div>
        <hr className="divider" />
        {filteredInvoices.length === 0 ? (
          <div className="no-data-message">
            {searchQuery ? `No invoices match "${searchQuery}"` : "No invoices found"}
          </div>
        ) : (
          <>
            <div className="data-count-info">Showing {filteredInvoices.length} of {invoices.length} invoices</div>
            {filteredInvoices.map((invoice) => (
              <div key={invoice.id} className="data-row">
                <div className="column1"><span>{invoice.invoice_number}</span></div>
                <div className="column1">
                  <span className={getStatusClassName(invoice.status)}>
                    {invoice.status || 'Active'}
                  </span>
                </div>
                <div className="column1"><span>{invoice.client_name}</span></div>
                <div className="column1">
                  <span>
  {(() => {
    const dateStr = invoice.invoice_date || invoice.date || invoice.created_on;
    const parsedDate = parseInvoiceDate(dateStr);
    return parsedDate && !isNaN(parsedDate.getTime()) 
      ? parsedDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      : 'N/A';
  })()}
</span>
                </div>
                <div className="column1"><span>₹{invoice.amount?.toLocaleString()}</span></div>
                <div className="column1 actions">
                  <FaEye className="action-icon view-icon" title="View" onClick={() => onViewInvoice(invoice)} />
                  <FaEdit className="action-icon edit-icon" title="Edit" onClick={() => onEditInvoice(invoice)} />
                  <FaEnvelope className="action-icon mail-icon" title="Send Email" onClick={() => handleSendEmail(invoice)} />
                  <FaSms className="action-icon sms-icon" title="Send SMS" onClick={() => handleSendSMS(invoice)} />
                </div>
              </div>
            ))}
          </>
        )}
      </section>
    </div>
  );
};


const PerformaInvoicesDisplay = ({ 
  invoices, 
  searchQuery, 
  onSearchChange, 
  onAddPerformaInvoice,
  onEditInvoice,
  onViewInvoice  
}) => {
  const [financialYear, setFinancialYear] = React.useState(getCurrentFinancialYear());
  const [quarter, setQuarter] = React.useState(getCurrentQuarter());
  const [period, setPeriod] = React.useState(getCurrentPeriod());
  const [status, setStatus] = React.useState("ALL INVOICES");
  const [appliedFilters, setAppliedFilters] = React.useState(null);

  const handleFilterSearch = (filters) => {
    setAppliedFilters(filters);
  };

const filteredInvoices = invoices.filter((invoice) => {
  const invoiceNumber = invoice.performa_invoice_no || invoice.invoice_number || '';
  const clientName = invoice.billed_name || invoice.client_name || '';
  const vendorName = invoice.vendor_name || '';
  const amount = invoice.amount || invoice.grand_total || 0;
  
  const matchesSearch = 
    invoiceNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
    clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    amount.toString().includes(searchQuery);

  if (!matchesSearch) {
    return false;
  }

  if (!appliedFilters) {
    return true;
  }

  return checkInvoiceMatchesFilters(invoice, appliedFilters);
});

  const handleSendEmail = (invoice) => {
    console.log("Send email for performa invoice:", invoice);
  };

  const handleSendSMS = (invoice) => {
    console.log("Send SMS for performa invoice:", invoice);
  };

  return (
    <div>
      <div className="search-add-section">
        <div className="search-container">
          <div className="icon-wrapper"><FaSearch /></div>
          <div className="Search-bar">
            <input
              type="text"
              placeholder="        Search Performa Invoice Details"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
        <div className="IV-04">
          <button className="IV-05" onClick={onAddPerformaInvoice}>+ Performa Invoice</button>
        </div>
      </div>

      <FilterSection 
        onSearch={handleFilterSearch}
        financialYear={financialYear}
        setFinancialYear={setFinancialYear}
        quarter={quarter}
        setQuarter={setQuarter}
        period={period}
        setPeriod={setPeriod}
        status={status}
        setStatus={setStatus}
      />
      
      <section className="data-container">
        <div className="header-row1">
          <div className="column1"><span>Invoice Number</span></div>
          <div className="column1"><span>Status</span></div>
          <div className="column1"><span>Billed To</span></div>
          <div className="column1"><span>Date</span></div>
          <div className="column1"><span>Grand Total</span></div>
          <div className="column1"><span>Actions</span></div>
        </div>
        <hr className="divider" />
        {filteredInvoices.length === 0 ? (
          <div className="no-data-message">
            {searchQuery ? `No invoices match "${searchQuery}"` : "No invoices found"}
          </div>
        ) : (
          <>
            <div className="data-count-info">Showing {filteredInvoices.length} of {invoices.length} invoices</div>
            {filteredInvoices.map((invoice) => (
              <div key={invoice.id} className="data-row">
                <div className="column1"><span>{invoice.performa_invoice_no || invoice.invoice_number}</span></div>
                <div className="column1">
                  <span className={getStatusClassName(invoice.status)}>
                    {invoice.status || 'Active'}
                  </span>
                </div>
                <div className="column1"><span>{invoice.billed_name || invoice.client_name}</span></div>
                <div className="column1">
                  <span>
  {(() => {
    const dateStr = invoice.invoice_date || invoice.date || invoice.created_on;
    const parsedDate = parseInvoiceDate(dateStr);
    return parsedDate && !isNaN(parsedDate.getTime()) 
      ? parsedDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      : 'N/A';
  })()}
</span>
                </div>
                <div className="column1"><span>₹{invoice.amount?.toLocaleString()}</span></div>
                <div className="column1 actions">
                  <FaEye className="action-icon view-icon" title="View" onClick={() => onViewInvoice(invoice)} />
                  <FaEdit className="action-icon edit-icon" title="Edit" onClick={() => onEditInvoice(invoice)} />
                  <FaEnvelope className="action-icon mail-icon" title="Send Email" onClick={() => handleSendEmail(invoice)} />
                  <FaSms className="action-icon sms-icon" title="Send SMS" onClick={() => handleSendSMS(invoice)} />
                </div>
              </div>
            ))}
          </>
        )}
      </section>
    </div>
  );
};

  
  const Navbar = ({ onLogout, project, initialSection, notificationMessages }) => {

 const handleReportSubmissionPageClick = async () => {
  console.log('Report Submission clicked - making API call...');
  
  setShowProjectsDropdown(false);
  setShowEmployeesDropdown(false);
  setShowClientsDropdown(false);
  setShowInvoicesDropdown(false);
  
  setShowManageLeaves(false);
  setShowLeaves(false);
  setShowProjects(false);
  setShowReports(false);
  setShowAddProject(false);
  setShowExpenses(false);
  setShowProjectUpdate(false);
  setShowUserProfile(false);
  setShowVendors(false);
  setShowClients(false);
  setShowAddVendor(false);
  setShowAddClient(false);
  setShowEditVendor(false);
  setShowViewVendor(false);
  setShowEditClient(false);
  setShowViewClient(false);
  setShowTaxInvoice(false);
  setShowProformaInvoice(false);
  setShowUpdateTaxInvoice(false);
  setShowViewInvoice(false);
  setShowInvoices(false);
  setShowPerformaInvoices(false);
  setShowPerformaInvoiceForm(false);
  setShowUpdatePerformaInvoice(false);
  setShowEmployeeProject(false);
  
  setShowReportSubmission(true);

  const userType = localStorage.getItem('userType');
  const clientEmail = localStorage.getItem('currentUserEmail');
  
  if (userType === 'client' && clientEmail) {
    try {
      const clientResponse = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
      });
      
      if (clientResponse.ok) {
        const clientResult = await clientResponse.json();
        const clientsData = Array.isArray(clientResult) ? clientResult : 
                           (clientResult.data || clientResult.clients || []);
        
        const matchingClient = clientsData.find(c => c.email === clientEmail);
        
        if (matchingClient) {
          const projectsResponse = await fetch(`${API_URL}/projects/get_projects`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
          });
          
          if (projectsResponse.ok) {
            const projectsResult = await projectsResponse.json();
            const projectsData = Array.isArray(projectsResult) ? projectsResult :
                               (projectsResult.data || projectsResult.projects || []);
            
            const clientProjects = projectsData.filter(p => 
              p.client_id === matchingClient.client_id || p.client === matchingClient.client_id
            );
            
            setProjects(clientProjects.map(transformProjectData));
          }
        }
      }
    } catch (error) {
      console.error('Error fetching client projects:', error);
    }
  } else {
    await fetchProjects();
  }
};


    const [showViewInvoice, setShowViewInvoice] = useState(false);
    const [viewInvoiceData, setViewInvoiceData] = useState(null);
 
  const [selectedVendorStatus, setSelectedVendorStatus] = useState(
    localStorage.getItem('selectedVendorStatus') || "Active"
  );
   
    const [selectedClientStatus, setSelectedClientStatus] = useState(
    localStorage.getItem('selectedClientStatus') || "Active"
  );

  const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState(
  localStorage.getItem('selectedEmployeeStatus') || "Active"
);
    const [showPopup, setShowPopup] = useState(false);
    const [showProjectModal, setShowProjectModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showInvoices, setShowInvoices] = useState(false);
    const [selectedProjectData, setSelectedProjectData] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [employeeLeaves, setEmployeeLeaves] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [showUserProfile, setShowUserProfile] = useState(false);
    const [showManageLeaves, setShowManageLeaves] = useState(true);
    const [showLeaves, setShowLeaves] = useState(false);


    const [showReportSubmission, setShowReportSubmission] = useState(false);
const [reportSubmissionSearchQuery, setReportSubmissionSearchQuery] = useState("");

const [showReportSubmissionView, setShowReportSubmissionView] = useState(false);
const [selectedReportForSubmission, setSelectedReportForSubmission] = useState(null);


    const [showEmployeesDropdown, setShowEmployeesDropdown] = useState(false);
    const [showProjects, setShowProjects] = useState(false);
    const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);
    const [showAddProject, setShowAddProject] = useState(false);
    const [selectedProjectStatus, setSelectedProjectStatus] = useState("");
    const [showExpenses, setShowExpenses] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [showProjectUpdate, setShowProjectUpdate] = useState(false); 
    const [projectToUpdate, setProjectToUpdate] = useState(null); 
    const [employees, setEmployees] = useState([]); 
    const [showReports, setShowReports] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [showVendors, setShowVendors] = useState(false);
    const [showClients, setShowClients] = useState(false);
    const [showClientsDropdown, setShowClientsDropdown] = useState(false);
    const [showAddVendor, setShowAddVendor] = useState(false);
    const [showAddClient, setShowAddClient] = useState(false);
    const [showEditVendor, setShowEditVendor] = useState(false);
    const [showViewVendor, setShowViewVendor] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [showTaxInvoice, setShowTaxInvoice] = useState(false);
    const [refreshInvoiceNumber, setRefreshInvoiceNumber] = useState(null);

    const [showEditClient, setShowEditClient] = useState(false);
    const [showViewClient, setShowViewClient] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const fileInputRef = useRef(null);
    const [profileImage, setProfileImage] = useState(null);
    const [userName, setUserName] = useState("User Name");
    const [reports, setReports] = useState([]);
    const [projects, setProjects] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [error, setError] = useState('');
    const [projectExpenses, setProjectExpenses] = useState([]);
    const [showUpdateTaxInvoice, setShowUpdateTaxInvoice] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [vendorSearchQuery, setVendorSearchQuery] = useState("");
    const [clientSearchQuery, setClientSearchQuery] = useState("");
    const [invoiceSearchQuery, setInvoiceSearchQuery] = useState("");
    const [showInvoicesDropdown, setShowInvoicesDropdown] = useState(false);
    const [showProformaInvoice, setShowProformaInvoice] = useState(false);
    const [showReportsList, setShowReportsList] = useState(false);
    const [selectedProjectForReports, setSelectedProjectForReports] = useState(null);
    const [projectReports, setProjectReports] = useState([]);
    
    const [viewMode, setViewMode] = useState(false); 
    const [showGetReports, setShowGetReports] = useState(false);

    const [assignedProjectIds, setAssignedProjectIds] = useState([]);

    const [showEmployeeProject, setShowEmployeeProject] = useState(false);
  const [selectedProjectForEmployees, setSelectedProjectForEmployees] = useState(null);
    


  const [showNotifications, setShowNotifications] = useState(false);
const [notifications, setNotifications] = useState([]);
const [unreadCount, setUnreadCount] = useState(0);

    const [performaInvoices, setPerformaInvoices] = useState([]);
  const [showPerformaInvoices, setShowPerformaInvoices] = useState(false);
  const [showPerformaInvoiceForm, setShowPerformaInvoiceForm] = useState(false);
  const [showUpdatePerformaInvoice, setShowUpdatePerformaInvoice] = useState(false);
  const [selectedPerformaInvoice, setSelectedPerformaInvoice] = useState(null);
  const [performaInvoiceSearchQuery, setPerformaInvoiceSearchQuery] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");


const [filterType, setFilterType] = useState('all');







  useEffect(() => {
  if (initialSection) {
    resetAllViews();
    
    switch(initialSection) {
      case 'employees':
        setShowManageLeaves(true);
        fetchEmployees();
        break;
      case 'projects':
        setShowProjects(true);
        fetchProjects();
        break;
      case 'reports':
        setShowReports(true);
        fetchReports();
        break;
      case 'vendors':
        setShowVendors(true);
        fetchVendors();
        break;
      case 'clients':
        setShowClients(true);
        fetchClients();
        break;
      case 'taxInvoices':
        setShowInvoices(true);
        fetchInvoices();
        break;
      case 'performaInvoices':
        setShowPerformaInvoices(true);
        fetchPerformaInvoices();
        break;
          case 'reportSubmission':
        setShowReportSubmission(true);
        break;
      default:
        break;
    }
  }
}, [initialSection]);

  const isCEOUser = () => {
    const accessLevel = localStorage.getItem('accessLevel');
    const userRole = currentUser?.role || localStorage.getItem('currentUserRole') || '';
    return accessLevel === 'full' || 
          userRole.toUpperCase().includes('CEO') ||
          userRole.toUpperCase().includes('ADMIN');
  };

  const getUserRole = () => {
    const userRole = currentUser?.role || localStorage.getItem('currentUserRole') || '';
    const accessLevel = localStorage.getItem('accessLevel');
    
    if (accessLevel === 'full' || 
        userRole.toUpperCase() === 'CEO' || 
        userRole.toUpperCase().includes('CEO') ||
        userRole.toUpperCase() === 'ADMIN' ||
        userRole.toUpperCase().includes('ADMIN')) {
      return 'CEO';
    } else if (localStorage.getItem('userType') === 'client') {
      return 'CLIENT';
    } else {
      return 'EMPLOYEE';
    }
  };

const isMenuItemVisible = (menuItem) => {
  const role = getUserRole();
  
  switch (role) {
    case 'CEO':
      return true;
      
    case 'CLIENT':
      return menuItem === 'REPORT_SUBMISSION';
      
    case 'EMPLOYEE':
      return ['EMPLOYEES', 'PROJECTS', 'REPORTS'].includes(menuItem);
      
    default:
      return false;
  }
};


const fetchEmployeeAssignedProjects = async () => {
  try {
    const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
    
    if (!currentUserId) {
      console.log('No current user ID found');
      return [];
    }
    const response = await fetch(`${API_URL}/projects/get_employee_to_projects`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    if (result.status === 'success' && result.data) {
      const employeeProjects = result.data.filter(
        emp => emp.employee_id === parseInt(currentUserId)
      );
      
      const projectIds = [...new Set(employeeProjects.map(emp => emp.project_id))];
      console.log('Employee assigned to project IDs:', projectIds);
      
      setAssignedProjectIds(projectIds);
      return projectIds;
    } else {
      console.log('No project assignments found for employee');
      setAssignedProjectIds([]);
      return [];
    }
  } catch (error) {
    console.error('Error fetching employee assigned projects:', error);
    setAssignedProjectIds([]);
    return [];
  }
};

const loadNotifications = () => {
  const currentUserId = localStorage.getItem('currentUserId');
  if (!currentUserId) return;
  
  const storedNotifications = localStorage.getItem(`notifications_${currentUserId}`) || '[]';
  
  try {
    const parsedNotifications = JSON.parse(storedNotifications);
    const sortedNotifications = parsedNotifications.sort((a, b) => 
      new Date(b.timestamp) - new Date(a.timestamp)
    );
    setNotifications(sortedNotifications);
    
    const unread = sortedNotifications.filter(n => !n.read).length;
    setUnreadCount(unread);
  } catch (error) {
    console.error('Error loading notifications:', error);
    setNotifications([]);
  }
};

useEffect(() => {
  loadNotifications();

  const handleNotificationUpdate = () => {
    loadNotifications();
  };

  const handleStorageChange = (e) => {
    if (e.key && (e.key.startsWith('notifications_') || e.key === 'notifications_update')) {
      loadNotifications();
    }
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener('notificationUpdate', handleNotificationUpdate);

  const notificationCheckInterval = setInterval(loadNotifications, 5000);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener('notificationUpdate', handleNotificationUpdate);
    clearInterval(notificationCheckInterval);
  };
}, []);


const addNotification = (type, message, details = {}) => {
  const currentUserId = localStorage.getItem('currentUserId');
  const notification = {
    id: Date.now(),
    type,
    message,
    details,
    timestamp: new Date().toISOString(),
    read: false
  };

  const existingNotifications = JSON.parse(localStorage.getItem(`notifications_${currentUserId}`) || '[]');
  existingNotifications.unshift(notification);
  
  localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(existingNotifications));
  loadNotifications();
};


useEffect(() => {
  loadNotifications();

  const handleStorageChange = (e) => {
    if (e.key && e.key.startsWith('notifications_')) {
      loadNotifications();
    }
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener('notificationUpdate', loadNotifications);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener('notificationUpdate', loadNotifications);
  };
}, []);



const getFilteredLeaves = () => {
  const role = getUserRole();
  const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
  
  if (role === 'CEO') {
    return employeeLeaves;
  } else if (role === 'EMPLOYEE') {
    return employeeLeaves.filter(leave => 
      String(leave.employee_id) === String(currentUserId)
    );
  }
  return [];
};



useEffect(() => {
  const handleClickOutside = (event) => {
    if (showProfileMenu && !event.target.closest('.profile-section')) {
      setShowProfileMenu(false);
    }
    if (showNotifications && !event.target.closest('.notification-section') && !event.target.closest('.HM-notification-panel')) {
      setShowNotifications(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [showProfileMenu, showNotifications]);


  const getFilteredEmployees = () => {
    const role = getUserRole();
    const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
    
    if (role === 'CEO') {
      return employees;
    } else if (role === 'EMPLOYEE') {
      return employees.filter(emp => 
        emp.id === parseInt(currentUserId) || 
        emp.employee_id === parseInt(currentUserId)
      );
    }
    return [];
  };
  const handleManageEmployees = (project) => {
    console.log("Manage employees clicked for project:", project);
    setSelectedProjectForEmployees(project);
    setShowEmployeeProject(true);
    setShowProjects(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowReports(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowInvoices(false);
  };

  const handleBackFromEmployeeProject = () => {
    setShowEmployeeProject(false);
    setSelectedProjectForEmployees(null);
    setShowProjects(true);
  };
 
  const getFilteredProjects = () => {
  const role = getUserRole();
  const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
  const clientId = currentUser?.client_id || localStorage.getItem('currentClientId');
  
  if (role === 'CEO') {
    return projects;
  } else if (role === 'CLIENT') {
    return projects.filter(project => 
      project.client_id === parseInt(clientId) || 
      project.client === parseInt(clientId)
    );
  } else if (role === 'EMPLOYEE') {
    if (assignedProjectIds.length === 0) {
      return [];
    }
    return projects.filter(project => 
      assignedProjectIds.includes(project.project_id || project.id)
    );
  }
  return [];
};
  
  const AddClient = ({ onBack, onSubmit }) => {
      const [clientData, setClientData] = useState({
        client_name: '',
        gst_no: '',
        contact_number: '',
        client_logo: null
      });
      const [isSubmitting, setIsSubmitting] = useState(false);
      const [submitError, setSubmitError] = useState('');
      const logoInputRef = useRef(null);

      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setClientData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
          if (file.size > 2 * 1024 * 1024) {
            alert('Logo file size should be less than 2MB');
            return;
          }
          
          const reader = new FileReader();
          reader.onload = (e) => {
            setClientData(prev => ({
              ...prev,
              client_logo: e.target.result
            }));
          };
          reader.readAsDataURL(file);
        }
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!clientData.client_name.trim()) {
          alert('Please enter client name');
          return;
        }

        setIsSubmitting(true);
        setSubmitError('');

        try {
          const response = await fetch(`${API_URL}/clients/add_client`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            mode: 'cors',
            body: JSON.stringify(clientData)
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(`Failed to add client: ${errorData.message || response.statusText}`);
          }

          const result = await response.json();
          console.log('Client added successfully:', result);

          const newClient = {
            id: result.client_id || Date.now(),
            client_id: result.client_id || Date.now(),
            client_name: clientData.client_name,
            gst_no: clientData.gst_no,
            contact_number: clientData.contact_number,
            client_logo: clientData.client_logo,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString(),
            originalData: result
          };

          if (onSubmit) {
            onSubmit(newClient);
          }

          alert('Client added successfully!');
          onBack();

        } catch (error) {
          console.error('Error adding client:', error);
          setSubmitError(error.message);
          
          const newClient = {
            id: Date.now(),
            client_id: Date.now(),
            client_name: clientData.client_name,
            gst_no: clientData.gst_no,
            contact_number: clientData.contact_number,
            client_logo: clientData.client_logo,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString()
          };

          if (onSubmit) {
            onSubmit(newClient);
          }
          
          alert('Client added to local list (check server connection)');
          onBack();
        } finally {
          setIsSubmitting(false);
        }
      };

      useEffect(() => {
        fetchEmployees();
      }, []);

      return (
        <div className="add-client-container">
          <div className="add-client-form-wrapper">
            <div className="add-client-header">
              <button 
                onClick={onBack}
                className="back-button"
              >
                ←
              </button>
              <h2 className="add-client-title">Add New Client</h2>
            </div>

            {submitError && (
              <div className="error-alert">
                {submitError}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">
                  Client Name *
                </label>
                <input
                  type="text"
                  name="client_name"
                  value={clientData.client_name}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  GST NO
                </label>
                <input
                  type="text"
                  name="gst_no"
                  value={clientData.gst_no}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Enter GST NO (optional)"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  Contact Number
                </label>
                <input
                  type="text"
                  name="contact_number"
                  value={clientData.contact_number}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Enter Contact Number (optional)"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  Client Logo
                </label>
                <input
                  type="file"
                  ref={logoInputRef}
                  onChange={handleLogoUpload}
                  accept="image/*"
                  className="hidden-file-input"
                />
                <div className="logo-upload-section">
                  <button
                    type="button"
                    onClick={() => logoInputRef.current?.click()}
                    className="choose-logo-button"
                  >
                    Choose Logo
                  </button>
                  {clientData.client_logo && (
                    <img 
                      src={clientData.client_logo} 
                      alt="Client Logo Preview" 
                      className="logo-preview"
                    />
                  )}
                </div>
              </div>

              <div className="form-actions">
                <button
                  type="button"
                  onClick={onBack}
                  className="cancel-button"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`submit-button ${isSubmitting ? 'disabled' : ''}`}
                >
                  {isSubmitting ? 'Adding...' : 'Add Client'}
                </button>
              </div>
            </form>
          </div>
        </div>
      );
    };

  useEffect(() => {
  const storedUser = localStorage.getItem('currentUser');
  const storedProfileImage = localStorage.getItem('currentUserProfileImage');
  const storedUserName = localStorage.getItem('currentUserName');
  const userType = localStorage.getItem('userType');
  
  if (storedUser) {
    try {
      const userData = JSON.parse(storedUser);
      setCurrentUser(userData);
    
      const userRole = userData.role || localStorage.getItem('currentUserRole') || 'Employee';
      setUserName(userData.name || storedUserName || "User Name");
      
      if (userData.id || userData.employee_id) {
        const employeeId = userData.id || userData.employee_id;
        const employeeImage = localStorage.getItem(`employee_${employeeId}_profileImage`);
        if (employeeImage) {
          setProfileImage(employeeImage);
        }
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
      setUserName(storedUserName || "User Name");
    }
  }
  
  if (storedProfileImage) {
    setProfileImage(storedProfileImage);
  }
  
  if (storedUserName) {
    setUserName(storedUserName);
  }

  if (userType === 'client') {
    handleReportSubmissionPageClick();
  } else {
    const openReports = localStorage.getItem('openReportsOnLoad');
    if (openReports === 'true') {
      localStorage.removeItem('openReportsOnLoad');
      handleReportsClick();
    }
    fetchProjects();
  }
}, []);
    
useEffect(() => {
  if (showManageLeaves) {
    fetchEmployees();
  }
}, [selectedEmployeeStatus]);   
    const getProjectId = () => {
      if (!project) return null;
      return project.project_id || project.id;
    };

useEffect(() => {
 
  const storedUser = localStorage.getItem('currentUser');
  const storedProfileImage = localStorage.getItem('currentUserProfileImage');
  const storedUserName = localStorage.getItem('currentUserName');
  const storedUserEmail = localStorage.getItem('currentUserEmail');
  const storedUserRole = localStorage.getItem('currentUserRole');
  
  if (storedUser) {
    try {
      const userData = JSON.parse(storedUser);
      setCurrentUser(userData);
      setUserName(userData.name || storedUserName || "User Name");
      setUserEmail(userData.email || storedUserEmail || "");
      setUserRole(userData.role || storedUserRole || "Client");
      
      if (userData.id || userData.employee_id) {
        const employeeId = userData.id || userData.employee_id;
        const employeeImage = localStorage.getItem(`employee_${employeeId}_profileImage`);
        if (employeeImage) {
          setProfileImage(employeeImage);
        }
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
      setUserName(storedUserName || "User Name");
      setUserEmail(storedUserEmail || "");
      setUserRole(storedUserRole || "Client");
    }
  }
  
  if (storedProfileImage) {
    setProfileImage(storedProfileImage);
  }
  
  if (storedUserName) {
    setUserName(storedUserName);
  }
  
  if (storedUserEmail) {
    setUserEmail(storedUserEmail);
  }
  
  if (storedUserRole) {
    setUserRole(storedUserRole);
  }


  loadNotifications();

  const handleNotificationUpdate = () => {
    loadNotifications();
  };

  const handleStorageChange = (e) => {
    if (e.key && (e.key.startsWith('notifications_') || e.key === 'notifications_update')) {
      loadNotifications();
    }
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener('notificationUpdate', handleNotificationUpdate);

  const notificationCheckInterval = setInterval(loadNotifications, 5000);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener('notificationUpdate', handleNotificationUpdate);
    clearInterval(notificationCheckInterval);
  };
}, []);

    const fetchProjectExpenses = async () => {
      const projectId = getProjectId();
      
      setLoading(true);
      setError('');
      
      try {
        const employeeLookup = await fetchEmployees();
        
        let apiUrl;
        if (projectId) {
          apiUrl = `${API_URL}/projects/get_project_expense?project_id=${projectId}`;
        }

        console.log('Fetching expenses from:', apiUrl);

        const response = await fetch(apiUrl, {
          method: 'GET',  
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error(`API Error: ${response.status}`);
        }

        const result = await response.json();
        
        let expensesData = [];
        if (result.status === "success" && result.project_expenses) {
          expensesData = result.project_expenses;
        } else if (result.project_expenses) {
          expensesData = result.project_expenses;
        }

        console.log('Raw expenses:', expensesData);
        
        const formattedExpenses = expensesData.map((expense, index) => {
          const employeeId = expense.employee_id || '';
          const amount = parseFloat(expense.expense_amount || expense.amount || 0);
          
          const formatted = {
            id: expense.expense_id || expense.id || index + 1,
            expense_id: expense.expense_id || expense.id,
            employeeName: employeeId,
            employee_name: employeeId,
            date: expense.date_of_expense ? 
                  expense.date_of_expense.split('T')[0] : 
                  new Date().toISOString().split('T')[0],
            reason: expense.expense_reason || 'No reason provided',
            description: expense.expense_reason || 'No reason provided',
            amount: amount,
            status: expense.status || 'Pending',
            project_id: expense.project_id,
            employee_id: expense.employee_id,
            originalData: expense
          };
          
          console.log('Formatted expense:', formatted);
          return formatted;
        });
        
        setExpenses(formattedExpenses);

      } catch (error) {
        console.error('Error fetching expenses:', error);
        setError(`Failed to load expenses: ${error.message}`);
        setExpenses([]);
      } finally {
        setLoading(false);
      }
    };

  const isCEO = () => {
    const accessLevel = localStorage.getItem('accessLevel');
    const userRole = currentUser?.role || localStorage.getItem('currentUserRole') || 'Employee';
    
    return accessLevel === 'full' || 
          userRole.toLowerCase().includes('ceo') ||
          userRole.toLowerCase().includes('assistant admin');  
  };
    const canEditEmployee = (employeeId) => {
      if (isCEO()) return true;
      const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
      return parseInt(currentUserId) === parseInt(employeeId);
    };
  const handleEmployeesClick = () => {
    setShowEmployeesDropdown(!showEmployeesDropdown);
    setShowProjectsDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);
    
    if (!showEmployeesDropdown) {
      setShowInvoices(false);
      setShowProjects(false);
      setShowReports(false);
      setShowVendors(false);
      setShowClients(false);
      setShowAddProject(false);
      setShowExpenses(false);
      setShowProjectUpdate(false);
      setShowUserProfile(false);
      setShowAddVendor(false);
      setShowAddClient(false);
      setShowEditVendor(false);
      setShowViewVendor(false);
      setShowEditClient(false);
      setShowViewClient(false);
      setShowTaxInvoice(false);
      setShowProformaInvoice(false);
      setShowUpdateTaxInvoice(false);
      setShowViewInvoice(false);
      setShowLeaves(false);
      setShowPerformaInvoices(false);        
      setShowPerformaInvoiceForm(false);     
      setShowUpdatePerformaInvoice(false);   
      
      setShowManageLeaves(true);
    }
  };
  const handleVendorStatusChange = (status) => {
    setSelectedVendorStatus(status);
    localStorage.setItem('selectedVendorStatus', status);
  };

  const handleClientStatusChange = (status) => {
    setSelectedClientStatus(status);
    localStorage.setItem('selectedClientStatus', status);
  };
  const handleEmployeeStatusChange = (status) => {
    setSelectedEmployeeStatus(status);
    localStorage.setItem('selectedEmployeeStatus', status);
  };
  const handleClientsClick = async () => {
    console.log('Clients page clicked - making API call...');
     setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);
    setShowReportSubmission(false);
setShowReportSubmissionView(false);
    
    setShowInvoices(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
    setShowPerformaInvoices(false);       
    setShowPerformaInvoiceForm(false);     
    setShowUpdatePerformaInvoice(false);   
    
    setShowClients(true);

    await fetchClients();
  };

const fetchPerformaInvoices = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const response = await fetch(`${API_URL}/performainvoices/get_performainvoice`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    });
    
    const result = await response.json();
    console.log('==================== DEBUG START ====================');
    console.log('Full API Response:', JSON.stringify(result, null, 2));
    
    let invoicesData = [];
    
    if (result.status === "success" && result.data) {
      invoicesData = Array.isArray(result.data) ? result.data : [result.data];
    } else if (Array.isArray(result)) {
      invoicesData = result;
    }
    
    console.log('Extracted invoices data:', invoicesData);
    
 
    invoicesData.forEach((inv, index) => {
      console.log(`Invoice ${index + 1} (ID: ${inv.invoice_id}):`, {
        performa_invoice_no: inv.performa_invoice_no,
        status: inv.status,
        raw_invoice: inv
      });
    });
    
    const transformedInvoices = invoicesData.map(invoice => {
      const transformed = transformInvoiceData(invoice);
      console.log(`Transformed Invoice ${invoice.invoice_id}:`, {
        before_status: invoice.status,
        after_status: transformed.status,
        full_transformed: transformed
      });
      return transformed;
    });
    
    console.log('Final performaInvoices state:', transformedInvoices);
    console.log('==================== DEBUG END ====================');
    
    setPerformaInvoices(transformedInvoices);
    
  } catch (error) {
    console.error("Error fetching performa invoices:", error);
    setPerformaInvoices([]);
  } finally {
    setIsLoading(false);
  }
};



const handleMarkAllRead = (e) => {
  e.stopPropagation();
  const currentUserId = localStorage.getItem('currentUserId');
  const updatedNotifications = notifications.map(notif => ({ ...notif, read: true }));
  
  localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
  setNotifications(updatedNotifications);
  setUnreadCount(0);
};

const handleNotificationClick = (id) => {
  const currentUserId = localStorage.getItem('currentUserId');
  const updatedNotifications = notifications.map(notif => 
    notif.id === id ? { ...notif, read: true } : notif
  );
  
  localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
  setNotifications(updatedNotifications);
  setUnreadCount(prev => Math.max(0, prev - 1));
};



const handleDeleteNotification = (id, e) => {
  e.stopPropagation();
  const currentUserId = localStorage.getItem('currentUserId');
  const updatedNotifications = notifications.filter(notif => notif.id !== id);
  
  localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify(updatedNotifications));
  setNotifications(updatedNotifications);
  
  const unread = updatedNotifications.filter(n => !n.read).length;
  setUnreadCount(unread);
};

const handleClearAll = (e) => {
  e.stopPropagation();
  const currentUserId = localStorage.getItem('currentUserId');
  localStorage.setItem(`notifications_${currentUserId}`, JSON.stringify([]));
  setNotifications([]);
  setUnreadCount(0);
};



const getNotificationIcon = (type) => {
  switch (type) {
    case 'leave_approval':
    case 'leave_approved':
      return <FaCheckCircle className="notif-icon success" />;
    case 'leave_rejected':
      return <FaExclamationCircle className="notif-icon danger" />;
    case 'project_assignment':
      return <FaClipboardList className="notif-icon info" />;
    case 'expense_approval':
    case 'expense_approved':
      return <FaCheckCircle className="notif-icon success" />;
    case 'expense_rejected':
      return <FaExclamationCircle className="notif-icon danger" />;
    case 'employee_update':
    case 'profile_updated_by_admin':
      return <FaUserEdit className="notif-icon info" />;
    default:
      return <FaInfoCircle className="notif-icon info" />;
  }
};


const getTimeAgo = (timestamp) => {
  const now = new Date();
  const notifTime = new Date(timestamp);
  const diffMs = now - notifTime;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  return notifTime.toLocaleDateString();
};

const filteredNotifications = filterType === 'all' 
  ? notifications 
  : notifications.filter(n => n.type && n.type.toLowerCase().includes(filterType));


const handleMarkNotificationAsRead = async (notificationId, type) => {
  const role = getUserRole();
  
  if (role !== 'EMPLOYEE') {
    return;
  }

  try {
    const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
    
    await fetch(`${API_URL}/employees/mark_notification_read`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        notification_id: notificationId,
        employee_id: currentUserId
      })
    });

    setNotifications(prev => 
      prev.map(n => n.id === notificationId ? {...n, read: true} : n)
    );
    setUnreadCount(prev => Math.max(0, prev - 1));

  } catch (error) {
    console.error('Error marking notification as read:', error);
  }
};

  const handleAddPerformaInvoice = () => {
    setShowPerformaInvoiceForm(true);
    setShowPerformaInvoices(false);
  };

  const handleBackFromPerformaInvoiceForm = async (shouldRefresh = false) => {
    setShowPerformaInvoiceForm(false);
    setShowPerformaInvoices(true);
    
    if (shouldRefresh) {
      await fetchPerformaInvoices();
    }
  };

const handleEditPerformaInvoice = async (invoice) => {

  
  const invoiceForEdit = {
    ...invoice,
    id: invoice.invoice_id || invoice.id,
    invoice_id: invoice.invoice_id || invoice.id,
    invoice_type: 'Performa Invoice',
    performa_invoice_no: invoice.performa_invoice_no || invoice.invoice_no || invoice.invoice_number,
    billed_name: invoice.billed_name || invoice.client_name,
    billed_address: invoice.billed_address,
    billed_gst_no: invoice.billed_gst_no,
    billed_pan_no: invoice.billed_pan_no,
    billed_state: invoice.billed_state,
    status: invoice.status || 'Active',  
    vendor_name: invoice.vendor_name,
    po_no: invoice.po_no,
    po_date: invoice.po_date,
    ola_no: invoice.ola_no,
    invoice_date: invoice.invoice_date,
    line_items: invoice.line_items,
    originalData: invoice
  };
  
  console.log("Performa invoice data being passed to update:", invoiceForEdit);
  console.log("Status being passed:", invoiceForEdit.status);
  
  setSelectedPerformaInvoice(invoiceForEdit);
  setShowUpdatePerformaInvoice(true);
  setShowPerformaInvoices(false);
  setShowUpdateTaxInvoice(false);
};

  const handleEditInvoice = async (invoice) => {
    console.log("Edit tax invoice clicked:", invoice);
    
    try {
      const response = await fetch(`${API_URL}/taxinvoices/get_taxinvoice/${invoice.invoice_id || invoice.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      let invoiceData;
      if (response.ok) {
        const result = await response.json();
        invoiceData = result.data || result;
      } else {
        console.warn('Could not fetch fresh invoice data, using existing data');
        invoiceData = invoice;
      }

      const invoiceForEdit = {
        ...invoiceData,
        id: invoiceData.invoice_id || invoiceData.id || invoice.id,
        invoice_id: invoiceData.invoice_id || invoice.invoice_id || invoice.id,
        invoice_type: 'Tax Invoice', 
        invoice_no: invoiceData.invoice_no || invoiceData.invoice_number || invoice.invoice_no || invoice.invoice_number || '',
        billed_name: invoiceData.billed_name || invoiceData.client_name || invoice.billed_name || invoice.client_name || '',
        vendor_name: invoiceData.vendor_name || invoice.vendor_name || '',
        description: invoiceData.description || invoice.description || '',
        rate: parseFloat(invoiceData.rate || invoice.rate || 0),
        quantity: parseFloat(invoiceData.quantity || invoice.quantity || 1),
        gross_amount: parseFloat(invoiceData.gross_amount || invoice.gross_amount || 0),
        igst_amount: parseFloat(invoiceData.igst_amount || invoice.igst_amount || 0),
        cgst_amount: parseFloat(invoiceData.cgst_amount || invoice.cgst_amount || 0),
        sgst_amount: parseFloat(invoiceData.sgst_amount || invoice.sgst_amount || 0),
        grand_total: parseFloat(invoiceData.grand_total || invoiceData.amount || invoice.grand_total || invoice.amount || 0),
        created_on: invoiceData.created_on || invoice.created_on || new Date().toISOString(),
        updated_on: invoiceData.updated_on || invoice.updated_on || new Date().toISOString(),
        status: invoiceData.status || invoice.status || 'Active',
        originalData: invoiceData || invoice
      };
      
      console.log("Tax invoice data being passed to UpdateTaxInvoice:", invoiceForEdit);
      
      setSelectedInvoice(invoiceForEdit);
      setShowUpdateTaxInvoice(true);
      setShowInvoices(false);
      setShowUpdatePerformaInvoice(false); 
      setShowReports(false);
      setShowManageLeaves(false);
      setShowLeaves(false);
      setShowProjects(false);
      setShowProjectsDropdown(false);
      setShowEmployeesDropdown(false);
      setShowClientsDropdown(false);
      setShowInvoicesDropdown(false);
      setShowProformaInvoice(false);
      setShowTaxInvoice(false);
      
    } catch (error) {
      console.error('Error fetching invoice for edit:', error);
      
      const invoiceForEdit = {
        ...invoice,
        id: invoice.invoice_id || invoice.id,
        invoice_id: invoice.invoice_id || invoice.id,
        invoice_type: 'Tax Invoice',
        invoice_no: invoice.invoice_no || invoice.invoice_number || '',
        billed_name: invoice.billed_name || invoice.client_name || '',
        vendor_name: invoice.vendor_name || '',
        description: invoice.description || '',
        rate: parseFloat(invoice.rate || 0),
        quantity: parseFloat(invoice.quantity || 1),
        gross_amount: parseFloat(invoice.gross_amount || 0),
        igst_amount: parseFloat(invoice.igst_amount || 0),
        cgst_amount: parseFloat(invoice.cgst_amount || 0),
        sgst_amount: parseFloat(invoice.sgst_amount || 0),
        grand_total: parseFloat(invoice.grand_total || invoice.amount || 0),
        originalData: invoice
      };
      
      setSelectedInvoice(invoiceForEdit);
      setShowUpdateTaxInvoice(true);
      setShowInvoices(false);
      setShowUpdatePerformaInvoice(false);
    }
  };
const handleBackFromUpdatePerformaInvoice = async () => {
  setShowUpdatePerformaInvoice(false);
  setSelectedPerformaInvoice(null);
  setShowPerformaInvoices(true);
  
 
  await fetchPerformaInvoices();
};
  const handleDeleteEmployee = async (employeeId) => {
    const confirmDelete = window.confirm('Are you sure you want to mark this employee as Inactive?');
    if (!confirmDelete) return;

    try {
      setIsLoading(true);
      setErrorMessage("");

      const response = await fetch(`${API_URL}/employees/delete_employees`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          employee_id: employeeId.toString()
        }),
      });

      const result = await response.json();

      if (response.ok && result.bool) {
        alert(result.message || 'Employee marked as Inactive successfully!');
        await fetchEmployees();
      } else {
        throw new Error(result.message || 'Failed to update employee status');
      }
    } catch (error) {
      console.error('Error updating employee status:', error);
      alert(`Failed to mark employee as Inactive: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchInvoices = async () => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const response = await fetch(`${API_URL}/taxinvoices/get_taxinvoice`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });
    
      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }
      
      const result = await response.json();
      console.log('Raw API response:', result);
      
      let invoicesData = [];
      
      if (result.status === "success" && result.data) {
        invoicesData = Array.isArray(result.data) ? result.data : [result.data];
      } else if (Array.isArray(result)) {
        invoicesData = result;
      } else {
        console.warn('Unexpected response structure:', result);
        invoicesData = [];
      }
      
      console.log('Extracted invoices data:', invoicesData);
      
      const transformedInvoices = invoicesData.map(transformInvoiceData);
      console.log('Transformed invoices:', transformedInvoices);
      
      setInvoices(transformedInvoices);
      
    } catch (error) {
      console.error("Detailed error fetching tax invoices:", error);
      
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running and accessible.");
      } else if (error.message.includes('CORS')) {
        setErrorMessage("CORS error: Backend is not allowing requests from this origin.");
      } else if (error.message.includes('404')) {
        setErrorMessage("API endpoint not found. Check if the route '/v1/taxinvoices/get_taxinvoice' exists.");
      }
      
      setInvoices([]);
    } finally {
      setIsLoading(false);
    }
  };

const transformInvoiceData = (apiInvoice) => {
  console.log('🔄 Transforming invoice:', apiInvoice.invoice_id || apiInvoice.id);
  console.log('   Raw status from API:', apiInvoice.status);
  
  const invoiceNumber = 
    apiInvoice.invoice_no || 
    apiInvoice.invoice_number || 
    apiInvoice.performa_invoice_no ||  
    apiInvoice.performainvoice_no ||
    'N/A';
  
  
  const invoiceStatus = apiInvoice.status;
  console.log('   Extracted status:', invoiceStatus);
  
  const transformed = {
    id: apiInvoice.invoice_id || apiInvoice.id,
    invoice_id: apiInvoice.invoice_id,
    invoice_number: invoiceNumber,
    invoice_no: invoiceNumber,
    client_name: apiInvoice.billed_name || apiInvoice.client_name,
    billed_name: apiInvoice.billed_name || apiInvoice.client_name,
    billed_address: apiInvoice.billed_address || apiInvoice.vendor_address || apiInvoice.client_address,
   date: apiInvoice.invoice_date || apiInvoice.created_on?.split(' ')[0] || '',
invoice_date: apiInvoice.invoice_date,
    amount: parseFloat(apiInvoice.grand_total || apiInvoice.amount || 0),
    status: invoiceStatus, 
    created_on: apiInvoice.created_on,
    updated_on: apiInvoice.updated_on,
    vendor_name: apiInvoice.vendor_name,
    description: apiInvoice.description,
    rate: apiInvoice.rate,
    quantity: apiInvoice.quantity,
    gross_amount: apiInvoice.gross_amount,
    igst_amount: apiInvoice.igst_amount,
    cgst_amount: apiInvoice.cgst_amount,
    sgst_amount: apiInvoice.sgst_amount,
    grand_total: apiInvoice.grand_total,
    performa_invoice_no: apiInvoice.performa_invoice_no,
    po_no: apiInvoice.po_no,
    po_date: apiInvoice.po_date,
    ola_no: apiInvoice.ola_no,
    invoice_date: apiInvoice.invoice_date,
    line_items: apiInvoice.line_items,
    billed_gst_no: apiInvoice.billed_gst_no,
    billed_pan_no: apiInvoice.billed_pan_no,
    billed_state: apiInvoice.billed_state,
    vendor_address: apiInvoice.vendor_address,
    vendor_gst_no: apiInvoice.vendor_gst_no,
    vendor_code: apiInvoice.vendor_code,
    originalData: apiInvoice
  };
  
  console.log('   Final transformed status:', transformed.status);
  
  return transformed;
};


const fetchEmployees = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    let url = `${API_URL}/employees/get_employees`;
    const params = new URLSearchParams();
    
   
    if (selectedEmployeeStatus && selectedEmployeeStatus !== "") {
      params.append('status', selectedEmployeeStatus);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('Navbar fetching employees from:', url);
    console.log('Selected status:', selectedEmployeeStatus);
    
    const response = await fetch(url);
    
    if (response.ok) {
      const result = await response.json();
      console.log('Navbar API Response:', result);
      
      let employeesData = [];
      
      if (Array.isArray(result)) {
        employeesData = result;
      } else if (result.employees && Array.isArray(result.employees)) {
        employeesData = result.employees;
      }
      
      const employeesWithImages = employeesData.map(employee => {
  const employeeId = employee.employee_id || employee.id;
  const storedImage = localStorage.getItem(`employee_${employeeId}_profileImage`);
  return {
    ...employee,
    id: employeeId,
    profileImage: storedImage,
    avatar: storedImage || '👤'
  };
});


employeesWithImages.sort((a, b) => {
  const idA = parseInt(a.id) || 0;
  const idB = parseInt(b.id) || 0;
  return idA - idB;
});

console.log('Navbar employees loaded:', employeesWithImages.length);
setEmployees(employeesWithImages);
      
      console.log('Navbar employees loaded:', employeesWithImages.length);
      setEmployees(employeesWithImages);
      
      const accessLevel = localStorage.getItem('accessLevel');
      if (accessLevel === 'full') {
        localStorage.setItem('allEmployeesData', JSON.stringify(employeesData));
      }
    } else {
      console.error('Failed to fetch employees:', response.status);
      setEmployees([]);
    }
    
  } catch (error) {
    console.error("Error fetching employees:", error);
    setEmployees([]);
  } finally {
    setIsLoading(false);
  }
};


  const handlePerformaInvoicesPageClick = async () => {
    console.log('Performa Invoices clicked - making API call...');
    
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);
    
    setShowReportSubmission(false);
setShowReportSubmissionView(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
    setShowInvoices(false);
    setShowPerformaInvoiceForm(false);
    setShowUpdatePerformaInvoice(false);
    
    setShowPerformaInvoices(true);

    await fetchPerformaInvoices();
  };

const handleInvoicesPageClick = async () => {
    console.log('Invoices clicked - making API call...');
    
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);

    setShowReportSubmission(false);
setShowReportSubmissionView(false);
    
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
    setShowPerformaInvoices(false);        
    setShowPerformaInvoiceForm(false);     
    setShowUpdatePerformaInvoice(false);   
    
    setShowInvoices(true);

    await fetchInvoices(); 
  };
  const handleBackFromInvoices = () => {
    setShowInvoices(false);
  };

  const filteredInvoices = invoices.filter((invoice) => {
    const invoiceNumber = invoice.invoice_number || '';
    const clientName = invoice.client_name || '';
    const vendorName = invoice.vendor_name || '';
    const amount = invoice.amount ? invoice.amount.toString() : '';
    
    return invoiceNumber.toLowerCase().includes(invoiceSearchQuery.toLowerCase()) ||
          clientName.toLowerCase().includes(invoiceSearchQuery.toLowerCase()) ||
          vendorName.toLowerCase().includes(invoiceSearchQuery.toLowerCase()) ||
          amount.includes(invoiceSearchQuery);
  });

const handleEmployeesManagementClick = async () => {
  setShowReportSubmission(false);
setShowReportSubmissionView(false);
 
  setShowManageLeaves(true);
  setShowLeaves(false);
  setShowProjects(false);
  setShowReports(false);  
  setShowProjectsDropdown(false);
  setShowEmployeesDropdown(false);
  setShowClientsDropdown(false);
  setShowInvoicesDropdown(false);
  setShowAddProject(false);
  setShowExpenses(false);
  setShowProjectUpdate(false);
  setShowVendors(false);
  setShowClients(false);
  setShowAddVendor(false);
  setShowAddClient(false);
  setShowEditVendor(false);
  setShowViewVendor(false);
  setShowTaxInvoice(false);
  setShowProformaInvoice(false);
  setShowUpdateTaxInvoice(false);
  setShowViewInvoice(false);
  setShowPerformaInvoices(false);
  setShowPerformaInvoiceForm(false);
  setShowUpdatePerformaInvoice(false);
  setShowEmployeeProject(false);

  await fetchEmployees();
};


const resetAllViews = () => {
   setShowReportSubmissionView(false);
  setShowReportSubmission(false);
  setShowManageLeaves(false);
  setShowLeaves(false);
  setShowProjects(false);
  setShowReports(false);
  setShowProjectsDropdown(false);
  setShowEmployeesDropdown(false);
  setShowClientsDropdown(false);
  setShowInvoicesDropdown(false);
  setShowAddProject(false);
  setShowExpenses(false);
  setShowProjectUpdate(false);
  setShowVendors(false);
  setShowClients(false);
  setShowAddVendor(false);
  setShowAddClient(false);
  setShowEditVendor(false);
  setShowViewVendor(false);
  setShowTaxInvoice(false);
  setShowProformaInvoice(false);
  setShowUpdateTaxInvoice(false);
  setShowViewInvoice(false);
  setShowPerformaInvoices(false);
  setShowPerformaInvoiceForm(false);
  setShowUpdatePerformaInvoice(false);
  setShowEmployeeProject(false);
  setShowUserProfile(false);
  setShowEditClient(false);
  setShowViewClient(false);
  setShowGetReports(false);
  setShowReportsList(false);
};

  const handleInvoicesClick = () => {
    setShowInvoicesDropdown(!showInvoicesDropdown);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    
    if (!showInvoicesDropdown) {
      handleInvoicesPageClick();
    }
  };
  
  const handleTaxInvoiceClick = () => {
    setShowTaxInvoice(true);
    setShowProformaInvoice(false);
    setRefreshInvoiceNumber(Date.now());
    setShowClients(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);  
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowInvoices(false);   
    console.log("Tax Invoice clicked");
  };

  const handleProformaInvoiceClick = () => {
    setShowProformaInvoice(true);
    setShowTaxInvoice(false);
    setShowClients(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    console.log("Performa Invoice clicked");
  };

  const handleBackFromProformaInvoice = async (shouldRefresh = false) => {
    setShowProformaInvoice(false);
    setShowInvoices(true);
    
    if (shouldRefresh) {
      await fetchPerformaInvoices();
    }
  };

  const handleBackFromTaxInvoice = async (shouldRefresh = false) => {
    setShowTaxInvoice(false);
    setShowInvoices(true);
    
    if (shouldRefresh) {
      await fetchInvoices();
    }
  };

  const handleLeavesClick = async () => {
    console.log('Leaves clicked - making API call...');
    
    setShowReportSubmission(false);
setShowReportSubmissionView(false);
    setShowLeaves(true);
    setShowManageLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);

    try {
      await fetchEmployeeLeaves();
    } catch (error) {
      console.error('Error in handleLeavesClick:', error);
      setErrorMessage("Failed to load leaves data");
    }
  };

  const handleExpensesClick = () => {
    setShowExpenses(true);
    setShowLeaves(false);
    setShowManageLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowAddProject(false);
    setShowProjectUpdate(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);
    setSelectedProject(null);
  };

  const handleAddVendor = () => {
    setShowAddVendor(true);
    setShowVendors(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowClients(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);
    console.log("Add Vendor clicked");
  };

  const handleAddClient = () => {
    setShowAddClient(true);
    setShowClients(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowAddVendor(false);
    setShowTaxInvoice(false);
    console.log("Add Client clicked");
  };

  const handleBackFromAddVendor = () => {
    setShowAddVendor(false);
    setShowVendors(true);
    fetchVendors();
  };

  const handleBackFromEditVendor = () => {
    setShowEditVendor(false);
    setSelectedVendor(null);
    setShowVendors(true);
    fetchVendors();
  };

  const handleBackFromViewVendor = () => {
    setShowViewVendor(false);
    setSelectedVendor(null);
    setShowVendors(true);
  };

  const handleBackFromViewClient = () => {
    setShowViewClient(false);
    setSelectedClient(null);
    setShowClients(true);
  };
  const ViewVendor = ({ vendorData, onBack }) => {
    if (!vendorData) return null;
    const hasValue = (value) => {
      return value && value !== 'N/A' && value !== '' && value !== null && value !== undefined;
    };
    return (
      <div className="user-profile-container">
        <div className="user-profile-wrapper">
          <div className="user-profile-header">
            <button onClick={onBack} className="back-button">←</button>
            <h2 className="user-profile-title">Vendor Details</h2>
          </div>

        {hasValue(vendorData.vendor_logo) && (
    <div className="user-profile-image-section">
      <img 
        src={vendorData.vendor_logo} 
        alt="Vendor Logo" 
        className="user-profile-image"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
      <h3 className="user-profile-name">{vendorData.vendor_name}</h3>
    </div>
  )}

  {!hasValue(vendorData.vendor_logo) && (
    <div className="user-profile-image-section">
      <div className="user-profile-placeholder">
        <FaUserTie style={{ fontSize: '48px' }} />
      </div>
      <h3 className="user-profile-name">{vendorData.vendor_name}</h3>
    </div>
  )}
          <div className="user-profile-info">
            <h4 className="user-profile-info-title">Basic Information</h4>
            <div className="user-profile-info-grid">
              <div className="user-profile-info-row">
                <strong className="info-label">Vendor ID:</strong>
                <span className="info-value">{vendorData.vendor_id || vendorData.id || 'N/A'}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">Vendor Name:</strong>
                <span className="info-value">{vendorData.vendor_name || 'N/A'}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">Name:</strong>
                <span className="info-value">{vendorData.name || 'N/A'}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">Contact Number:</strong>
                <span className="info-value">{vendorData.contact_number || 'N/A'}</span>
              </div>
              {vendorData.email && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Email:</strong>
                  <span className="info-value">{vendorData.email}</span>
                </div>
              )}
              <div className="user-profile-info-row">
                <strong className="info-label">Status:</strong>
                <span className={`info-value status-${(vendorData.status || 'Active').toLowerCase()}`}>
                  {vendorData.status || 'Active'}
                </span>
              </div>
            </div>
            <h4 className="user-profile-info-title">Address Information</h4>
            <div className="user-profile-info-grid">
              {(vendorData.vendor_address || vendorData.address) && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Address Line 1:</strong>
                  <span className="info-value">{vendorData.vendor_address || vendorData.address}</span>
                </div>
              )}
              {(vendorData.vendor_address2 || vendorData.address2) && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Address Line 2:</strong>
                  <span className="info-value">{vendorData.vendor_address2 || vendorData.address2}</span>
                </div>
              )}
              {(vendorData.vendor_state || vendorData.state) && (
                <div className="user-profile-info-row">
                  <strong className="info-label">State:</strong>
                  <span className="info-value">{vendorData.vendor_state || vendorData.state}</span>
                </div>
              )}
            </div>

            <h4 className="user-profile-info-title">Tax Information</h4>
            <div className="user-profile-info-grid">
              <div className="user-profile-info-row">
                <strong className="info-label">GST Number:</strong>
                <span className="info-value">{vendorData.vendor_gst_no || vendorData.gst_no || 'N/A'}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">PAN Number:</strong>
                <span className="info-value">{vendorData.vendor_pan_no || vendorData.pan_no || 'N/A'}</span>
              </div>
            </div>

            <h4 className="user-profile-info-title">Banking Information</h4>
            <div className="user-profile-info-grid">
              {vendorData.bank_name && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Bank Name:</strong>
                  <span className="info-value">{vendorData.bank_name}</span>
                </div>
              )}
              {vendorData.bank_account_number && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Account Number:</strong>
                  <span className="info-value">{vendorData.bank_account_number}</span>
                </div>
              )}
              {vendorData.ifsc_code && (
                <div className="user-profile-info-row">
                  <strong className="info-label">IFSC Code:</strong>
                  <span className="info-value">{vendorData.ifsc_code}</span>
                </div>
              )}
            </div>

            <h4 className="user-profile-info-title">System Information</h4>
            <div className="user-profile-info-grid">
              {vendorData.created_on && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Created On:</strong>
                  <span className="info-value">{new Date(vendorData.created_on).toLocaleDateString()}</span>
                </div>
              )}
              {vendorData.updated_on && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Last Updated:</strong>
                  <span className="info-value">{new Date(vendorData.updated_on).toLocaleDateString()}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const ViewClient = ({ clientData, onBack }) => {
    if (!clientData) return null;
    const hasValue = (value) => {
      return value && value !== 'N/A' && value !== '' && value !== null && value !== undefined;
    };
    return (
      <div className="user-profile-container">
        <div className="user-profile-wrapper">
          <div className="user-profile-header">
            <button onClick={onBack} className="back-button">←</button>
            <h2 className="user-profile-title">Client Details</h2>
          </div>
          {hasValue(clientData.client_logo) && (
            <div className="user-profile-image-section">
              <img 
                src={clientData.client_logo} 
                alt="Client Logo" 
                className="user-profile-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <h3 className="user-profile-name">{clientData.client_name}</h3>
            </div>
          )}

          {!hasValue(clientData.client_logo) && (
            <div className="user-profile-image-section">
              <div className="user-profile-placeholder">
                <FaUserTie style={{ fontSize: '48px' }} />
              </div>
              <h3 className="user-profile-name">{clientData.client_name}</h3>
            </div>
          )}  
          <div className="user-profile-info">
            <h4 className="user-profile-info-title">Basic Information</h4>
            <div className="user-profile-info-grid">
              <div className="user-profile-info-row">
                <strong className="info-label">Client Name:</strong>
                <span className="info-value">{clientData.client_name || 'N/A'}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">Name:</strong>
                <span className="info-value">{clientData.name || 'N/A'}</span>
              </div>
              
              {hasValue(clientData.client_id) && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Client ID:</strong>
                  <span className="info-value">{clientData.client_id}</span>
                </div>
              )}

              <div className="user-profile-info-row">
                <strong className="info-label">GST NO:</strong>
                <span className="info-value">{clientData.gst_no || clientData.client_gst_no || 'N/A'}</span>
              </div>

              {hasValue(clientData.pan_no || clientData.client_pan_no) && (
                <div className="user-profile-info-row">
                  <strong className="info-label">PAN NO:</strong>
                  <span className="info-value">{clientData.pan_no || clientData.client_pan_no}</span>
                </div>
              )}

              <div className="user-profile-info-row">
                <strong className="info-label">Contact Number:</strong>
                <span className="info-value">{clientData.contact_number || 'N/A'}</span>
              </div>

              {hasValue(clientData.email) && (
                <div className="user-profile-info-row">
                  <strong className="info-label">Email:</strong>
                  <span className="info-value">{clientData.email}</span>
                </div>
              )}
              <div className="user-profile-info-row">
                <strong className="info-label">Status:</strong>
                <span className={`info-value status-${(clientData.status || 'Active').toLowerCase()}`}>
                  {clientData.status || 'Active'}
                </span>
              </div>
            </div>
          </div>
          {(hasValue(clientData.client_address) || hasValue(clientData.address) || 
            hasValue(clientData.client_address2) || hasValue(clientData.address2) || 
            hasValue(clientData.state) || hasValue(clientData.client_state)) && (
            <div className="user-profile-info">
              <h4 className="user-profile-info-title">Address Information</h4>
              <div className="user-profile-info-grid">
                {hasValue(clientData.client_address || clientData.address) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Address Line 1:</strong>
                    <span className="info-value">{clientData.client_address || clientData.address}</span>
                  </div>
                )}

                {hasValue(clientData.client_address2 || clientData.address2) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Address Line 2:</strong>
                    <span className="info-value">{clientData.client_address2 || clientData.address2}</span>
                  </div>
                )}

                {hasValue(clientData.state || clientData.client_state) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">State:</strong>
                    <span className="info-value">{clientData.state || clientData.client_state}</span>
                  </div>
                )}

                {hasValue(clientData.city) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">City:</strong>
                    <span className="info-value">{clientData.city}</span>
                  </div>
                )}

                {hasValue(clientData.pincode) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Pincode:</strong>
                    <span className="info-value">{clientData.pincode}</span>
                  </div>
                )}
              </div>
            </div>
          )}
          {(hasValue(clientData.bank_name) || hasValue(clientData.bank_account_number) || 
            hasValue(clientData.ifsc_code)) && (
            <div className="user-profile-info">
              <h4 className="user-profile-info-title">Bank Details</h4>
              <div className="user-profile-info-grid">
                {hasValue(clientData.bank_name) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Bank Name:</strong>
                    <span className="info-value">{clientData.bank_name}</span>
                  </div>
                )}

                {hasValue(clientData.bank_account_number) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Account Number:</strong>
                    <span className="info-value">{clientData.bank_account_number}</span>
                  </div>
                )}

                {hasValue(clientData.ifsc_code) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">IFSC Code:</strong>
                    <span className="info-value">{clientData.ifsc_code}</span>
                  </div>
                )}
              </div>
            </div>
          )}     
          {(hasValue(clientData.created_on) || hasValue(clientData.updated_on)) && (
            <div className="user-profile-info">
              <h4 className="user-profile-info-title">System Information</h4>
              <div className="user-profile-info-grid">
                {hasValue(clientData.created_on) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Created On:</strong>
                    <span className="info-value">
                      {new Date(clientData.created_on).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                )}
                {hasValue(clientData.updated_on) && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Last Updated:</strong>
                    <span className="info-value">
                      {new Date(clientData.updated_on).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}     
        </div>
      </div>
    );
  };
  const handleBackFromAddClient = () => {
    setShowAddClient(false);
    setShowClients(true);
    fetchClients();
  };
  const handleBackFromLeaves = async () => {
    setShowLeaves(false);
    setShowManageLeaves(true); 
    await fetchEmployees();
  };

  const handleVendorSubmit = (newVendorData) => {
    console.log("New vendor data received:", newVendorData);
    
    setVendors(prevVendors => [
      ...prevVendors,
      newVendorData
    ]);
    console.log("Vendor added to vendors list successfully!");
  };
  const handleVendorUpdated = (updatedVendorData) => {
    console.log("Updated vendor data received:", updatedVendorData);
    setVendors(prevVendors => 
      prevVendors.map(vendor => 
        vendor.id === updatedVendorData.id || vendor.vendor_id === updatedVendorData.vendor_id
          ? updatedVendorData 
          : vendor
      )
    );
    console.log("Vendor updated in vendors list successfully!");
  };

  const handleClientSubmit = (newClientData) => {
    console.log("New client data received:", newClientData);
    
    setClients(prevClients => [
      ...prevClients,
      newClientData
    ]);
    
    console.log("Client added to clients list successfully!");
  };

  const handleCurrentEmployeeUpdate = (employeeData) => {
    console.log('Navbar received current employee update:', employeeData);
    
    setCurrentUser(employeeData);
    setUserName(employeeData.name || "User Name");
    
    if (employeeData.profileImage) {
      setProfileImage(employeeData.profileImage);
      localStorage.setItem('currentUserProfileImage', employeeData.profileImage);
    }
    
    localStorage.setItem('currentUser', JSON.stringify(employeeData));
    localStorage.setItem('currentUserName', employeeData.name);
    localStorage.setItem('currentUserId', employeeData.id.toString());
    localStorage.setItem('currentUserEmail', employeeData.email);
    
    console.log('Navbar updated with employee data:', {
      name: employeeData.name,
      id: employeeData.id,
      role: employeeData.role,
      email: employeeData.email
    });
  };
  const handleProfileImageUpdate = (imageDataUrl, name) => {
    setProfileImage(imageDataUrl);
    setUserName(name || "User Name");
    if (imageDataUrl) {
      localStorage.setItem('currentUserProfileImage', imageDataUrl);
      localStorage.setItem('currentUserName', name || "User Name");
    }
  };
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSearchChange = (value, setter) => {
    setter(value);
  };
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
      'application/msword', 
      'application/pdf',
      'image/jpeg',
      'image/png',
      'image/jpg',
      'text/plain',
      'application/vnd.ms-excel', 
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    ];

    if (!allowedTypes.includes(file.type)) {
      alert('Please upload a valid file (Word, PDF, Excel, Image, or Text file)');
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      return;
    }

    setIsUploading(true);
    setErrorMessage("");

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('project_name', file.name.split('.')[0]);
      formData.append('location', 'Unknown'); 
      formData.append('status', 'Uploaded'); 
      formData.append('upload_date', new Date().toISOString().split('T')[0]);

      const response = await fetch(`${API_URL}/reports/upload`, {
        method: 'POST',
        body: formData,
        mode: 'cors',
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Upload failed: ${response.status} - ${errorData.message || response.statusText}`);
      }

      const result = await response.json();
      console.log('File uploaded successfully:', result);

      setUploadSuccess(true);
      setTimeout(() => setUploadSuccess(false), 3000);

      if (showReports) {
        await fetchReports();
      }

      event.target.value = '';

    } catch (error) {
      console.error("Error uploading file:", error);
      
      const newReport = {
        id: Date.now(),
        name: file.name.split('.')[0],
        blocks: "1 Block",
        status: "Uploaded",
        location: "Document Upload",
        project_name: file.name.split('.')[0],
        no_of_blocks: "1",
        upload_date: new Date().toISOString().split('T')[0],
        file_type: file.type,
        file_size: (file.size / 1024).toFixed(2) + ' KB'
      };

      setReports(prevReports => [newReport, ...prevReports]);
      setUploadSuccess(true);
      setTimeout(() => setUploadSuccess(false), 3000);
      
      event.target.value = '';
    } finally {
      setIsUploading(false);
    }
  };

const filteredReports = reports.filter((report) => {
  const reportName = report.project_name || report.name || '';
  const reportLocation = report.location || '';
  const reportStatus = report.status || '';
  
  const matchesSearch = reportName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                      reportLocation.toLowerCase().includes(searchQuery.toLowerCase());
  const matchesStatus = selectedProjectStatus === "" || reportStatus === selectedProjectStatus;
  
  const role = getUserRole();
  if (role === 'EMPLOYEE') {
    
    if (assignedProjectIds.length === 0) {
      return false;
    }
    
    const matchesAssignment = assignedProjectIds.includes(report.id || report.project_id);
    return matchesSearch && matchesStatus && matchesAssignment;
  }
  
  return matchesSearch && matchesStatus;
});
  
  const filteredProjects = projects.filter((project) => {
    const matchesSearch = project.name?.toLowerCase().includes(searchQuery.toLowerCase()) || false;
    const matchesStatus = selectedProjectStatus === "" || project.status === selectedProjectStatus;
    return matchesSearch && matchesStatus;
  });

  const filteredVendors = vendors.filter((vendor) => {
    const vendorName = vendor.vendor_name || '';
    const gst_no = vendor.gst_no || '';
    const contact_number = vendor.contact_number || '';
    
    const matchesSearch = vendorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          gst_no.toLowerCase().includes(searchQuery.toLowerCase()) ||
          contact_number.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesStatus = !selectedVendorStatus || vendor.status === selectedVendorStatus;
    
    return matchesSearch && matchesStatus;
  });
  const filteredClients = clients.filter((client) => {
    const clientName = client.client_name || '';
    const gst_no = client.gst_no || '';
    const contact_number = client.contact_number || '';
    return clientName.toLowerCase().includes(clientSearchQuery.toLowerCase()) ||
          gst_no.toLowerCase().includes(clientSearchQuery.toLowerCase()) ||
          contact_number.toLowerCase().includes(clientSearchQuery.toLowerCase());
  });
const fetchReports = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const role = getUserRole();
    const isEmployeeRole = role === 'EMPLOYEE';
    let employeeProjectIds = [];
    if (isEmployeeRole) {
      employeeProjectIds = await fetchEmployeeAssignedProjects();
    }
    const response = await fetch(`${API_URL}/projects/get_projects`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'same-origin',
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
    }
    const result = await response.json();
    console.log('Fetched reports from API:', result);
    let reportsData = [];
    if (Array.isArray(result)) {
      reportsData = result;
    } else if (result.data && Array.isArray(result.data)) {
      reportsData = result.data;
    } else if (result.projects && Array.isArray(result.projects)) {
      reportsData = result.projects;
    } else if (result.project_employees && Array.isArray(result.project_employees)) {
      reportsData = result.project_employees;
    }
    console.log('Raw reports data:', reportsData);
    let filteredReportsData = reportsData;
    if (isEmployeeRole) {
      if (employeeProjectIds.length === 0) {
       
        filteredReportsData = [];
      } else {
      
        filteredReportsData = reportsData.filter(report => 
          employeeProjectIds.includes(report.project_id || report.id)
        );
      }
      console.log('Filtered reports for employee:', filteredReportsData);
    }
    
    const transformedReports = filteredReportsData.map(transformReportData);
    console.log('Transformed reports data:', transformedReports);
    
    setReports(transformedReports);
    
  } catch (error) {
    console.error("Error fetching reports:", error);
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage(`Cannot connect to server. Please check if the backend is running on ${API_URL}`);
    }
  } finally {
    setIsLoading(false);
  }
};


  const fetchProjectReports = async (projectId) => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const response = await fetch(`${API_URL}/test_report/get_test_reports?project_id=${projectId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Fetched project reports from API:', result);
      
      let reportsData = [];
      
      if (Array.isArray(result)) {
        reportsData = result;
      } else if (result.data && Array.isArray(result.data)) {
        reportsData = result.data;
      } else if (result.reports && Array.isArray(result.reports)) {
        reportsData = result.reports;
      } else if (result.test_reports && Array.isArray(result.test_reports)) {
        reportsData = result.test_reports;
      }
      
      console.log('Raw project reports data:', reportsData);
      
    
      setProjectReports(reportsData);
      
      return reportsData;
      
    } catch (error) {
      console.error("Error fetching project reports:", error);
      setErrorMessage(`Failed to load project reports: ${error.message}`);
      setProjectReports([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  };
  const transformProjectData = (apiProject) => {
    console.log('Transforming project data:', apiProject);
    
    return {
      id: apiProject.project_id,
      project_id: apiProject.project_id,
      name: apiProject.project_name,
      project_name: apiProject.project_name,
      blocks: apiProject.no_of_blocks ? `${apiProject.no_of_blocks} Blocks` : "N/A Blocks",
      status: apiProject.status,
      location: apiProject.location,
      startDate: apiProject.starting_date ? apiProject.starting_date.split('T')[0] : '',
      starting_date: apiProject.starting_date,
      vendor: apiProject.vendor_id,
      vendor_id: apiProject.vendor_id,
      vendorName: apiProject.vendor_name,
      vendor_name: apiProject.vendor_name,
      client: apiProject.client_id,
      client_id: apiProject.client_id,
      clientName: apiProject.client_name,
      client_name: apiProject.client_name,
      quotation: apiProject.amount_in_rupees,
      amount_in_rupees: apiProject.amount_in_rupees,
      city: apiProject.city || '',
      pincode: apiProject.pincode || '',
      equipment: apiProject.equipment || '',
      originalData: apiProject,
      no_of_blocks: apiProject.no_of_blocks,
      numberOfBlocks: apiProject.no_of_blocks
    };
  };

  const transformReportData = (apiReport) => {
    console.log('Transforming report data:', apiReport);
    
    return {
      id: apiReport.project_id || apiReport.id,
      name: apiReport.project_name || apiReport.name,
      blocks: apiReport.no_of_blocks ? `${apiReport.no_of_blocks} Blocks` : "N/A Blocks",
      status: apiReport.status || 'Pipelined',
      location: apiReport.location || 'Unknown Location',
      startDate: apiReport.starting_date ? apiReport.starting_date.split('T')[0] : '',
      vendor: apiReport.vendor_id,
      client: apiReport.client_id,
      quotation: apiReport.amount_in_rupees,
          city: apiReport.city || '',
          pincode: apiReport.pincode || '',
          equipment: apiReport.equipment || '',
          originalData: apiReport,
          project_name: apiReport.project_name,
          no_of_blocks: apiReport.no_of_blocks,
          numberOfBlocks: apiReport.no_of_blocks
        };
      };

  const transformVendorData = (apiVendor) => {
    console.log('Transforming vendor data:', apiVendor);
    
    return {
      id: apiVendor.vendor_id,
      vendor_id: apiVendor.vendor_id,
      vendor_name: apiVendor.vendor_name,
      vendor_address: apiVendor.vendor_address || apiVendor.address,
      vendor_address2: apiVendor.vendor_address2 || apiVendor.address2,
      vendor_gst_no: apiVendor.vendor_gst_no || apiVendor.gst_no, 
      vendor_pan_no: apiVendor.vendor_pan_no || apiVendor.pan_no, 
      vendor_state: apiVendor.vendor_state || apiVendor.state, 
      gst_no: apiVendor.gst_no || apiVendor.vendor_gst_no, 
      name: apiVendor.name,
      email: apiVendor.email,
      contact_number: apiVendor.contact_number,
      vendor_logo: apiVendor.vendor_logo,
      status: apiVendor.status || 'Active',
      bank_name: apiVendor.bank_name,
      bank_account_number: apiVendor.bank_account_number,
      ifsc_code: apiVendor.ifsc_code,
      pan_no: apiVendor.pan_no || apiVendor.vendor_pan_no,
      state: apiVendor.state || apiVendor.vendor_state,
      address: apiVendor.address || apiVendor.vendor_address,
      created_on: apiVendor.created_on,
      updated_on: apiVendor.updated_on,
      originalData: apiVendor
    };
  };

  const transformLeaveData = (apiLeave) => {
    console.log('Transforming leave data:', apiLeave);
    
    return {
      id: apiLeave.leave_id,
      leave_id: apiLeave.leave_id,
      employee_id: apiLeave.employee_id,
      reason: apiLeave.reason,
      total_days: apiLeave.total_days,
      leave_type: apiLeave.leave_type,
      from_date: apiLeave.from_date,
      to_date: apiLeave.to_date,
      originalData: apiLeave
    };
  };

  const transformClientData = (apiClient) => {
    console.log('Transforming client data:', apiClient);
    
    return {
      id: apiClient.client_id,
      client_id: apiClient.client_id,
      client_name: apiClient.client_name,
      client_address: apiClient.client_address || apiClient.address,
      client_address2: apiClient.client_address2 || apiClient.address2,
      client_gst_no: apiClient.client_gst_no || apiClient.gst_no,
      client_pan_no: apiClient.client_pan_no || apiClient.pan_no,
      client_state: apiClient.client_state || apiClient.state,
      gst_no: apiClient.gst_no || apiClient.client_gst_no,
      name: apiClient.name,
      email: apiClient.email,
      contact_number: apiClient.contact_number,
      client_logo: apiClient.client_logo,
      status: apiClient.status || 'Active',
      bank_name: apiClient.bank_name,
      bank_account_number: apiClient.bank_account_number,
      ifsc_code: apiClient.ifsc_code,
      pan_no: apiClient.pan_no || apiClient.client_pan_no,
      state: apiClient.state || apiClient.client_state,
      address: apiClient.address || apiClient.client_address,
      created_on: apiClient.created_on,
      updated_on: apiClient.updated_on,
      originalData: apiClient
    };
  };
  const fetchVendors = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      let url = `${API_URL}/vendors/get_vendor`;
      const params = new URLSearchParams();
      
      if (selectedVendorStatus) {
        params.append('status', selectedVendorStatus);
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Vendors API error: ${response.status} - ${errorData.message || response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Fetched vendors from API:', result);
      
      let vendorsData = [];
      
      if (result.status === "success" && result.data) {
        vendorsData = Array.isArray(result.data) ? result.data : [result.data];
      } else if (Array.isArray(result)) {
        vendorsData = result;
      } else if (result.vendors && Array.isArray(result.vendors)) {
        vendorsData = result.vendors;
      }
      
      console.log('Raw vendors data:', vendorsData);
      
      const transformedVendors = vendorsData.map(transformVendorData);
      console.log('Transformed vendors data:', transformedVendors);
      
      setVendors(transformedVendors);
      
    } catch (error) {
      console.error("Error fetching vendors:", error);
      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running on ${API_URL}");
      } 
      
      setVendors([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClients = async () => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Clients API error: ${response.status} - ${errorData.message || response.statusText}`);
      }
      
      const result = await response.json();
      console.log('Fetched clients from API:', result);
      
      let clientsData = [];
      
      if (Array.isArray(result)) {
        clientsData = result;
      } else if (result.data && Array.isArray(result.data)) {
        clientsData = result.data;
      } else if (result.clients && Array.isArray(result.clients)) {
        clientsData = result.clients;
      }
      
      console.log('Raw clients data:', clientsData);
      
      const transformedClients = clientsData.map(transformClientData);
      console.log('Transformed clients data:', transformedClients);
      
      setClients(transformedClients);
      
    } catch (error) {
      console.error("Error fetching clients:", error);
      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running on ${API_URL}");
      } 
      
      setClients([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleProjectsClick = async () => {
  setShowProjectsDropdown(!showProjectsDropdown);
  setShowEmployeesDropdown(false);
  setShowClientsDropdown(false);
  setShowInvoicesDropdown(false);
  setShowReportSubmission(false);
setShowReportSubmissionView(false);
  
  if (!showProjectsDropdown) {
    setShowInvoices(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowReports(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
    setShowAddProject(false);
    setShowUserProfile(false);
    setShowPerformaInvoices(false);
    setShowPerformaInvoiceForm(false);
    setShowUpdatePerformaInvoice(false);
    
    setShowProjects(true);
    setSelectedProjectStatus("");

    const role = getUserRole();
    if (role === 'EMPLOYEE') {
      await fetchEmployeeAssignedProjects();
    }
    
    await fetchProjects();
  }
};
  const handleVendorsClick = async () => {
    console.log('Vendors clicked - making API call...');
          
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);

    setShowReportSubmission(false);
setShowReportSubmissionView(false);
    
    setShowInvoices(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
    setShowPerformaInvoices(false);        
    setShowPerformaInvoiceForm(false);     
    setShowUpdatePerformaInvoice(false);   
    
    setShowVendors(true);
    setSelectedVendorStatus("Active");

    await fetchVendors();
  };

  const handleClientsPageClick = async () => {
    console.log('Clients page clicked - making API call...');
    
    setShowClients(true);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);

    await fetchClients();
  };


  const fetchProjects = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const role = getUserRole();
    const isEmployeeRole = role === 'EMPLOYEE';
    let employeeProjectIds = [];
    
    if (isEmployeeRole) {
      employeeProjectIds = await fetchEmployeeAssignedProjects();
    }

    const response = await fetch(`${API_URL}/projects/get_projects`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'same-origin',
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`API error: ${response.status} - ${errorData.message || response.statusText}`);
    }
    
    const result = await response.json();
    console.log('Fetched projects from API:', result);
    
    let projectsData = [];
    
    if (Array.isArray(result)) {
      projectsData = result;
    } else if (result.data && Array.isArray(result.data)) {
      projectsData = result.data;
    } else if (result.projects && Array.isArray(result.projects)) {
      projectsData = result.projects;
    } else if (result.project_employees && Array.isArray(result.project_employees)) {
      projectsData = result.project_employees;
    }
    
    console.log('Raw projects data:', projectsData);

    await fetchVendors();
    await fetchClients();

    const enrichedProjects = projectsData.map(project => {
      const vendor = vendors.find(v => v.vendor_id === project.vendor_id || v.id === project.vendor_id);
      const client = clients.find(c => c.client_id === project.client_id || c.id === project.client_id);
      
      return {
        ...project,
        vendor_name: vendor?.vendor_name || 'Not specified',
        client_name: client?.client_name || 'Not specified'
      };
    });
    
    let filteredProjectsData = enrichedProjects;
    
    if (isEmployeeRole) {
      if (employeeProjectIds.length === 0) {
        console.log('No projects assigned to this employee');
        filteredProjectsData = [];
      } else {
        filteredProjectsData = enrichedProjects.filter(project => 
          employeeProjectIds.includes(project.project_id || project.id)
        );
        console.log('Filtered projects for employee:', filteredProjectsData);
      }
    }
    
    const transformedProjects = filteredProjectsData.map(transformProjectData);
    console.log('Transformed projects data:', transformedProjects);
    
    setProjects(transformedProjects);
    
  } catch (error) {
    console.error("Error fetching projects:", error);
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage(`Cannot connect to server. Please check if the backend is running on ${API_URL}`);
    } 
    
    setProjects([]);
  } finally {
    setIsLoading(false);
  }
};


const handleReportsClick = async () => {
  setShowProjectsDropdown(false);
  setShowEmployeesDropdown(false);
  setShowClientsDropdown(false);
  setShowInvoicesDropdown(false);

  setShowReportSubmission(false);
setShowReportSubmissionView(false);
  
  setShowManageLeaves(false);
  setShowLeaves(false);
  setShowProjects(false);
  setShowAddProject(false);
  setShowExpenses(false);
  setShowProjectUpdate(false);
  setShowUserProfile(false);
  setShowVendors(false);
  setShowClients(false);
  setShowAddVendor(false);
  setShowAddClient(false);
  setShowEditVendor(false);
  setShowViewVendor(false);
  setShowEditClient(false);
  setShowViewClient(false);
  setShowTaxInvoice(false);
  setShowProformaInvoice(false);
  setShowInvoices(false);
  setShowUpdateTaxInvoice(false);
  setShowViewInvoice(false);
  setShowReportsList(false);
  setSelectedProjectForReports(null);
  setShowPerformaInvoices(false);
  setShowPerformaInvoiceForm(false);
  setShowUpdatePerformaInvoice(false);
  
  setShowReports(true);
  setSelectedProjectStatus("");

  const role = getUserRole();
  if (role === 'EMPLOYEE') {
   
    await fetchEmployeeAssignedProjects();
  }
  
  await fetchReports();
};
  
  const handleBackFromManageLeaves = () => {
    setShowManageLeaves(false);
    setShowReports(true);
  };


  const sendLeaveApprovalNotification = (leave, approverName) => {
  const notification = {
    id: Date.now(),
    type: 'leave_approved',
    message: `Your ${leave.leave_type || 'leave'} request from ${new Date(leave.from_date).toLocaleDateString()} to ${new Date(leave.to_date).toLocaleDateString()} has been approved`,
    details: {
      approver: approverName,
      leaveType: leave.leave_type,
      fromDate: leave.from_date,
      toDate: leave.to_date,
      totalDays: leave.total_days
    },
    timestamp: new Date().toISOString(),
    read: false
  };

  const existingNotifications = JSON.parse(localStorage.getItem(`notifications_${leave.employee_id}`) || '[]');
  existingNotifications.unshift(notification);
  localStorage.setItem(`notifications_${leave.employee_id}`, JSON.stringify(existingNotifications));
  
  window.dispatchEvent(new Event('notificationUpdate'));
};

  const handleBackFromAddProject = () => {
    setShowAddProject(false);
    setShowProjects(true);
    
    fetchProjects();
  };

  const handleBackFromExpenses = () => {
    setShowExpenses(false);
    setSelectedProject(null);
    setShowProjects(true); 
  };

  const handleBackFromProjectUpdate = async () => {
    setShowProjectUpdate(false);
    setProjectToUpdate(null);
    setShowProjects(true);
    
    await fetchProjects();
  };

  const handleBackFromVendors = () => {
    setShowVendors(false);
    setShowReports(true); 
  };

  const handleBackFromClients = () => {
    setShowClients(false);
    setShowReports(true); 
  };

  const handleProjectStatusClick = (status) => {
    setSelectedProjectStatus(status);
    setShowProjectsDropdown(false);
    
    if (!showProjects) {
      setShowProjects(true);
      setShowReports(false);
      setShowManageLeaves(false);
      setShowLeaves(false);
      setShowAddProject(false);
      setShowExpenses(false);
      setShowProjectUpdate(false);
      setShowVendors(false);
      setShowClients(false);
      setShowInvoices(false);
      setShowTaxInvoice(false);
      setShowProformaInvoice(false);
      setShowUpdateTaxInvoice(false);
    }
  };

  const handleAddProject = () => {
    setShowAddProject(true);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);
    console.log("Add Project clicked");
  };

  const handleProjectSubmit = (newProjectData) => {
    console.log("New project data received:", newProjectData);
    
    const transformedNewProject = transformProjectData(newProjectData);
    
    setProjects(prevProjects => [
      ...prevProjects,
      transformedNewProject
    ]);
    
    console.log("Project added to projects successfully!");
  };

  const handleDeleteProject = async (projectId) => {
    setProjects(prevProjects => prevProjects.filter(project => project.id !== projectId));
    console.log(`Project with ID ${projectId} deleted successfully!`);
  };

  const handleUpdateProject = (project) => {
    console.log("Update project clicked:", project);
    setProjectToUpdate(project);
    setShowProjectUpdate(true);
    setShowProjects(false);
    setShowReports(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);
  };

  const handleProjectUpdateSubmit = async (updatedProjectData) => {
    console.log("Updated project data received:", updatedProjectData);
    
    setProjects(prevProjects => 
      prevProjects.map(project => 
        project.id === updatedProjectData.id ? updatedProjectData : project
      )
    );
    
    console.log(`Project with ID ${updatedProjectData.id} updated successfully!`);
    
    handleBackFromProjectUpdate();
    
    await fetchProjects();
  };
  const handleProjectClick = async (project) => {
    console.log("Project clicked:", project);
    
    try {
      const projectExpenses = await fetchProjectExpenses(project.id);
      
      const projectWithExpenses = {
        ...project,
        expenses: projectExpenses
      };
      
      setSelectedProject(projectWithExpenses);
      setShowExpenses(true);
      setShowProjects(false);
      setShowReports(false);
      setShowManageLeaves(false);
      setShowLeaves(false);
      setShowAddProject(false);
      setShowProjectUpdate(false);
      setShowUserProfile(false);
      setShowVendors(false);
      setShowClients(false);
      setShowAddVendor(false);
      setShowAddClient(false);
      setShowEditVendor(false);
      setShowViewVendor(false);
      setShowTaxInvoice(false);
    } catch (error) {
      console.error("Error fetching project expenses:", error);
      setSelectedProject(project);
      setShowExpenses(true);
      setShowProjects(false);
    }
  };

  const handleEditClient = (client) => {
    console.log("Edit client clicked:", client);
    
    const clientForEdit = {
      ...client,
      id: client.id || client.client_id,
      client_id: client.client_id || client.id,
      client_name: client.client_name || '',
      gst_no: client.gst_no || '',
      contact_number: client.contact_number || '',
      client_logo: client.client_logo || null,
      created_on: client.created_on,
      updated_on: client.updated_on,
      originalData: client.originalData || client
    };
    
    console.log("Client data being passed to EditClient:", clientForEdit);
    
    setSelectedClient(clientForEdit);
    setShowEditClient(true);
    setShowClients(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
  };

  const handleViewProfile = () => {
    setShowUserProfile(true);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowTaxInvoice(false);
    setShowProfileMenu(false);
  };



  const handleViewProjectReports = async (project) => {
    console.log("View reports clicked for project:", project);
    

    const projectWithId = {
      ...project,
      project_id: project.id || project.project_id,
      id: project.id || project.project_id,
      project_name: project.project_name || project.name,
      name: project.project_name || project.name,
      location: project.location,
      client_name: project.client_name || project.clientName,
      vendor_name: project.vendor_name || project.vendorName,
      status: project.status,
      no_of_blocks: project.no_of_blocks || project.numberOfBlocks
    };
    
    console.log("Processed project data:", projectWithId);
    setSelectedProjectForReports(projectWithId);
    setShowGetReports(true);
    setShowReportsList(false);
    setShowReports(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowInvoices(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
  };
  const handleBackFromGetReports = () => {
    setShowGetReports(false);
    setSelectedProjectForReports(null);
    setProjectReports([]);
    setShowReports(true);
  };
  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserEmail');
    localStorage.removeItem('currentUserName');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('currentUserProfileImage');
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUserRole');
    localStorage.removeItem('accessLevel');  
    localStorage.removeItem('allEmployeesData');  
    
    if (onLogout) {
      onLogout();
    }
  };
  const handleBackFromReportsList = () => {
    setShowReportsList(false);
    setSelectedProjectForReports(null);
    setProjectReports([]);  
    setShowReports(true);
  };

  const handleBackFromProfile = () => {
    setShowUserProfile(false);
    setShowManageLeaves(true);
  };

  const getCurrentPageTitle = () => {
      if (showReportSubmission) return "Report Submission";
    if (showGetReports) return "Reports / Test Reports"; 
    if (showReportsList) return "Reports / Project Details"; 
    if (showUserProfile) return "User Profile";
    if (showManageLeaves) return "Employees";
    if (showLeaves) return "Employees / Leaves";

    if (showPerformaInvoices) return "Performa Invoices";
  if (showPerformaInvoiceForm) return "Add Invoice /Performa Invoice";
  if (showUpdatePerformaInvoice) return "Performa Invoice / Update Performa Invoice";
    if (showProjects) {
      const baseTitle = "Projects";
      if (selectedProjectStatus) {
        return `${baseTitle} / ${selectedProjectStatus}`;
      }
      return baseTitle;
    }
    if (showAddProject) return "Projects";
    if (showVendors) return "Vendors";
    if (showClients) return "Clients";
    if (showAddVendor) return "Vendors ";
    if (showAddClient) return "Clients ";
    if (showEditVendor) return "Vendors ";
    if (showEditClient) return "Clients ";
    if (showViewVendor) return "Vendors ";
    if (showInvoices) return "Tax Invoices";
    if (showTaxInvoice) return "Add Invoice / Tax Invoice";
    if (showProformaInvoice) return "Proforma Invoice";
    if (showUpdateTaxInvoice) return "Tax Invoices / Update Tax Invoice";
    if (showProjectUpdate && projectToUpdate) {
      const projectName = projectToUpdate.name || "Unknown Project";
      return `Projects `;
    }
    if (showExpenses && selectedProject) {
      const projectName = selectedProject.project_name || selectedProject.name || "Unknown Project";
      return `Projects`;
    }
    const baseTitle = "Reports";
    if (selectedProjectStatus) {
      return `${baseTitle} / ${selectedProjectStatus}`;
    }
    return baseTitle;
  };

  const handleEmployeeAdded = (newEmployee) => {
    if (newEmployee.profileImage) {
      localStorage.setItem(`employee_${newEmployee.id}_profileImage`, newEmployee.profileImage);
    }
    
    setEmployees(prevEmployees => [...prevEmployees, newEmployee]);
    
    const currentUserId = localStorage.getItem('currentUserId');
    if (currentUserId && parseInt(currentUserId) === newEmployee.id) {
      handleProfileImageUpdate(newEmployee.profileImage, newEmployee.name);
    }
  };

  const handleEmployeeUpdated = (updatedEmployee) => {
    if (updatedEmployee.profileImage) {
      localStorage.setItem(`employee_${updatedEmployee.id}_profileImage`, updatedEmployee.profileImage);
    }
    if (!canEditEmployee(updatedEmployee.id)) {
      alert('You do not have permission to edit this employee');
      return;
    }
    
    setEmployees(prevEmployees => 
      prevEmployees.map(emp => 
        emp.id === updatedEmployee.id ? updatedEmployee : emp
      )
    );
    
    const currentUserId = localStorage.getItem('currentUserId');
    if (currentUserId && parseInt(currentUserId) === updatedEmployee.id) {
      handleProfileImageUpdate(updatedEmployee.profileImage, updatedEmployee.name);
    }
  };

  const handleViewVendor = (vendor) => {
    console.log("View vendor clicked:", vendor);
    setSelectedVendor(vendor);
    setShowViewVendor(true);
    setShowVendors(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
    setShowTaxInvoice(false);
    setShowProformaInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowViewInvoice(false);
    setShowInvoices(false);
  };

  const handleEditVendor = (vendor) => {
    console.log("Edit vendor clicked:", vendor);
    setSelectedVendor(vendor);
    setShowEditVendor(true);
    setShowVendors(false);
    setShowViewVendor(false);
  };

const handleViewInvoice = (invoice) => {
  console.log("View invoice clicked:", invoice);

  const invoiceWithType = {
    ...invoice,
    invoice_type: invoice.invoice_type || 
                  (invoice.performa_invoice_no ? 'Performa Invoice' : 'Tax Invoice'),
    sourceNavbar: invoice.performa_invoice_no ? 'performa' : 'tax'
  };

    setViewInvoiceData(invoiceWithType);
    setShowViewInvoice(true);
    setShowInvoices(false);
    setShowPerformaInvoices(false);
    setShowManageLeaves(false);
    setShowLeaves(false);
    setShowProjects(false);
    setShowReports(false);
    setShowProjectsDropdown(false);
    setShowEmployeesDropdown(false);
    setShowClientsDropdown(false);
    setShowInvoicesDropdown(false);
    setShowProformaInvoice(false);
    setShowTaxInvoice(false);
    setShowUpdateTaxInvoice(false);
    setShowAddProject(false);
    setShowExpenses(false);
    setShowProjectUpdate(false);
    setShowUserProfile(false);
    setShowVendors(false);
    setShowClients(false);
    setShowAddVendor(false);
    setShowAddClient(false);
    setShowEditVendor(false);
    setShowViewVendor(false);
    setShowEditClient(false);
    setShowViewClient(false);
  };

const handleBackFromViewInvoice = (invoiceType) => {
  setShowViewInvoice(false);
  const sourceNavbar = viewInvoiceData?.sourceNavbar;
  setViewInvoiceData(null);
  
  if (invoiceType === 'Performa Invoice' || sourceNavbar === 'performa') {
    setShowPerformaInvoices(true);
    setShowInvoices(false);
  } else {
    setShowInvoices(true);
    setShowPerformaInvoices(false);
  }
};

  const ViewInvoice = ({ invoiceData, onBack }) => {
    if (!invoiceData) return null;

    return (
      <div className="user-profile-container">
        <div className="user-profile-wrapper">
          <div className="user-profile-header">
            <button onClick={onBack} className="back-button">←</button>
            <h2 className="user-profile-title">Invoice Details</h2>
          </div>

          <div className="user-profile-info">
            <div className="user-profile-info-grid">
              <div className="user-profile-info-row">
                <strong className="info-label">Invoice Number:</strong>
                <span className="info-value">{invoiceData.invoice_number}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">Vendor Name:</strong>
                <span className="info-value">{invoiceData.vendor_name || 'N/A'}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">Billed To:</strong>
                <span className="info-value">{invoiceData.client_name}</span>
              </div>
              
              <div className="user-profile-info-row">
                <strong className="info-label">Gross Amount:</strong>
                <span className="info-value">₹{invoiceData.gross_amount?.toLocaleString()}</span>
              </div>
              <div className="user-profile-info-row">
                <strong className="info-label">IGST:</strong>
                <span className="info-value">₹{invoiceData.igst_amount?.toLocaleString()}</span>
              </div>
              <div className="user-profile-info-row">
    <strong className="info-label">CGST:</strong>
    <span className="info-value">₹{invoiceData.cgst_amount?.toLocaleString()}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">SGST:</strong>
    <span className="info-value">₹{invoiceData.sgst_amount?.toLocaleString()}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">Grand Total:</strong>
    <span className="info-value">₹{invoiceData.amount?.toLocaleString()}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">Date:</strong>
    <span className="info-value">{new Date(invoiceData.date || invoiceData.created_on).toLocaleDateString()}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">Description:</strong>
    <span className="info-value">{invoiceData.description || 'N/A'}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">Rate:</strong>
    <span className="info-value">₹{invoiceData.rate?.toLocaleString()}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">Quantity:</strong>
    <span className="info-value">{invoiceData.quantity}</span>
  </div>
  <div className="user-profile-info-row">
    <strong className="info-label">Status:</strong>
    <span className="info-value status-active">{invoiceData.status}</span>
  </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
    const handleBackFromUpdateTaxInvoice = () => {
      setShowUpdateTaxInvoice(false);
      setSelectedInvoice(null);
      setShowInvoices(true);
    
      fetchInvoices();
    };

    const handleDeleteVendor = async (vendorId) => {
      try {
        setIsLoading(true);
        setErrorMessage("");

        const formData = new FormData();
        formData.append('vendor_id', vendorId);

        const response = await fetch(`${API_URL}/vendors/delete_vendor`, {
          method: 'DELETE',
          body: formData,
          mode: 'cors',
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(`Failed to delete vendor: ${errorData.message || response.statusText}`);
        }

        const result = await response.json();
        console.log('Vendor deleted successfully:', result);

        setVendors(prevVendors => 
          prevVendors.map(vendor => 
            vendor.id === vendorId || vendor.vendor_id === vendorId
              ? { ...vendor, status: 'Inactive' }
              : vendor
          )
        );

        alert('Vendor has been marked as Inactive successfully!');
        
        await fetchVendors();

      } catch (error) {
        console.error('Error deleting vendor:', error);
        alert('Failed to update vendor status');
      } finally {
        setIsLoading(false);
      }
    };

    const handleViewClient = (client) => {
      console.log("View client clicked:", client);
      setSelectedClient(client);
      setShowViewClient(true);
      setShowClients(false);
      setShowManageLeaves(false);
      setShowLeaves(false);
      setShowProjects(false);
      setShowReports(false);
      setShowProjectsDropdown(false);
      setShowEmployeesDropdown(false);
      setShowClientsDropdown(false);
      setShowInvoicesDropdown(false);
      setShowAddProject(false);
      setShowExpenses(false);
      setShowProjectUpdate(false);
      setShowUserProfile(false);
      setShowVendors(false);
      setShowAddVendor(false);
      setShowAddClient(false);
      setShowEditVendor(false);
      setShowEditClient(false);
      setShowViewVendor(false);
      setShowTaxInvoice(false);
      setShowProformaInvoice(false);
      setShowUpdateTaxInvoice(false);
      setShowViewInvoice(false);
      setShowInvoices(false);
    };

    const handleDeleteClient = async (clientId) => {
      try {
        setIsLoading(true);
        setErrorMessage("");

        const formData = new FormData();
        formData.append('client_id', clientId);

        const response = await fetch(`${API_URL}/clients/delete_client`, {
          method: 'DELETE',
          body: formData,
          mode: 'cors',
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(`Failed to delete client: ${errorData.message || response.statusText}`);
        }

        const result = await response.json();
        console.log('Client deleted successfully:', result);

        setClients(prevClients => 
          prevClients.map(client => 
            client.id === clientId || client.client_id === clientId
              ? { ...client, status: 'Inactive' }
              : client
          )
        );

        alert('Client has been marked as Inactive successfully!');
        
        await fetchClients();

      } catch (error) {
        console.error('Error deleting client:', error);
        alert('Failed to update client status');
      } finally {
        setIsLoading(false);
      }
    };
      
    const UserProfile = () => {
      return (
        <div className="user-profile-container">
          <div className="user-profile-wrapper">
            <div className="user-profile-header">
              <button 
                onClick={handleBackFromProfile}
                className="back-button"
              >
                ←
              </button>
              <h2 className="user-profile-title">User Profile</h2>
            </div>

            <div className="user-profile-image-section">
              {profileImage ? (
                <img 
                  src={profileImage} 
                  alt="Profile" 
                  className="user-profile-image"
                />
              ) : (
                <div className="user-profile-placeholder">
                  <FaUser />
                </div>
              )}
              <h3 className="user-profile-name">{userName}</h3>
              <p className="user-profile-email">{currentUser?.email || localStorage.getItem('currentUserEmail') || 'No email available'}</p>
            </div>

            <div className="user-profile-info">
              <h4 className="user-profile-info-title">Personal Information</h4>
              <div className="user-profile-info-grid">
                <div className="user-profile-info-row">
                  <strong className="info-label">Full Name:</strong>
                  <span className="info-value">{userName}</span>
                </div>
                <div className="user-profile-info-row">
                  <strong className="info-label">Email:</strong>
                  <span className="info-value">{currentUser?.email || localStorage.getItem('currentUserEmail') || 'Not available'}</span>
                </div>
                <div className="user-profile-info-row">
                  <strong className="info-label">Employee ID:</strong>
                  <span className="info-value">{currentUser?.employee_id || currentUser?.id || localStorage.getItem('currentUserId') || 'Not available'}</span>
                </div>
                <div className="user-profile-info-row">
                  <strong className="info-label">Role:</strong>
                  <span className="info-value">{currentUser?.role || 'User'}</span>
                </div>
                <div className="user-profile-info-row">
                  <strong className="info-label">Status:</strong>
                  <span className="info-value status-active">{currentUser?.status || 'Active'}</span>
                </div>
                {currentUser?.phone && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Phone:</strong>
                    <span className="info-value">{currentUser.phone}</span>
                  </div>
                )}
                {currentUser?.department && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Department:</strong>
                    <span className="info-value">{currentUser.department}</span>
                  </div>
                )}
                {currentUser?.joinDate && (
                  <div className="user-profile-info-row">
                    <strong className="info-label">Join Date:</strong>
                    <span className="info-value">{new Date(currentUser.joinDate).toLocaleDateString()}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="user-profile-logout-section">
              <button
                onClick={handleLogout}
                className="logout-button"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      );
    };

    function hasImage(logo) {
      if (!logo || typeof logo !== "string") return false;
      return (
        logo.startsWith("data:image/") ||
        logo.startsWith("http://") ||
        logo.startsWith("https://")
      );
    }

    const handleBackFromEditClient = () => {
      setShowEditClient(false);
      setSelectedClient(null);
      setShowClients(true);
      fetchClients(); 
    };

    const handleClientUpdated = (updatedClientData) => {
      console.log("Updated client data received:", updatedClientData);
      
      setClients(prevClients => 
        prevClients.map(client => 
          client.id === updatedClientData.id || client.client_id === updatedClientData.client_id
            ? updatedClientData 
            : client
        )
      );
      
      console.log("Client updated in clients list successfully!");
    };

    const transformExpenseData = (apiExpense) => {
      console.log('Transforming expense data:', apiExpense);
      
      return {
        id: apiExpense.expense_id || apiExpense.id,
        expense_id: apiExpense.expense_id,
        project_id: apiExpense.project_id,
        expense_type: apiExpense.expense_type,
        amount: apiExpense.amount,
        description: apiExpense.description,
        date: apiExpense.expense_date ? apiExpense.expense_date.split('T')[0] : '',
        created_date: apiExpense.created_date,
        updated_date: apiExpense.updated_date,
        receipt_image: apiExpense.receipt_image,
        category: apiExpense.category,
        vendor_name: apiExpense.vendor_name,
        originalData: apiExpense
      };
    };

    const handleInvoiceUpdated = (updatedInvoiceData) => {
      console.log("Updated invoice data received:", updatedInvoiceData);
      
      setInvoices(prevInvoices => 
        prevInvoices.map(invoice => 
          invoice.id === updatedInvoiceData.id || invoice.invoice_id === updatedInvoiceData.invoice_id
            ? updatedInvoiceData 
            : invoice
        )
      );
      
      console.log("Invoice updated in invoices list successfully!");
    };
    const handleExpenseAdded = async (newExpense, projectId) => {
      console.log("New expense added:", newExpense);
      
      if (selectedProject && (selectedProject.project_id === projectId || selectedProject.id === projectId)) {
        const updatedExpenses = await fetchProjectExpenses(projectId);
        
        const updatedProject = {
          ...selectedProject,
          expenses: updatedExpenses
        };
        
        setSelectedProject(updatedProject);
        console.log("Project expenses updated after adding new expense");
      }
    };
    const handleExpenseUpdated = async (updatedExpense, projectId) => {
      console.log("Expense updated:", updatedExpense);
      
      if (selectedProject && (selectedProject.project_id === projectId || selectedProject.id === projectId)) {
        const updatedExpenses = await fetchProjectExpenses(projectId);
        
        const updatedProject = {
          ...selectedProject,
          expenses: updatedExpenses
        };
        
        setSelectedProject(updatedProject);
        console.log("Project expenses updated after expense modification");
      }
    };




const ReportSubmissionDisplay = ({ 
  reports, 
  searchQuery, 
  onSearchChange,
  onViewReport,
  onUploadReport
}) => {
  const [uploadingFiles, setUploadingFiles] = React.useState({});
  const [uploadProgress, setUploadProgress] = React.useState({});
  const fileInputRefs = React.useRef({});

  const handleUploadClick = (report) => {
    console.log('=== UPLOAD ICON CLICKED ===');
    console.log('Report:', report);
    console.log('Report ID:', report.id);
    
   
    if (!fileInputRefs.current[report.id]) {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.accept = '.doc,.docx,.pdf,.xls,.xlsx,.zip,.rar,.txt,.jpg,.jpeg,.png,.gif';
      input.style.display = 'none';
      input.onchange = (e) => handleFileChange(e, report);
      document.body.appendChild(input);
      fileInputRefs.current[report.id] = input;
    }
    
    const fileInput = fileInputRefs.current[report.id];
    
    
    if (fileInput && fileInput.value !== undefined) {
      fileInput.value = '';
    }
    
   
    fileInput.click();
    console.log('File input clicked');
  };

  const handleFileChange = async (event, report) => {
    console.log('=== FILE CHANGE EVENT ===');
    console.log('Event:', event);
    console.log('Files:', event.target.files);
    
   
    const fileInput = event.target;
    const files = Array.from(fileInput.files);
    
    if (files.length === 0) {
      console.log('No files selected');
      return;
    }

    const projectId = report?.project_id || report?.id;
    
    if (!projectId) {
      alert('Error: Project ID not found');
      return;
    }

    console.log(`Starting upload for ${files.length} file(s) to project ${projectId}`);
    
  
    setUploadingFiles(prev => ({ ...prev, [report.id]: true }));
    setUploadProgress(prev => ({ ...prev, [report.id]: '0%' }));
    
    let successCount = 0;
    let failCount = 0;
    const errors = [];
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      
      try {
        console.log(`\n=== Processing file ${i + 1}/${files.length}: ${file.name} ===`);
        setUploadProgress(prev => ({ 
          ...prev, 
          [report.id]: `Processing ${i + 1}/${files.length}...` 
        }));
        
        
        if (file.size > 10 * 1024 * 1024) {
          throw new Error(`File size must be less than 10MB`);
        }

        console.log(`File size: ${(file.size / 1024).toFixed(2)} KB`);

        
        console.log('Converting to base64...');
        const base64File = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          
          reader.onload = () => {
            console.log('✓ File converted to base64 successfully');
            resolve(reader.result);
          };
          
          reader.onerror = (error) => {
            console.error('✗ FileReader error:', error);
            reject(new Error(`Failed to read file: ${error}`));
          };
          
          reader.onabort = () => {
            console.error('✗ FileReader aborted');
            reject(new Error('File reading was aborted'));
          };
          
          reader.readAsDataURL(file);
        });

        
        const getMimeType = (filename) => {
          const ext = filename.split('.').pop().toLowerCase();
          const mimeTypes = {
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'pdf': 'application/pdf',
            'txt': 'text/plain',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'zip': 'application/zip',
            'rar': 'application/x-rar-compressed'
          };
          return mimeTypes[ext] || 'application/octet-stream';
        };

        const mimeType = getMimeType(file.name);
        console.log(`MIME type: ${mimeType}`);

        const uploadPayload = {
          base64_file: base64File,
          filename: file.name,
          file_type: mimeType,
          file_size: file.size,
          project_id: parseInt(projectId)
        };

        console.log('Upload payload prepared (without base64 data):', {
          filename: uploadPayload.filename,
          file_type: uploadPayload.file_type,
          file_size: uploadPayload.file_size,
          project_id: uploadPayload.project_id,
          base64_length: base64File.length
        });

        setUploadProgress(prev => ({ 
          ...prev, 
          [report.id]: `Uploading ${i + 1}/${files.length}...` 
        }));

        console.log(`Sending POST request to ${API_URL}/user_uploads/create_user_uploads`);
        
        
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 60000); 

        const response = await fetch(`${API_URL}/user_uploads/create_user_uploads`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          body: JSON.stringify(uploadPayload),
          signal: controller.signal
        }).finally(() => clearTimeout(timeoutId));

        console.log('Response status:', response.status);
        console.log('Response ok:', response.ok);

        if (!response.ok) {
          let errorMessage;
          try {
            const errorData = await response.json();
            console.error('Error response data:', errorData);
            errorMessage = errorData.message || errorData.error || `HTTP ${response.status}`;
          } catch (e) {
            const errorText = await response.text();
            console.error('Error response text:', errorText);
            errorMessage = errorText || `HTTP ${response.status}`;
          }
          throw new Error(errorMessage);
        }

        const result = await response.json();
        console.log('✓ Upload response:', result);

        if (result.status === 'success' || result.message?.includes('success')) {
          successCount++;
          console.log(`✓ Successfully uploaded: ${file.name}`);
        } else {
          throw new Error(result.message || result.error || 'Upload failed - unknown error');
        }

      } catch (error) {
        failCount++;
        console.error(`✗ Error uploading ${file.name}:`, error);
        
        let errorMsg = error.message;
        if (error.name === 'AbortError') {
          errorMsg = 'Upload timeout (60s exceeded)';
        }
        
        errors.push(`${file.name}: ${errorMsg}`);
      }
    }

 
    setUploadingFiles(prev => ({ ...prev, [report.id]: false }));
    setUploadProgress(prev => ({ ...prev, [report.id]: '' }));
    
    
    console.log(`\n=== UPLOAD SUMMARY ===`);
    console.log(`Success: ${successCount}, Failed: ${failCount}`);
    
    if (successCount > 0 && failCount === 0) {
      const message = successCount === 1 
        ? `✓ ${files[0].name} uploaded successfully!`
        : `✓ ${successCount} file(s) uploaded successfully!`;
      alert(message);
    } else if (successCount > 0 && failCount > 0) {
      alert(`✓ ${successCount} file(s) uploaded successfully\n\n✗ ${failCount} failed:\n${errors.join('\n')}`);
    } else if (failCount > 0) {
      alert(`✗ All uploads failed:\n\n${errors.join('\n')}`);
    }
    
    
    try {
      if (fileInput && fileInput.value !== undefined && fileInput.value !== null) {
        fileInput.value = '';
      }
    } catch (e) {
      console.warn('Could not reset file input:', e);
      
    }
  };

  
  React.useEffect(() => {
    return () => {
     
      Object.values(fileInputRefs.current).forEach(input => {
        try {
          if (input && input.parentNode) {
            input.parentNode.removeChild(input);
          }
        } catch (e) {
          console.warn('Error removing file input:', e);
        }
      });
      fileInputRefs.current = {};
    };
  }, []);

  const filteredReports = reports.filter((report) => {
    const reportName = report.project_name || report.name || '';
    const reportLocation = report.location || '';
    const reportStatus = report.status || '';
    
    return reportName.toLowerCase().includes(searchQuery.toLowerCase()) ||
           reportLocation.toLowerCase().includes(searchQuery.toLowerCase()) ||
           reportStatus.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div>
      <div className="search-add-section">
        <div className="search-container">
          <div className="icon-wrapper"><FaSearch /></div>
          <div className="Search-bar">
            <input
              type="text"
              placeholder="        Search Report Details"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
      </div>

      <section className="data-container">
        <div className="header-row1">
          <div className="column1"><span>PROJECT NAME</span></div>
          <div className="column1"><span>NO.OF. BLOCKS</span></div>
          <div className="column1"><span>LOCATION</span></div>
          <div className="column1"><span>ACTIONS</span></div>
        </div>
        <hr className="divider" />
        
        {filteredReports.length === 0 ? (
          <div className="no-data-message">
            {searchQuery ? `No reports match "${searchQuery}"` : "No reports found"}
          </div>
        ) : (
          <>
            <div className="data-count-info">
              Showing {filteredReports.length} of {reports.length} reports
            </div>
            {filteredReports.map((report) => (
              <div key={report.id} className="data-row">
                <div className="column1">
                  <span>{report.project_name || report.name}</span>
                </div>
                <div className="column1">
                  <span>{report.no_of_blocks || report.blocks}</span>
                </div>
                <div className="column1">
                  <span>{report.location}</span>
                </div>
                <div className="column1 actions">
  <FaEye
    className="action-icon view-icon"
    title="View Reports"
    onClick={() => onViewReport(report)}
  />
  {getUserRole() !== 'CLIENT' && (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <FaUpload
        className={`action-icon edit-icon ${uploadingFiles[report.id] ? 'uploading' : ''}`}
        title={uploadingFiles[report.id] ? uploadProgress[report.id] : "Upload Report"}
        onClick={() => !uploadingFiles[report.id] && handleUploadClick(report)}
        style={{ 
          cursor: uploadingFiles[report.id] ? 'wait' : 'pointer',
          opacity: uploadingFiles[report.id] ? 0.6 : 1
        }}
      />
      {uploadingFiles[report.id] && (
        <span style={{ 
          position: 'absolute', 
          top: '100%', 
          left: '50%', 
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap',
          fontSize: '10px',
          color: '#666'
        }}>
          {uploadProgress[report.id]}
        </span>
      )}
    </div>
  )}
</div>
              </div>
            ))}
          </>
        )}
      </section>
    </div>
  );
};

const handleViewReportSubmission = async (report) => {
  console.log("View report submission clicked:", report);
  
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const projectId = report.project_id || report.id;
    
    if (!projectId) {
      throw new Error('Project ID is missing');
    }
    
    const response = await fetch(`${API_URL}/user_uploads/get_user_uploads?project_id=${projectId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      // throw new Error(`Failed to fetch reports: ${errorData.message || response.statusText}`);
    }

    const result = await response.json();
    console.log('Fetched uploaded reports:', result);
    
    let uploadedReports = [];
    if (result.status === 'success' && result.data) {
      uploadedReports = Array.isArray(result.data) ? result.data : [result.data];
    } else if (Array.isArray(result)) {
      uploadedReports = result;
    } else if (result.upload_reports && Array.isArray(result.upload_reports)) {
      uploadedReports = result.upload_reports;
    }
    
    const unseenReports = uploadedReports.filter(r => !r.is_seen);
    if (unseenReports.length > 0) {
      for (const unseenReport of unseenReports) {
        try {
          const formData = new FormData();
          formData.append('user_upload_id', unseenReport.user_upload_id);

          await fetch(`${API_URL}/user_uploads/mark_as_seen`, {
            method: 'POST',
            mode: 'cors',
            body: formData
          });
          
          unseenReport.is_seen = true;
        } catch (markError) {
          console.error('Error marking report as seen:', markError);
        }
      }
    }
    
    setSelectedReportForSubmission({
      ...report,
      uploadedReports: uploadedReports,
      mode: 'view'
    });
    setShowReportSubmissionView(true);
    setShowReportSubmission(false);
  } catch (error) {
    console.error('Error fetching uploaded reports:', error);
    alert(`Failed to fetch reports: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};


const handleUploadReportSubmission = (report) => {
  console.log("Upload report clicked:", report);
  setSelectedReportForSubmission({
    ...report,
    mode: 'upload'
  });
  setShowReportSubmissionView(true);
  setShowReportSubmission(false);
};



const handleBackFromReportSubmissionView = () => {
  setShowReportSubmissionView(false);
  setSelectedReportForSubmission(null);
  setShowReportSubmission(true);
};

    const handleExpenseDeleted = async (deletedExpenseId, projectId) => {
      console.log("Expense deleted:", deletedExpenseId);
      
      if (selectedProject && (selectedProject.project_id === projectId || selectedProject.id === projectId)) {
        const updatedExpenses = await fetchProjectExpenses(projectId);
        
        const updatedProject = {
          ...selectedProject,
          expenses: updatedExpenses
        };
        
        setSelectedProject(updatedProject);
        console.log("Project expenses updated after expense deletion");
      }
    };
    const fetchEmployeeLeaves = async () => {
      setIsLoading(true);
      setErrorMessage("");
      
      try {
        const response = await fetch(`${API_URL}/payslips/get_employee_leaves`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(`Employee leaves API error: ${response.status} - ${errorData.message || response.statusText}`);
        }
        
        const result = await response.json();
        console.log('Fetched employee leaves from API:', result);
        
        let leavesData = [];
        
        if (result.status === "success" && result.data) {
          leavesData = Array.isArray(result.data) ? result.data : [result.data];
        } else if (Array.isArray(result)) {
          leavesData = result;
        } else if (result.leaves && Array.isArray(result.leaves)) {
          leavesData = result.leaves;
        }
        
        console.log('Raw employee leaves data:', leavesData);
        setEmployeeLeaves(leavesData);
        
      } catch (error) {
        console.error("Error fetching employee leaves:", error);
        
        if (error.message.includes("Failed to fetch")) {
          setErrorMessage("Network connection failed");
        } else if (error.name === 'TypeError') {
          setErrorMessage("Data processing error");  
        } else if (error.message.includes("JSON")) {
          setErrorMessage("Invalid response format");
        } else {
          setErrorMessage(`Error fetching employee leaves: ${error.message}`);
        }
        
        setEmployeeLeaves([]);
      } finally {
        setIsLoading(false);
      }
    };
    return (
      <>
        <section className="container">
          <aside className="sidebar">
            <div className="logo">
              <img className="img1" src="https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg" alt="Logo" />
            </div>
            <nav className="menu">
  {isMenuItemVisible('EMPLOYEES') && (
    <div className="menu-item-with-dropdown">
      <div className="menu-item" onClick={handleEmployeesClick}>
        <FaUsers className="icon" />
        <p>Employees</p>
        <FaChevronDown className={`dropdown-arrow ${showEmployeesDropdown ? 'rotated' : ''}`} />
      </div>
      {showEmployeesDropdown && (
        <div className="dropdown-menu0010">
          <div className="dropdown-item00100" onClick={handleEmployeesManagementClick}>
            Employees
          </div>
          <div className="dropdown-item00100" onClick={handleLeavesClick}>
            Leaves
          </div>
        </div>
      )}
    </div>
  )}
  {isMenuItemVisible('PROJECTS') && (
    <div className="menu-item-with-dropdown">
      <div className="menu-item" onClick={handleProjectsClick}>
        <FaProjectDiagram className="icon" />
        <p>Projects</p>
        <FaChevronDown className={`dropdown-arrow ${showProjectsDropdown ? 'rotated' : ''}`} />
      </div>
      {showProjectsDropdown && (
        <div className="dropdown-menu0010">
          <div className={`dropdown-item00100 ${selectedProjectStatus === "Ongoing" ? "active" : ""}`} onClick={() => handleProjectStatusClick("Ongoing")}>
            OnGoing
          </div>
          <div className={`dropdown-item00100 ${selectedProjectStatus === "Completed" ? "active" : ""}`} onClick={() => handleProjectStatusClick("Completed")}>
            Completed
          </div>
          <div className={`dropdown-item00100 ${selectedProjectStatus === "Pipelined" ? "active" : ""}`} onClick={() => handleProjectStatusClick("Pipelined")}>
            Pipelined
          </div>
        </div>
      )}
    </div>
  )}
  {isMenuItemVisible('REPORTS') && (
    <div className="menu-item" onClick={handleReportsClick}>
      <FaFileAlt className="icon" />
      <p>Reports</p>
    </div>
  )}
  {isMenuItemVisible('VENDORS') && (
    <div className="menu-item" onClick={handleVendorsClick}>
      <FaStore className="icon" />
      <p>Vendors</p>
    </div>
  )}
  {isMenuItemVisible('CLIENTS') && (
    <div className="menu-item" onClick={handleClientsClick}>
      <FaUserTie className="icon" />
      <p>Clients</p>
    </div>
  )}
  {isMenuItemVisible('TAX_INVOICES') && (
    <div className="menu-item" onClick={handleInvoicesPageClick}>
      <FaFileInvoiceDollar className="icon" />
      <p>Tax Invoices</p>
    </div>
  )}
  {isMenuItemVisible('PERFORMA_INVOICES') && (
    <div className="menu-item" onClick={handlePerformaInvoicesPageClick}>
      <FaFileInvoiceDollar className="icon" />
      <p>Performa Invoices</p>
    </div>
  )}
  {(isMenuItemVisible('REPORT_SUBMISSION') || getUserRole() === 'CLIENT') && (
    <div className="menu-item" onClick={handleReportSubmissionPageClick}>
      <FaClipboardCheck className="icon" />
      <p>Report Submission</p>
    </div>
  )}
</nav>
          </aside>
 <main className="content">
  <header className="header">
    <h2>{getCurrentPageTitle()}</h2>

    <div className="header-actions">
      <div
        className="home-section"
        onClick={() => window.location.href = '/home'}
        title="Go to Home"
      >
        <FaHome className="home-icon" />
      </div>
    
      <div
        className="notification-section"
        onClick={() => setShowNotifications(!showNotifications)}
      >
        <FaBell className="notification-icon" />
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </div>
    </div>

   

{showNotifications && (
  <div className="NAV-00">
    <div className="NAV-01">
      <h3>Notifications</h3>
      <button 
        className="NAV-02"
        onClick={() => setShowNotifications(false)}
      >
        <FaTimes />
      </button>
    </div>

    <div className="NAV-03">
      <button 
        className={`NAV-04 ${filterType === 'all' ? 'active' : ''}`}
        onClick={() => setFilterType('all')}
      >
        All ({notifications.length})
      </button>
      <button 
        className={`NAV-04 ${filterType === 'leave' ? 'active' : ''}`}
        onClick={() => setFilterType('leave')}
      >
        Leaves
      </button>
      <button 
        className={`NAV-04 ${filterType === 'project' ? 'active' : ''}`}
        onClick={() => setFilterType('project')}
      >
        Projects
      </button>
      <button 
        className={`NAV-04 ${filterType === 'employee' ? 'active' : ''}`}
        onClick={() => setFilterType('employee')}
      >
        Updates
      </button>
    </div>

    {notifications.length > 0 && (
      <div className="NAV-05">
        {unreadCount > 0 && (
          <button 
            className="NAV-06"
            onClick={handleMarkAllRead}
          >
            Mark all as read
          </button>
        )}
        <button 
          className="NAV-06 danger"
          onClick={handleClearAll}
        >
          Clear all
        </button>
      </div>
    )}

    <div className="NAV-07">
      {filteredNotifications.length === 0 ? (
        <div className="NAV-08">
          <FaBell className="NAV-09" />
          <p>No notifications yet</p>
          <span>You'll see updates here</span>
        </div>
      ) : (
        filteredNotifications.map((notification) => (
          <div 
            key={notification.id} 
            className={`NAV-10 ${notification.read ? 'read' : 'unread'}`}
            onClick={() => handleNotificationClick(notification.id)}
          >
            <div className="NAV-11">
              {getNotificationIcon(notification.type)}
            </div>
            
            <div className="NAV-12">
              <p className="NAV-13">{notification.message}</p>
              
              {notification.details && Object.keys(notification.details).length > 0 && (
                <div className="NAV-14">
                  {notification.details.approver && (
                    <span className="NAV-15">By: {notification.details.approver}</span>
                  )}
                  {notification.details.updatedBy && (
                    <span className="NAV-15">By: {notification.details.updatedBy}</span>
                  )}
                  {notification.details.employeeName && (
                    <span className="NAV-15">Employee: {notification.details.employeeName}</span>
                  )}
                  {notification.details.project && (
                    <span className="NAV-15">Project: {notification.details.project}</span>
                  )}
                  {notification.details.amount && (
                    <span className="NAV-15">Amount: ₹{notification.details.amount}</span>
                  )}
                  {notification.details.reason && (
                    <span className="NAV-15">Reason: {notification.details.reason}</span>
                  )}
                  {notification.details.changes && (
                    <span className="NAV-15">Changed: {notification.details.changes}</span>
                  )}
                </div>
              )}
              
              <span className="NAV-16">{getTimeAgo(notification.timestamp)}</span>
            </div>

            <button 
              className="NAV-17"
              onClick={(e) => handleDeleteNotification(notification.id, e)}
            >
              <FaTimes />
            </button>
          </div>
        ))
      )}
    </div>
  </div>
)}

    {/* Profile Section */}
    <div
      className="profile-section"
      onClick={() => setShowProfileMenu(!showProfileMenu)}
    >
      {profileImage ? (
        <img src={profileImage} alt="Profile" className="profile-image" />
      ) : 
      (
        <FaUser className="profile-icon" />
      )}
      {userName}
      {showProfileMenu && (
        <div className="profile-menu">
          <p onClick={handleViewProfile}>View Profile</p>
          <p onClick={handleLogout}>Logout</p>
        </div>
      )}
    </div>
  </header>

  <hr className="divider" />
  
  {uploadSuccess && (
    <div className="success-alert">
      ✓ File uploaded successfully! Report has been added to the list.
    </div>
  )}
  
  {isLoading && <div className="loading-message">Loading...</div>}
  {errorMessage && <div className="error-message">{errorMessage}</div>}

  
  {showReportSubmissionView && selectedReportForSubmission ? (
    <ReportSubmission
      project={selectedReportForSubmission}
      onBack={handleBackFromReportSubmissionView}
      projectId={
        selectedReportForSubmission.project_id ||
        selectedReportForSubmission.id
      }
    />
  ) : showReportSubmission ? (
    <ReportSubmissionDisplay
      reports={projects}
      searchQuery={reportSubmissionSearchQuery}
      onSearchChange={setReportSubmissionSearchQuery}
      onViewReport={handleViewReportSubmission}
      onUploadReport={() => {}}
      getUserRole={getUserRole}
    />
  ) : showUserProfile ? (
    <UserProfile />
  ) : showGetReports && selectedProjectForReports ? (
    <Get 
      onCancel={handleBackFromGetReports} 
      project={selectedProjectForReports}
    />
  ) : showReportsList && selectedProjectForReports ? (
    <CreateReport
      project={selectedProjectForReports}
      goBack={handleBackFromReportsList}
      reports={projectReports}
    />
  ) : showTaxInvoice ? (
    <TaxInvoice 
      onBack={handleBackFromTaxInvoice}
      refreshInvoiceNumber={refreshInvoiceNumber}
    />
  ) : showProformaInvoice ? (
    <Performa onBack={handleBackFromProformaInvoice} />
  ) : showAddVendor ? (
    <AddVendor
      onBack={handleBackFromAddVendor}
      onSubmit={handleVendorSubmit}
    />
  ) : showUpdateTaxInvoice ? (
    <UpdateTaxinvoice
      invoiceData={selectedInvoice}
      invoiceId={selectedInvoice?.invoice_id || selectedInvoice?.id}
      onBack={handleBackFromUpdateTaxInvoice}
      onInvoiceUpdated={(updatedInvoice) => {
        const transformedInvoice = transformInvoiceData(updatedInvoice);
        setInvoices((prevInvoices) =>
          prevInvoices.map((inv) =>
            inv.id === transformedInvoice.id ||
            inv.invoice_id === transformedInvoice.invoice_id
              ? transformedInvoice
              : inv
          )
        );
        handleBackFromUpdateTaxInvoice();
      }}
    />
  ) : showUpdatePerformaInvoice && selectedPerformaInvoice?.invoice_type === 'Performa Invoice' ? (
    <PerformaUpdate
      invoiceData={selectedPerformaInvoice}
      invoiceId={selectedPerformaInvoice?.invoice_id || selectedPerformaInvoice?.id}
      onBack={handleBackFromUpdatePerformaInvoice}
      onInvoiceUpdated={(updatedInvoice) => {
        const transformedInvoice = transformInvoiceData(updatedInvoice);
        setPerformaInvoices((prevInvoices) =>
          prevInvoices.map((inv) =>
            inv.id === transformedInvoice.id ||
            inv.invoice_id === transformedInvoice.invoice_id
              ? transformedInvoice
              : inv
          )
        );
        handleBackFromUpdatePerformaInvoice();
      }}
    />
  ) : showViewInvoice ? (
    <ViewTaxInvoice 
      invoiceData={viewInvoiceData} 
      onBack={handleBackFromViewInvoice} 
    />
  ) : showInvoices ? (
    <InvoicesDisplay
      invoices={invoices}
      searchQuery={invoiceSearchQuery}
      onSearchChange={setInvoiceSearchQuery}
      onTaxInvoiceClick={handleTaxInvoiceClick}
      onProformaInvoiceClick={handleProformaInvoiceClick}
      onEditInvoice={handleEditInvoice}
      onViewInvoice={handleViewInvoice}  
    />
  ) : showPerformaInvoices ? (
    <PerformaInvoicesDisplay
      invoices={performaInvoices}
      searchQuery={performaInvoiceSearchQuery}
      onSearchChange={setPerformaInvoiceSearchQuery}
      onAddPerformaInvoice={handleAddPerformaInvoice}
      onEditInvoice={handleEditPerformaInvoice}
      onViewInvoice={handleViewInvoice}
    />
  ) : showPerformaInvoiceForm ? (
    <Performa onBack={handleBackFromPerformaInvoiceForm} />
  ) : showViewVendor ? (
    <ViewVendor 
      vendorData={selectedVendor} 
      onBack={handleBackFromViewVendor} 
    />
  ) : showEditVendor ? (
    <EditVendor
      onBack={handleBackFromEditVendor}
      onVendorUpdated={handleVendorUpdated}
      vendorData={selectedVendor}
    />
  ) : showVendors ? (
    <VendorsDisplay
      vendors={vendors}
      searchQuery={vendorSearchQuery}
      onSearchChange={setVendorSearchQuery}
      onAddVendor={handleAddVendor}
      onViewVendor={handleViewVendor}
      onEditVendor={handleEditVendor}
      onDeleteVendor={handleDeleteVendor}
      selectedVendorStatus={selectedVendorStatus}
      onStatusChange={handleVendorStatusChange}
    />
  ) : showViewClient ? (
    <ViewClient 
      clientData={selectedClient} 
      onBack={handleBackFromViewClient} 
    />
  ) : showAddClient ? (
    <Client onBack={handleBackFromAddClient} onSubmit={handleClientSubmit} />
  ) : showEditClient ? (
    <EditClient
      onBack={handleBackFromEditClient}
      onClientUpdated={handleClientUpdated}
      clientData={selectedClient}
    />
  ) : showClients ? (
    <ClientsDisplay
      clients={clients}
      searchQuery={clientSearchQuery}
      onSearchChange={setClientSearchQuery}
      onAddClient={handleAddClient}
      onViewClient={handleViewClient}
      onEditClient={handleEditClient}
      onDeleteClient={handleDeleteClient}
      selectedClientStatus={selectedClientStatus}
      onStatusChange={handleClientStatusChange}
    />
  ) : showLeaves ? (
    <ManageLeaves
      onBack={handleBackFromLeaves}
      employeeLeaves={employeeLeaves}
      isLoading={isLoading}
      errorMessage={errorMessage}
      onRefresh={fetchEmployeeLeaves}
    />
  ) : showExpenses && !selectedProject ? (
    <ExpenseList project={null} goBack={() => setShowReports(true)} />
  ) : showExpenses && selectedProject ? (
    <ExpenseList
      project={selectedProject}
      goBack={handleBackFromExpenses}
      onExpenseAdded={handleExpenseAdded}
      onExpenseUpdated={handleExpenseUpdated}
      onExpenseDeleted={handleExpenseDeleted}
    />
  ) : showManageLeaves ? (
    <AddEmployees
      goBack={handleBackFromManageLeaves}
      employees={getFilteredEmployees()}
      setEmployees={setEmployees}
      isLoading={isLoading}
      errorMessage={errorMessage}
      onProfileImageUpdate={handleProfileImageUpdate}
      onEmployeeAdded={handleEmployeeAdded}
      onEmployeeUpdated={handleEmployeeUpdated}
      onCurrentEmployeeUpdate={handleCurrentEmployeeUpdate}
      isCEO={isCEO()}
      canEditEmployee={canEditEmployee}
      selectedEmployeeStatus={selectedEmployeeStatus}
      onStatusChange={handleEmployeeStatusChange}
      onDeleteEmployee={handleDeleteEmployee}
    />
  ) : showAddProject ? (
    <AddProject
      goBack={handleBackFromAddProject}
      onBack={handleBackFromAddProject}
      onSubmit={handleProjectSubmit}
    />
  ) : showProjectUpdate ? (
    <ProjectUpdate
      project={projectToUpdate}
      onBack={handleBackFromProjectUpdate}
      onSubmit={handleProjectUpdateSubmit}
    />
  ) : showProjects ? (
    <ProjectNavbar
      projects={getFilteredProjects()}
      onDeleteProject={handleDeleteProject}
      onAddProject={handleAddProject}
      onProjectClick={handleProjectClick}
      onUpdateProject={handleUpdateProject}
      onManageEmployees={handleManageEmployees}
      selectedStatus={selectedProjectStatus}
      isLoading={isLoading}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      isCEO={isCEOUser()}
    />
  ) : showEmployeeProject && selectedProjectForEmployees ? (
    <AddEmployeeProject 
      project={selectedProjectForEmployees}
      onClose={handleBackFromEmployeeProject}
      onEmployeeAdded={async (newEmployee) => {
        // Handle employee addition
      }}
    />
  ) : showReports ? (
    <>
      <div className="search-add-section">
        <div className="search-container">
          <div className="icon-wrapper">
            <FaSearch />
          </div>
          <div className="Search-bar">
            <input
              type="text"
              placeholder="        Search Report Details"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileUpload}
        className="hidden-file-input"
        accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.xls,.xlsx"
        multiple={false}
      />

      <section className="data-container">
        <div className="header-row1">
          <div className="column1">
            <span>Project Name</span>
          </div>
          <div className="column1">
            <span>No of Blocks</span>
          </div>
          <div className="column1">
            <span>Status</span>
          </div>
          <div className="column1">
            <span>Location</span>
          </div>
          <div className="column1">
            <span>Actions</span>
          </div>
        </div>
        <hr className="divider" />

        {filteredReports.length === 0 ? (
          <div className="no-data-message">
            {selectedProjectStatus
              ? `No ${selectedProjectStatus.toLowerCase()} reports found`
              : searchQuery
              ? `No reports match "${searchQuery}"`
              : "No reports found"}
          </div>
        ) : (
          <>
            <div className="data-count-info">
              Showing {filteredReports.length} of {reports.length} reports
            </div>
            {filteredReports.map((report) => (
              <div key={report.id} className="data-row">
                <div className="column1">
                  <span>{report.name}</span>
                </div>
                <div className="column1">
                  <span>{report.blocks || report.no_of_blocks}</span>
                </div>
                <div className="column1">
                  <span
                    className={`status-${report.status
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {report.status}
                  </span>
                </div>
                <div className="column1">
                  <span>{report.location}</span>
                </div>
                <div className="column1 actions">
                  <FaEye
                    className="action-icon view-icon"
                    title="View Project Reports"
                    onClick={() => handleViewProjectReports(report)}
                  />
                  <FaPlus
                    className="action-icon edit-icon"
                    title="Add Report"
                    onClick={() => {
                      const projectData = {
                        name: report.project_name || report.name,
                        project_id: report.id || report.project_id,  
                        id: report.id || report.project_id,
                        location: report.location,
                        client: report.client,
                        vendor: report.vendor,
                        numberOfBlocks: report.no_of_blocks || report.blocks,
                        customer: report.customer || "Customer Name",
                      };
                      setShowPopup(true);
                      setSelectedProjectData(projectData);
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        )}
      </section>
    </>
  ) : null}
</main>
        </section>
        {showPopup && <CreateReport goBack={() => setShowPopup(false)} project={selectedProjectData} />}
        {showProjectModal && <Get onClose={() => setShowProjectModal(false)} />}
      </>
    );
  };

  export default Navbar; 




















